/* eslint-disable max-lines */
export class ReferenceDataLabels {
  public static readonly ACDelegationLevel = 'ACDelegationLevel';
  public static readonly ACDescriptionText = 'ACDescriptionText';
  public static readonly ACHeader = 'ACHeader';
  public static readonly ACLoadAccessControllerTable = 'ACLoadAccessControllerTable';
  public static readonly ACMobileNotSupported = 'ACMobileNotSupported';
  public static readonly ACResetTable = 'ACResetTable';
  public static readonly ACReturnDefaultView = 'ACReturnDefaultView';
  public static readonly ACSave = 'ACSave';
  public static readonly ACSearchButton = 'ACSearchButton';
  public static readonly ACSearchPlaceholderBw = 'ACSearchPlaceholderBw';
  public static readonly ACSearchPlaceholderCa = 'ACSearchPlaceholderCa';
  public static readonly ACTableDescription = 'ACTableDescription';
  public static readonly AIP = 'AIP';
  public static readonly AboutMainApplicantId = 'AboutMainApplicant';
  public static readonly AboutProperty = 'AboutProperty';
  public static readonly AboutTheActingSolicitor = 'AboutTheActingSolicitor';
  public static readonly AboutTheFeesDetails = 'AboutTheFeesDetails';
  public static readonly AboutTheFeesId = 'AboutTheFees';
  public static readonly AboutTheMortgageDetails = 'AboutTheMortgageDetails';
  public static readonly AboutTheMortgageId = 'AboutTheMortgage';
  public static readonly AboutTheOutgoingsDetails = 'AboutTheOutgoingsDetails';
  public static readonly AboutToExpireModalContentLine1 = 'AboutToExpireModalContentLine1';
  public static readonly AboutToExpireModalContentLine2 = 'AboutToExpireModalContentLine2';
  public static readonly AboutToExpireModalContinue = 'AboutToExpireModalContinue';
  public static readonly AboutToExpireModalTitle = 'AboutToExpireModalTitle';
  public static readonly AboutYouId = 'AboutYou';
  public static readonly AboutYourOutgoings = 'AboutYourOutgoings';
  public static readonly Accept = 'Accept';
  public static readonly AcceptAndContinue = 'AcceptAndContinue';
  public static readonly AcceptAndProceed = 'AcceptAndProceed';
  public static readonly AcceptAndProgressTo = 'AcceptAndProgressTo';
  public static readonly AcceptAndProgressToAip = 'AcceptAndProgressToAip';
  public static readonly AcceptAndSubmit = 'AcceptAndSubmit';
  public static readonly AcceptDirectDebit = 'AcceptDirectDebit';
  public static readonly AcceptedDDMLozenge = 'AcceptedDDMLozenge';
  public static readonly AcceptOfferDeclaration = 'AcceptOfferDeclaration';
  public static readonly AcceptOnlineOfferWindowAlternativeContent = 'AcceptOnlineOfferWindowAlternativeContent';
  public static readonly AcceptOnlineOfferWindowAlternativeContentBtl = 'AcceptOnlineOfferWindowAlternativeContentBtl';
  public static readonly AcceptOnlineOfferWindowAlternativeContentExistingBusiness =
    'AcceptOnlineOfferWindowAlternativeContentExistingBusiness';
  public static readonly AcceptOnlineOfferWindowAlternativeContentExistingBusinessBtl =
    'AcceptOnlineOfferWindowAlternativeContentExistingBusiness';
  public static readonly AcceptOnlineOfferWindowContent = 'AcceptOnlineOfferWindowContent';
  public static readonly AcceptOnlineOfferWindowContentBtl = 'AcceptOnlineOfferWindowContentBtl';
  public static readonly AcceptOnlineOfferWindowContentExistingBusiness =
    'AcceptOnlineOfferWindowContentExistingBusiness';
  public static readonly AcceptOnlineOfferWindowContentExistingBusinessBtl =
    'AcceptOnlineOfferWindowContentExistingBusiness';
  public static readonly AcceptOnlineOfferWindowContinueButton = 'AcceptOnlineOfferWindowContinueButton';
  public static readonly AcceptOnlineOfferWindowTitle = 'AcceptOnlineOfferWindowTitle';
  public static readonly AcceptedOfferLozenge = 'AcceptedOfferLozenge';
  public static readonly AcceptedOn = 'AcceptedOn';
  public static readonly AcceptedPrivacyNoticeStatus = 'AcceptedPrivacyNoticeStatus';
  public static readonly AccessCodeMethod = 'AccessCodeMethod';
  public static readonly AccessControllerAllRoles = 'AccessControllerAllRoles';
  public static readonly AccessControllerBW = 'AccessControllerBW';
  public static readonly AccessControllerCA = 'AccessControllerCA';
  public static readonly AccessControllerBusinessWritersNotFound = 'AccessControllerBusinessWritersNotFound';
  public static readonly AccessControllerCaseAdministratorsNotFound = 'AccessControllerCaseAdministratorsNotFound';
  public static readonly AccessControllerDisplayCaseAdmins = 'AccessControllerDisplayCaseAdmins';
  public static readonly Accessibility = 'Accessibility';
  public static readonly Account = 'Account';
  public static readonly AccountAuthentication = 'AccountAuthentication';
  public static readonly AccountAuthenticationTitle = 'AccountAuthenticationTitle';
  public static readonly AccountCustomers = 'AccountCustomers';
  public static readonly AccountFiles = 'AccountFiles';
  public static readonly AccountHolderName = 'AccountHolderName';
  public static readonly AccountHub = 'AccountHub';
  public static readonly AccountHubActivity = 'AccountHubActivity';
  public static readonly AccountHubSearchNoResultInformation = 'AccountHubSearchNoResultInformation';
  public static readonly AccountHubSearchNoResultTitle = 'AccountHubSearchNoResultTitle';
  public static readonly AccountIsSwitchableLozenge = 'AccountIsSwitchableLozenge';
  public static readonly AccountLocked = 'AccountLocked';
  public static readonly AccountManagement = 'AccountManagement';
  public static readonly AccountManagementMiniFormRequest = 'AccountManagementMiniFormRequest';
  public static readonly AccountManagementQA = 'AccountManagementQA';
  public static readonly AccountMessagingDescription = 'AccountMessagingDescription';
  public static readonly AccountMessagingGeneralAccount = 'AccountMessagingGeneralAccount';
  public static readonly AccountNotesRequiringAction = 'AccountNotesRequiringAction';
  public static readonly AccountNumber = 'AccountNumber';
  public static readonly AccountNumberShort = 'AccountNumberShort';
  public static readonly AccountOverviewMenuActions = 'AccountOverviewMenuActions';
  public static readonly AccountOverviewMenuCustomers = 'AccountOverviewMenuCustomers';
  public static readonly AccountOverviewMenuDistributedDocuments = 'AccountOverviewMenuDistributedDocuments';
  public static readonly AccountOverviewMenuMessages = 'AccountOverviewMenuMessages';
  public static readonly AccountOverviewMenuSummary = 'AccountOverviewMenuSummary';
  public static readonly AccountOverviewMenuTransactions = 'AccountOverviewMenuTransactions';
  public static readonly AccountOwner = 'AccountOwner';
  public static readonly AccountParticulars = 'AccountParticulars';
  public static readonly AccountProfileContactUsText = 'AccountProfileContactUsText';
  public static readonly AccountStatus = 'AccountStatus';
  public static readonly AccountStatusFilterSection = 'AccountStatusFilterSection';
  public static readonly AccountSummaryTitle = 'AccountSummaryTitle';
  public static readonly AccountSummaryTransactionSection = 'AccountSummaryTransactionSection';
  public static readonly AccountTypeDescription = 'AccountTypeDescription';
  public static readonly AccountantAddress = 'AccountantAddress';
  public static readonly AccountantIsOtherDetails = 'AccountantIsOtherDetails';
  public static readonly AccountantTypes = 'AccountantTypes';
  public static readonly AccountantsFaxNumber = 'AccountantsFaxNumber';
  public static readonly AccountantsName = 'AccountantsName';
  public static readonly AccountantsPhoneNumber = 'AccountantsPhoneNumber';
  public static readonly ActivitySection = 'ActivitySection';
  public static readonly Add = 'Add';
  public static readonly AddAdviceNote = 'AddAdviceNote';
  public static readonly AddAnotherApplicant = 'AddAnotherApplicant';
  public static readonly AddApplicantKFI = 'AddApplicantKFI';
  public static readonly AddBranchDetails = 'AddBranchDetails';
  public static readonly AddCaseAdministrator = 'AddCaseAdministrator';
  public static readonly AddDetailsBtn = 'AddDetailsBtn';
  public static readonly AddMortgageClub = 'AddMortgageClub';
  public static readonly AddCaseTaskNote = 'AddCaseTaskNote';
  public static readonly AddNewDepositSourceTypeCode = 'AddNewDepositSourceTypeCode';
  public static readonly AddNewDepositSourceTypeCodeForRemortgage = 'AddNewDepositSourceTypeCodeForRemortgage';
  public static readonly AddNewIncomeFromOutsideUK = 'AddNewIncomeFromOutsideUK';
  public static readonly AddNewMortgageClub = 'AddNewMortgageClub';
  public static readonly AddNewOutgoing = 'AddNewOutgoing';
  public static readonly AddNewPrivatePensionSource = 'AddNewPrivatePensionSource';
  public static readonly AddNotes = 'AddNotes';
  public static readonly AddOfferSequenceNumber = 'AddOfferSequenceNumber';
  public static readonly AddPlaceholder = 'AddPlaceholder';
  public static readonly AddPlaceholderTitle = 'AddPlaceholderTitle';
  public static readonly AddTask = 'AddTask';
  public static readonly AddTaskTitle = 'AddTaskTitle';
  public static readonly AddToLoanAmountId = 'AddToLoanAmount';
  public static readonly AddUserTitle = 'AddUserTitle';
  public static readonly AddWindowSubtitle = 'AddWindowSubtitle';
  public static readonly AddWindowTitle = 'AddWindowTitle';
  public static readonly AddedRoles = 'AddedRoles';
  public static readonly AddedToLoan = 'AddedToLoan';
  public static readonly AdditionalArrangedPayment = 'AdditionalArrangedPayment';
  public static readonly AdditionalBorrowing = 'AdditionalBorrowing';
  public static readonly AdditionalBorrowingFor = 'AdditionalBorrowingFor';
  public static readonly AdditionalInformation = 'AdditionalInformation';
  public static readonly AdditionalInformationDescription = 'AdditionalInformationDescription';
  public static readonly AdditionalInformationTitle = 'AdditionalInformationTitle';
  public static readonly AddressLine1 = 'AddressLine1';
  public static readonly AddressLine1Mandatory = 'AddressLine1Mandatory';
  public static readonly AddressLine2 = 'AddressLine2';
  public static readonly AddressLine3 = 'AddressLine3';
  public static readonly AddressOfEmployerId = 'AddressOfEmployer';
  public static readonly AddressOfSolicitorFirm = 'AddressOfSolicitorFirm';
  public static readonly AddressOfYourBusiness = 'AddressOfYourBusiness';
  public static readonly AddressSearchFailMessage = 'AddressSearchFailMessage';
  public static readonly AddressWithInfoForBusinessWriters = 'AddressWithInfoForBusinessWriters';
  public static readonly AddSolicitorToPanel = 'AddSolicitorToPanel';
  public static readonly Admin = 'Admin';
  public static readonly AdminNotesAddInternalNote = 'AdminNotesAddInternalNote';
  public static readonly AdminNotesAddNoteTitle = 'AdminNotesAddNoteTitle';
  public static readonly AdminNotesNote = 'AdminNotesNote';
  public static readonly AdminNotesNoteTitle = 'AdminNotesNoteTitle';
  public static readonly AdminNotesSAMNoteDownloaded = 'AdminNotesSAMNoteDownloaded';
  public static readonly AdminNotesSAMNoteNotDownloaded = 'AdminNotesSAMNoteNotDownloaded';
  public static readonly AdminNotesSAMNoteWillDownload = 'AdminNotesSAMNoteWillDownload';
  public static readonly Administration = 'Administration';
  public static readonly AdvancedSearch = 'AdvancedSearch';
  public static readonly AdvancedSearchHide = 'AdvancedSearchHide';
  public static readonly AdviceNotProceedingWindowContent = 'AdviceNotProceedingWindowContent';
  public static readonly AdviceNotProceedingWindowReason = 'AdviceNotProceedingWindowReason';
  public static readonly AdviceNotProceedingWindowTitle = 'AdviceNotProceedingWindowTitle';
  public static readonly AdviceStatus = 'AdviceStatus';
  public static readonly AdviceStatusSection = 'AdviceStatusSection';
  public static readonly AdviceTabAdviceActivity = 'AdviceTabAdviceActivity';
  public static readonly AdviceTabAdviceDecisions = 'AdviceTabAdviceDecisions';
  public static readonly AdviceTabAdviceOwner = 'AdviceTabAdviceOwner';
  public static readonly AdviceTabAdviceStatus = 'AdviceTabAdviceStatus';
  public static readonly AdviceTabAffordability = 'AdviceTabAffordability';
  public static readonly AdviceTabCompleteFF1 = 'AdviceTabCompleteFF1';
  public static readonly AdviceTabLockCaseToAdvisor = 'AdviceTabLockCaseToAdvisor';
  public static readonly AdviceTabManageAdviceOwner = 'AdviceTabManageAdviceOwner';
  public static readonly AdviceTabSoftCreditCheck = 'AdviceTabSoftCreditCheck';
  public static readonly AdviceTabUnlockCase = 'AdviceTabUnlockCase';
  public static readonly AdvisedBuyToLetDescription = 'AdvisedBuyToLetDescription';
  public static readonly AdvisedEligibilityTitle = 'AdvisedEligibilityTitle';
  public static readonly AdvisedFailContent = 'AdvisedFailContent';
  public static readonly AdvisedFailTitle = 'AdvisedFailTitle';
  public static readonly AdvisedNichaFailContent = 'AdvisedNichaFailContent';
  public static readonly AdvisedNichaFailTitle = 'AdvisedNichaFailTitle';
  public static readonly AdvisedProcessOverviewContent = 'AdvisedProcessOverviewContent';
  public static readonly AdvisedProcessOverviewTitle = 'AdvisedProcessOverviewTitle';
  public static readonly AdvisedResidentialCaseId = 'AdvisedResidentialCase';
  public static readonly AdvisedResidentialCompleteApplication = 'AdvisedResidentialCompleteApplication';
  public static readonly AdvisedResidentialDescription = 'AdvisedResidentialDescription';
  public static readonly AdvisedResidentialFactFind = 'AdvisedResidentialFactFind';
  public static readonly AdvisedResidentialMortgageOffer = 'AdvisedResidentialMortgageOffer';
  public static readonly AdvisedResidentialRecommendation = 'AdvisedResidentialRecommendation';
  public static readonly AdvisedResidentialSupportingDocumentation = 'AdvisedResidentialSupportingDocumentation';
  public static readonly Affordability = 'Affordability';
  public static readonly AffordabilityCalculatorTitle = 'AffordabilityCalculatorTitle';
  public static readonly AffordabilityCheckButton = 'AffordabilityCheckButtonLabel';
  public static readonly AffordabilityResult = 'AffordabilityResult';
  public static readonly AffordabilityResultsApplicant1 = 'AffordabilityResultsApplicant1';
  public static readonly AffordabilityResultsApplicant2 = 'AffordabilityResultsApplicant2';
  public static readonly AffordabilityResultsGrossAnnualIncome = 'AffordabilityResultsGrossAnnualIncome';
  public static readonly AffordabilityResultsIncomeSurplus = 'AffordabilityResultsIncomeSurplus';
  public static readonly AffordabilityResultsInputs = 'AffordabilityResultsInputs';
  public static readonly AffordabilityResultsInterestOnlyLoanAmount = 'AffordabilityResultsInterestOnlyLoanAmount';
  public static readonly AffordabilityResultsMajorMinorException = 'AffordabilityResultsMajorMinorException';
  public static readonly AffordabilityResultsMaxBorrowingAffordability =
    'AffordabilityResultsMaxBorrowingAffordability';
  public static readonly AffordabilityResultsMaxBorrowingIncomeMultiple =
    'AffordabilityResultsMaxBorrowingIncomeMultiple';
  public static readonly AffordabilityResultsMonthlyCommittedOutgoings =
    'AffordabilityResultsMonthlyCommittedOutgoings';
  public static readonly AffordabilityResultsMonthlyMortgagePaymentInterest =
    'AffordabilityResultsMonthlyMortgagePaymentInterest';
  public static readonly AffordabilityResultsMonthlyMortgagePaymentRepayment =
    'AffordabilityResultsMonthlyMortgagePaymentRepayment';
  public static readonly AffordabilityResultsMonthlyOtherOutgoings = 'AffordabilityResultsMonthlyOtherOutgoings';
  public static readonly AffordabilityResultsMortgageTerm = 'AffordabilityResultsMortgageTerm';
  public static readonly AffordabilityResultsNumberOfAdults = 'AffordabilityResultsNumberOfAdults';
  public static readonly AffordabilityResultsNumberOfApplicants = 'AffordabilityResultsNumberOfApplicants';
  public static readonly AffordabilityResultsNumberOfChildrenUnder18 = 'AffordabilityResultsNumberOfChildrenUnder18';
  public static readonly AffordabilityResultsOtherIncome = 'AffordabilityResultsOtherIncome';
  public static readonly AffordabilityResultsPercentageOfNetIncomeAccountedForByMortgage =
    'AffordabilityResultsPercentageOfNetIncomeAccountedForByMortgage';
  public static readonly AffordabilityResultsPercentageOfShortfallException =
    'AffordabilityResultsPercentageOfShortfallException';
  public static readonly AffordabilityResultsRepaymentLoanAmount = 'AffordabilityResultsRepaymentLoanAmount';
  public static readonly AffordabilityResultsResults = 'AffordabilityResultsResults';
  public static readonly AffordabilityWarningParagraph1 = 'AffordabilityWarningParagraph1';
  public static readonly AffordabilityWarningParagraph2 = 'AffordabilityWarningParagraph2';
  public static readonly AffordabilityWarningParagraph3 = 'AffordabilityWarningParagraph3';
  public static readonly AffordabiltyResults = 'AffordabiltyResults';
  public static readonly AffordabiltyResultsNumberOfApplicants = 'AffordabiltyResultsNumberOfApplicants';
  public static readonly AfterDeductionsLabel = 'AfterDeductionsLabel';
  public static readonly AfterDeductionsTooltip = 'AfterDeductionsTooltip';
  public static readonly AgeAtMortgageTerm = 'AgeAtMortgageTerm';
  public static readonly AgeOfFinancialDependant = 'AgeOfFinancialDependant';
  public static readonly AgeOfSponsorFinancialDependant = 'AgeOfSponsorFinancialDependant';
  public static readonly AgentAccountActivationExpired = 'AgentAccountActivationExpired';
  public static readonly AgentAccountStatus = 'AgentAccountStatus';
  public static readonly AgentAuditName = 'AgentAuditName';
  public static readonly AgentAvailableRoles = 'AgentAvailableRoles';
  public static readonly AgentEmailAlreadyRegistered = 'AgentEmailAlreadyRegistered';
  public static readonly AgentEmailAlreadyUsed = 'AgentEmailAlreadyUsed';
  public static readonly AgentEmailUpdateConfirmationResendFailed = 'AgentEmailUpdateConfirmationResendFailed';
  public static readonly AgentFirstName = 'AdvisorFirstName';
  public static readonly AgentInvalidLogin = 'AgentInvalidLogin';
  public static readonly AgentInvalidLoginInternal = 'AgentInvalidLoginInternal';
  public static readonly AgentLockedOut = 'AgentLockedOut';
  public static readonly AgentProfileContactUsText = 'AgentProfileContactUsText';
  public static readonly AgentProfileLinkedBusinessWriters = 'AgentProfileLinkedBusinessWriters';
  public static readonly AgentProfileLinkedCaseAdmins = 'AgentProfileLinkedCaseAdmins';
  public static readonly AgentPropositionName = 'AgentPropositionName';
  public static readonly AgentRegisteredDate = 'AgentRegisteredDate';
  public static readonly AgentRegistrationEmailRequired = 'AgentRegistrationEmailRequired';
  public static readonly AgentRegistrationIncomplete = 'AgentRegistrationIncomplete';
  public static readonly AgentRegistrationIntroductoryCopy = 'AgentRegistrationIntroductoryCopy';
  public static readonly AgentResetPasswordMismatch = 'AgentResetPasswordMismatch';
  public static readonly AgentUserChangeIncomplete = 'AgentUserChangeIncomplete';
  public static readonly AgentsGridAccountStatusColumn = 'AgentsGridAccountStatusColumn';
  public static readonly AgentsGridAddNew = 'AgentsGridAddNewInCompanyDetails';
  public static readonly AgentsGridAlternativeNameColumn = 'AgentsGridAlternativeNameColumn';
  public static readonly AgentsGridEmailColumn = 'AgentsGridEmailColumn';
  public static readonly AgentsGridInCompanyDetailsNameColumn = 'AgentsGridInCompanyDetailsNameColumn';
  public static readonly AgentsGridLastLoginColumn = 'AgentsGridLastLoginColumn';
  public static readonly AgentsGridNameColumn = 'AgentsGridNameColumn';
  public static readonly AgentsGridPrincipalReferenceColumn = 'AgentsGridPrincipalReferenceColumn';
  public static readonly AgentsGridRoleColumn = 'AgentsGridRoleColumn';
  public static readonly AgentsGridTitle = 'AgentsGridTitleInCompanyDetails';
  public static readonly AgentsGridTradingAsColumn = 'AgentsGridTradingAsColumn';
  public static readonly Agree = 'Agree';
  public static readonly AgreeToNonAdviseContent = 'AgreeToNonAdviseContent';
  public static readonly AgreeToNonAdvisedTitle = 'AgreeToNonAdvisedTitle';
  public static readonly AllPreviousEmployersWithin12MonthsDetails = 'AllPreviousEmployersWithin12MonthsDetails';
  public static readonly AllocateAccount = 'AllocateAccount';
  public static readonly AllocateAccountTitle = 'AllocateAccountTitle';
  public static readonly AllocateAdviceOwnerHeader = 'AllocateAdviceOwnerHeader';
  public static readonly AllocateAdviceOwnerSave = 'AllocateAdviceOwnerSave';
  public static readonly AllocateAdviceOwnerTitle = 'AllocateAdviceOwnerTitle';
  public static readonly AllocateCase = 'AllocateCase';
  public static readonly AllocateCaseHeader = 'AllocateCaseHeader';
  public static readonly AllocateCaseOptionMe = 'AllocateCaseOptionMe';
  public static readonly AllocateCaseTitle = 'AllocateCaseTitle';
  public static readonly AllocateTask = 'AllocateTask';
  public static readonly AllocateTaskHeader = 'AllocateTaskHeader';
  public static readonly AllocateTaskTitle = 'AllocateTaskTitle';
  public static readonly AllowanceLabel = 'AllowanceLabel';
  public static readonly AllowCaseAdminFunctionality = 'AllowCaseAdminFunctionality';
  public static readonly AllowProccesExistingBusiness = 'AllowProccesExistingBusiness';
  public static readonly AllowProcessExistingBusiness = 'AllowProccesExistingBusiness';
  public static readonly AmendedPayment = 'AmendedPayment';
  public static readonly AmlAutoCheck = 'AmlAutoCheck';
  public static readonly AmlManualCheck = 'AmlManualCheck';
  public static readonly AMLManualSearch = 'AMLManualSearch';
  public static readonly AmlManualSearchWindowTitle = 'AmlManualSearchWindowTitle';
  public static readonly AmountOwedOnCurrentProperty = 'AmountOwedOnCurrentProperty';
  public static readonly AmountOwedOnRemortgagedProperty = 'AmountOwedOnRemortgagedProperty';
  public static readonly AmountPerMonth = 'AmountPerMonth';
  public static readonly AmountToBeAdvanced = 'AmountToBeAdvanced';
  public static readonly AmountToBorrowId = 'AmountToBorrow';
  public static readonly AmountToBorrowToolTip = 'AmountToBorrowToolTip';
  public static readonly AmountToOverPayForSubaccountLabel = 'AmountToOverPayForSubaccountLabel';
  public static readonly AnOwnerMovingHouseId = 'AnOwnerMovingHouse';
  public static readonly AnnualBasicSalary = 'AnnualBasicSalary';
  public static readonly AnnualBasicSalaryIncludingAnyGId = 'AnnualBasicSalary';
  public static readonly AnnualSalaryToolTip = 'AnnualSalaryToolTip';
  public static readonly AnnualStatePension = 'AnnualStatePension';
  public static readonly Answer = 'Answer';
  public static readonly AnyAdditionalInformation = 'AnyAdditionalInformation';
  public static readonly AnyOtherSurnames = 'AnyOtherSurnames';
  public static readonly AppErrorDueToSamFeesLozenge = 'AppErrorDueToSamFeesLozenge';
  public static readonly AppErrorDueToSamOverviewLozenge = 'AppErrorDueToSamOverviewLozenge';
  public static readonly AppOutgoingType = 'AppOutgoingType';
  public static readonly ApplicantAcceptanceStatus = 'ApplicantAcceptanceStatus';
  public static readonly ApplicantAccountHolder = 'ApplicantAccountHolder';
  public static readonly ApplicantCurrentAddressSectionText = 'ApplicantCurrentAddressSectionText';
  public static readonly ApplicantEmailAddress = 'ApplicantEmailAddress';
  public static readonly ApplicantEmailAddresses = 'ApplicantEmailAddresses';
  public static readonly ApplicantId = 'Applicant';
  public static readonly ApplicantOrderProcessContent = 'ApplicantOrderProcessContent';
  public static readonly ApplicantOrderWarning = 'ApplicantOrderWarning';
  public static readonly ApplicantOrderWarningContent = 'ApplicantOrderWarningContent';
  public static readonly ApplicantOrderWarningTitle = 'ApplicantOrderWarningTitle';
  public static readonly ApplicantPhoneNumbers = 'ApplicantPhoneNumbers';
  public static readonly ApplicantPrimaryContactId = 'ApplicantPrimaryContact';
  public static readonly ApplicantPriority1 = 'ApplicantPriority1';
  public static readonly ApplicantPriority2 = 'ApplicantPriority2';
  public static readonly ApplicantPriority3 = 'ApplicantPriority3';
  public static readonly ApplicantRequiresAtLeastThreeYId = 'MinimumYearsAtPreviousAddresses';
  public static readonly ApplicantSolicitorHeader = 'ApplicantSolicitorHeader';
  public static readonly ApplicantSolicitorHeaderForFamilyLink = 'ApplicantSolicitorHeaderForFamilyLink';
  public static readonly ApplicantSolicitorHeaderForRetirementLink = 'ApplicantSolicitorHeaderForRetirementLink';
  public static readonly ApplicantSolicitorName = 'ApplicantSolicitorName';
  public static readonly ApplicantsDescription = 'ApplicantsDescription';
  public static readonly ApplicantsId = 'ApplicantsTitle';
  public static readonly ApplicantsOnlineDistributionSection = 'ApplicantsOnlineDistributionSection';
  public static readonly ApplicantsOnlineDistributionSectionExistingBusiness =
    'ApplicantsOnlineDistributionSectionExistingBusiness';
  public static readonly ApplicantsPostDistributionSection = 'ApplicantsPostDistributionSection';
  public static readonly ApplicantsPostDistributionSectionExistingBusiness =
    'ApplicantsPostDistributionSectionExistingBusiness';
  public static readonly ApplicantsTitle = 'ApplicantsTitle';
  public static readonly ApplicationCaseStatus = 'ApplicationCaseStatus';
  public static readonly ApplicationFor = 'ApplicationFor';
  public static readonly ApplicationProgressStatus = 'ApplicationProgressStatus';
  public static readonly ApplicationTypes = 'ApplicationTypes';
  public static readonly ApplyFilters = 'ApplyFilters';
  public static readonly ApplyHelpToBuyScheme = 'ApplyHelpToBuyScheme';
  public static readonly ApplyToRegistrationText = 'ApplyToRegistrationText';
  public static readonly ApplyToSwitchText = 'ApplyToSwitchText';
  public static readonly ApproximateOutstandingBalance = 'ApproximateOutstandingBalance';
  public static readonly AproxRedemOutstandingBalance = 'AproxRedemOutstandingBalance';
  public static readonly AreRepaymentAssetsInSterlingCode = 'AreRepaymentAssetsInSterlingCode';
  public static readonly AreYouAFirstTimeBuyerId = 'FirstTimeBuyer';
  public static readonly AreYouAwareOfAnyFutureEvents = 'AreYouAwareOfAnyFutureEvents';
  public static readonly AreYouConvertingPropToBtl = 'AreYouConvertingPropToBtl';
  public static readonly AreYouInReceiptOfPensionCode = 'AreYouInReceiptOfPensionCode';
  public static readonly AreYouPurchasingAtAConcessionaId = 'PurchasingAtConcessionaryPrice';
  public static readonly AreYouSellingYourCurrentResideId = 'SellingCurrentResidentialProperty';
  public static readonly ArrangeCallback = 'ArrangeCallback';
  public static readonly ArrangeCallbackContinueAndSubmit = 'ArrangeCallbackContinueAndSubmit';
  public static readonly ArrangeCallbackSubmit = 'ArrangeCallbackSubmit';
  public static readonly ArrangeCallbackTitle = 'ArrangeCallbackTitle';
  public static readonly ArrangementFeeId = 'ArrangementFee';
  public static readonly ArrangementWithCreditor = 'ArrangementWithCreditor';
  public static readonly ArrangementWithCreditorDetails = 'ArrangementWithCreditorDetails';
  public static readonly ArrearsLabel = 'ArrearsLabel';
  public static readonly ArrearsOrERCInformation = 'ArrearsOrERCInformation';
  public static readonly ArrearsNegative = 'ArrearsNegative';
  public static readonly ArrearsPositive = 'ArrearsPositive';
  public static readonly AsShownOnCard = 'AsShownOnCard';
  public static readonly AssessCase = 'AssessCase';
  public static readonly AssessmentReleased = 'AssessmentReleased';
  public static readonly AutoPackagingData = 'AutoPackagingData';
  public static readonly AvailableOptions = 'AvailableOptions';
  public static readonly AvailablePermissions = 'AvailablePermissions';
  public static readonly AvailableRoles = 'AvailableRoles';
  public static readonly BODirectDeclarationPageContent = 'BODirectDeclarationPageContent';
  public static readonly BODirectDeclarationPageHeader = 'BODirectDeclarationPageHeader';
  public static readonly BODirectDeclarationPageSubHeader = 'BODirectDeclarationPageSubHeader';
  public static readonly BOHardCreditSearchProcessContent = 'BOHardCreditSearchProcessContent';
  public static readonly BOHardCreditWarning = 'BOHardCreditWarning';
  public static readonly BOHardCreditWarningContent = 'BOHardCreditWarningContent';
  public static readonly BORegistrationTermsAndConditionsText = 'BORegistrationTermsAndConditionsText';
  public static readonly BOSoftCreditSearchProcessContent = 'BOSoftCreditSearchProcessContent';
  public static readonly BOSoftCreditWarning = 'BOSoftCreditWarning';
  public static readonly BOSoftCreditWarningContent = 'BOSoftCreditWarningContent';
  public static readonly BackButtonText = 'BackButtonText';
  public static readonly BackOffice = 'BackOffice';
  public static readonly BackOfficeAdviceOwnerRegionTitle = 'BackOfficeAdviceOwnerRegionTitle';
  public static readonly BackOfficeCaseOwnerRegionTitle = 'BOCaseOwnerRegionTitle';
  public static readonly BackOfficeDateCreated = 'BODateCreated';
  public static readonly BackOfficeDateSubmitted = 'BODateSubmitted';
  public static readonly BackOfficeLTVRegionTitle = 'BOLTVRegionTitle';
  public static readonly BackOfficeLoanAmountRegionTitle = 'BOLoanAmountRegionTitle';
  public static readonly BackOfficeLoanGroupsRegionTitle = 'BOLoanGroupsRegionTitle';
  public static readonly BackOfficeLoanTypesRegionTitle = 'BOLoanTypesRegionTitle';
  public static readonly BackOfficeMaxLTV = 'BOMaxLTV';
  public static readonly BackOfficeMaxLoanAmount = 'BOMaxLoanAmount';
  public static readonly BackOfficeMinLTV = 'BOMinLTV';
  public static readonly BackOfficeMinLoanAmount = 'BOMinLoanAmount';
  public static readonly BackOfficeOptExcludeInterestOnly = 'BOOptExcludeInterestOnly';
  public static readonly BackOfficeOptExcludeSelfEmployed = 'BOOptExcludeSelfEmployed';
  public static readonly BackOfficeOptShowOnlyDocumentAlerted = 'BOOptShowOnlyDocumentAlerted';
  public static readonly BackOfficePropositionRegionTitle = 'BOPropositionRegionTitle';
  public static readonly BackOfficeResultsAdviceOwner = 'BackOfficeResultsAdviceOwner';
  public static readonly BackOfficeResultsAmount = 'BOResultsAmount';
  public static readonly BackOfficeResultsApplicants = 'BOResultsApplicants';
  public static readonly BackOfficeResultsCaseOwner = 'BOResultsCaseOwner';
  public static readonly BackOfficeResultsCaseStatus = 'BOResultsCaseStatus';
  public static readonly BackOfficeResultsPolicyRule = 'BOResultsPolicyRule';
  public static readonly BackOfficeResultsSAM = 'BOResultsSAM';
  public static readonly BackOfficeResultsSortBy = 'BOResultsSortBy';
  public static readonly BackOfficeResultsTotalAmount = 'BOResultsTotalAmount';
  public static readonly BackOfficeResultsViewCase = 'BOResultsViewCase';
  public static readonly BackOfficeScorebandRegionTitle = 'BOScorebandRegionTitle';
  public static readonly BackOfficeShowOnlyAcceptedWithoutAipCertificate = 'BOShowOnlyAcceptedWithoutAipCertificate';
  public static readonly BackOfficeShowOnlyOffline = 'BOShowOnlyOffline';
  public static readonly BackOfficeSortByBusinessWriter = 'BOSortByBusinessWriter';
  public static readonly BackOfficeSortByCaseOwner = 'BOSortByCaseOwner';
  public static readonly BackOfficeSortByCaseStatusAsc = 'BOSortByCaseStatusAsc';
  public static readonly BackOfficeSortByCaseStatusDesc = 'BOSortByCaseStatusDesc';
  public static readonly BackOfficeSortByDateSubmitted = 'BOSortByDateSubmitted';
  public static readonly BackOfficeSortByLastModifiedDate = 'BOSortByLastModifiedDate';
  public static readonly BackOfficeSortByOldestUncheckedDocuments = 'BOSortByOldestUncheckedDocuments';
  public static readonly BackOfficeSortByOldestUnreadMessages = 'BOSortByOldestUnreadMessages';
  public static readonly BackOfficeTransactRegionTitle = 'BOTransactRegionTitle';
  public static readonly BackToEdit = 'BackToEdit';
  public static readonly BackToLogin = 'BackToLogin';
  public static readonly BackToLoginButton = 'BackToLoginButton';
  public static readonly BackToOfferOverview = 'BackToOfferOverview';
  public static readonly BackToSearch = 'BackToSearch';
  public static readonly BalanceCurrentlyOutstanding = 'BalanceCurrentlyOutstanding';
  public static readonly BalanceDetails = 'BalanceDetails';
  public static readonly BalanceDetailsTitle = 'BalanceDetailsTitle';
  public static readonly BalanceNegativeDescription = 'BalanceNegativeDescription';
  public static readonly BalancePositiveDescription = 'BalancePositiveDescription';
  public static readonly BankBuildingSocietyName = 'BankBuildingSocietyName';
  public static readonly BankNameAndAddress = 'BankNameAndAddress';
  public static readonly BankStatement = 'BankStatement';
  public static readonly Bankrupt = 'Bankrupt';
  public static readonly BankruptDetails = 'BankruptDetails';
  public static readonly BankUKWebsiteUrl = 'BankUKWebsiteUrl';
  public static readonly BeenInArrear = 'BeenInArrear';
  public static readonly BeenInArrearDetails = 'BeenInArrearDetails';
  public static readonly BoiCaseOwner = 'BoiCaseOwner';
  public static readonly BoiInfo = 'BoiInfo';
  public static readonly BoiMortgages = 'BoiMortgages';
  public static readonly BoiMortgagesLink = 'BoiMortgagesLink';
  public static readonly BookAdviceInterview = 'BookAdviceInterview';
  public static readonly BookingFeeId = 'BookingFee';
  public static readonly BorrowingTermId = 'BorrowingTerm';
  public static readonly BorrowingTermToolTip = 'BorrowingTermToolTip';
  public static readonly Branch = 'Branch';
  public static readonly BranchAddress = 'BranchAddress';
  public static readonly BranchAddress1 = 'BranchAddress1';
  public static readonly BranchAddress2 = 'BranchAddress2';
  public static readonly BranchDetails = 'BranchDetails';
  public static readonly BranchDetailsUpdated = 'BranchDetailsUpdated';
  public static readonly BranchErrorMessage = 'BranchErrorMessage';
  public static readonly BranchGroupAuditName = 'BranchGroupAuditName';
  public static readonly BranchGroupClone = 'BranchGroupClone';
  public static readonly BranchGroupCloneGroupName = 'BranchGroupCloneGroupName';
  public static readonly BranchGroupCloneGroupTitle = 'BranchGroupCloneGroupTitle';
  public static readonly BranchGroupDeleteCompleted = 'BranchGroupDeleteCompleted';
  public static readonly BranchGroupDeleteGroup = 'BranchGroupDeleteGroup';
  public static readonly BranchGroupDeleteGroupQuestion = 'BranchGroupDeleteGroupQuestion';
  public static readonly BranchGroupDeleteGroupTitle = 'BranchGroupDeleteGroupTitle';
  public static readonly BranchGroupDetails = 'BranchGroupDetails';
  public static readonly BranchGroupName = 'BranchGroupName';
  public static readonly BranchGroupReset = 'BranchGroupReset';
  public static readonly BranchGroupSaveClone = 'BranchGroupSaveClone';
  public static readonly BranchGroupSaveCompleted = 'BranchGroupSaveCompleted';
  public static readonly BranchID = 'BranchID';
  public static readonly BranchImport = 'BranchImport';
  public static readonly BranchImportBranches = 'BranchImportBranches';
  public static readonly BranchPhoneNumber = 'BranchPhoneNumber';
  public static readonly BranchPostCode = 'BranchPostCode';
  public static readonly BranchProposition = 'BranchProposition';
  public static readonly BranchPropositionName = 'BranchPropositionName';
  public static readonly BranchSearchForResults = 'BranchSearchForResults';
  public static readonly BranchStatus = 'BranchStatus';
  public static readonly BranchType = 'BranchType';
  public static readonly BranchUploadModalMessageFormats = 'BranchUploadModalMessageFormats';
  public static readonly BranchUploadModalTitle = 'BranchUploadModalTitle';
  public static readonly BranchUserAccessAllLocations = 'BranchUserAccessAllLocations';
  public static readonly BranchUserAuditName = 'BranchUserAuditName';
  public static readonly BranchUserEmailAddress = 'BranchUserEmailAddress';
  public static readonly BranchUserHomeBranch = 'BranchUserHomeBranch';
  public static readonly BranchUserHomeBranchId = 'BranchUserHomeBranchId';
  public static readonly BranchUserHomeBranchName = 'BranchUserHomeBranchName';
  public static readonly BranchUserLastLogin = 'BranchUserLastLogin';
  public static readonly BranchUserLocation = 'BranchUserLocation';
  public static readonly BranchUserLocationGroup = 'BranchUserLocationGroup';
  public static readonly BranchUserLocationId = 'BranchUserLocationId';
  public static readonly BranchUserLocationName = 'BranchUserLocationName';
  public static readonly BranchUserManageCases = 'BranchUserManageCases';
  public static readonly BranchUserPermissions = 'BranchUserPermissions';
  public static readonly BranchUserPersonalDetails = 'BranchUserPersonalDetails';
  public static readonly BranchUserReset = 'BranchUserReset';
  public static readonly BranchUserShowResults = 'BranchUserShowResults';
  public static readonly BranchUserStaffId = 'BranchUserStaffId';
  public static readonly BranchUserStatus = 'BranchUserStatus';
  public static readonly BranchUserTown = 'BranchUserTown';
  public static readonly BranchUserViewCases = 'BranchUserViewCases';
  public static readonly BranchUsersCount = 'BranchUsersCount';
  public static readonly BranchUsersExport = 'BranchUsersExport';
  public static readonly Branches = 'Branches';
  public static readonly BranchesAuditName = 'BranchAuditName';
  public static readonly BranchesCsvFailedToUpload = 'BranchesCsvFailedToUpload';
  public static readonly BrandMarketingConsentContentPart1 = 'BrandMarketingConsentContentPart1';
  public static readonly BrandMarketingConsentContentPart2 = 'BrandMarketingConsentContentPart2';
  public static readonly BrokerFeesDescription = 'BrokerFeesDescription';
  public static readonly BrokerFeesSection = 'BrokerFeesSection';
  public static readonly BrokerIsExcludedSociety = 'BrokerIsExcludedSociety';
  public static readonly BrokerIsMatchingMortgageProposition = 'BrokerIsMatchingMortgageProposition';
  public static readonly BrokerMortgageOfferDocumentsNeedHelp = 'BrokerMortgageOfferDocumentsNeedHelp';
  public static readonly BrokerMortgageOfferDocumentsNeedHelpExistingBusiness =
    'BrokerMortgageOfferDocumentsNeedHelpExistingBusiness';
  public static readonly BrokerMortgageOfferNeedHelp = 'BrokerMortgageOfferNeedHelp';
  public static readonly BrokerMortgageOfferNeedHelpExistingBusiness = 'BrokerMortgageOfferNeedHelpExistingBusiness';
  public static readonly BrokerMortgageOfferWelcomeInformation = 'BrokerMortgageOfferWelcomeInformation';
  public static readonly BrokerMortgageOfferWelcomeInformationExistingBusiness =
    'BrokerMortgageOfferWelcomeInformationExistingBusiness';
  public static readonly BrokerPreferencesDescription = 'BrokerPreferencesDescription';
  public static readonly BrokerPreferencesTitle = 'BrokerPreferencesTitle';
  public static readonly Browse = 'Browse';
  public static readonly BrowseAddressesFromListId = 'BrowseAddressesFromList';
  public static readonly BtlAffordabilityNotificationMsg = 'BtlAffordabilityNotificationMsg';
  public static readonly BtlCaseBarMortgageAccount = 'BtlCaseBarMortgageAccount';
  public static readonly BtlProductPickerMortgageConfirm = 'BtlProductPickerMortgageConfirm';
  public static readonly BtlProductPickerMortgageOffer = 'BtlProductPickerMortgageOffer';
  public static readonly BtlProductPickerMortgageSelect = 'BtlProductPickerMortgageSelect';
  public static readonly BtlSwitchProductPickerGetAdvice = 'BtlSwitchProductPickerGetAdvice';
  public static readonly BtlSwitchProductPickerUnsureOfProduct = 'BtlSwitchProductPickerUnsureOfProduct';
  public static readonly BtlSwitchProductPickerUnsureOfProductLoggedIn =
    'BtlSwitchProductPickerUnsureOfProductLoggedIn';
  public static readonly BuildingSurveyNoteId = 'BuildingSurveyNote';
  public static readonly BusinessAddress = 'BusinessAddress';
  public static readonly BusinessName = 'BusinessName';
  public static readonly BusinessTotalAnnualIncomePreviousYear = 'BusinessTotalAnnualIncomePreviousYear';
  public static readonly BusinessType = 'BusinessType';
  public static readonly BusinessWriter = 'BusinessWriter';
  public static readonly BusinessYearsInEmployment = 'BusinessYearsInEmployment';
  public static readonly ButtonAddAnotherApplicant = 'ButtonAddAnotherApplicant';
  public static readonly By = 'By';
  public static readonly ByAgentName = 'ByAgentName';
  public static readonly ByAttribute = 'ByAttribute';
  public static readonly ByProductCodeId = 'ByCode';
  public static readonly ByProductTypeId = 'ByType';
  public static readonly ByReleaseTag = 'ByReleaseTag';
  public static readonly CalculatedOnLatestPriceData = 'CalculatedOnLatestPriceData';
  public static readonly CalculatingId = 'Calculating';
  public static readonly CallCaseAssociatedToCall = 'CallCaseAssociatedToCall';
  public static readonly CallCaseNotAssociatedToCall = 'CallCaseNotAssociatedToCall';
  public static readonly CallCaseRequiredModalCaseId = 'CallCaseRequiredModalCaseId';
  public static readonly CallCaseRequiredModalContent = 'CallCaseRequiredModalContent';
  public static readonly CallCaseRequiredModalTitle = 'CallCaseRequiredModalTitle';
  public static readonly CallDirection = 'CallDirection';
  public static readonly CallFinish = 'CallFinish';
  public static readonly CallForClosedAccountsButton = 'CallForClosedAccountsButton';
  public static readonly CallLogHistory = 'CallLogHistory';
  public static readonly CallOutcome = 'CallOutcome';
  public static readonly CallOutcomeModalLogCall = 'CallOutcomeModalLogCall';
  public static readonly CallOutcomeModalTitle = 'CallOutcomeModalTitle';
  public static readonly CallStart = 'CallStart';
  public static readonly CallSubOutcome = 'CallSubOutcome';
  public static readonly CallToLinkAccountButton = 'CallToLinkAccountButton';
  public static readonly CannotPayPartRedemptionUntilProcessed = 'CannotPayPartRedemptionUntilProcessed';
  public static readonly CancelId = 'Cancel';
  public static readonly CancelAndReturnToCustomerHub = 'CancelAndReturnToCustomerHub';
  public static readonly CancelPaymentConfirmationMessage = 'CancelPaymentConfirmationMessage';
  public static readonly CancelTermChange = 'CancelTermChange';
  public static readonly CapsLockWarning = 'CapsLockWarning';
  public static readonly CapturePasswordRegisterButton = 'CapturePasswordRegisterButton';
  public static readonly CapturePasswordRegisterText = 'CapturePasswordRegisterText';
  public static readonly CapturePasswordRegisterTitle = 'CapturePasswordRegisterTitle';
  public static readonly CapturePasswordUnableSwitchText = 'CapturePasswordUnableSwitchText';
  public static readonly CapturePasswordUnableSwitchTitle = 'CapturePasswordUnableSwitchTitle';
  public static readonly Case = 'Case';
  public static readonly CaseActivity = 'CaseActivity';
  public static readonly CaseAdminNotAvailable = 'CaseAdminNotAvailable';
  public static readonly CaseAdministrator = 'RegistrationCaseAdministrator';
  public static readonly CaseAdviceRecordsActionsCompareFactFinds = 'CaseAdviceRecordsActionsCompareFactFinds';
  public static readonly CaseBarApplicationBuyToLet = 'CaseBarApplicationBuyToLet';
  public static readonly CaseBarApplicationResidential = 'CaseBarApplicationResidential';
  public static readonly CaseBarCaseLoan = 'CaseBarCaseLoan';
  public static readonly CaseBarCaseNumber = 'CaseBarCaseNumber';
  public static readonly CaseBarMortgageAccount = 'CaseBarMortgageAccount';
  public static readonly CaseBarStartNewBuyToLet = 'CaseBarStartNewBuyToLet';
  public static readonly CaseBarStartNewResidential = 'CaseBarStartNewResidential';
  public static readonly CaseDocumentsAdditionalDocuments = 'CaseDocumentsAdditionalDocuments';
  public static readonly CaseDocumentsAip = 'CaseDocumentsAip';
  public static readonly CaseDocumentsAipItem = 'CaseDocumentsAipItem';
  public static readonly CaseDocumentsApp = 'CaseDocumentsApp';
  public static readonly CaseDocumentsAppItem = 'CaseDocumentsAppItem';
  public static readonly CaseDocumentsDescription = 'CaseDocumentsDescription';
  public static readonly CaseDocumentsKfi = 'CaseDocumentsKfi';
  public static readonly CaseDocumentsKfiItem = 'CaseDocumentsKfiItem';
  public static readonly CaseDocumentsTab = 'CaseDocumentsTab';
  public static readonly CaseDocumentsTitle = 'CaseDocumentsTitle';
  public static readonly CaseFeesCaseOwner = 'CaseFeesCaseOwner';
  public static readonly CaseHub = 'CaseHub';
  public static readonly CaseHubRecentActivity = 'CaseHubRecentActivity';
  public static readonly CaseInvalidForLink = 'CaseInvalidForLink';
  public static readonly CaseManagement = 'CaseManagement';
  public static readonly CaseManagementQA = 'CaseManagementQA';
  public static readonly CaseMessagingDownloadedToSAM = 'CaseMessagingDownloadedToSAM';
  public static readonly CaseMessagingFormSendMessage = 'CaseMessagingFormSendMessage';
  public static readonly CaseMessagingFormTo = 'CaseMessagingFormTo';
  public static readonly CaseMessagingFrom = 'CaseMessagingFrom';
  public static readonly CaseMessagingHideMessage = 'CaseMessagingHideMessage';
  public static readonly CaseMessagingMessageRead = 'CaseMessagingMessageRead';
  public static readonly CaseMessagingMessageReadAuditStamp = 'CaseMessagingMessageReadAuditStamp';
  public static readonly CaseMessagingNote = 'CaseMessagingNote';
  public static readonly CaseMessagingRequiresAction = 'CaseMessagingRequiresAction';
  public static readonly CaseMessagingSAMNotDownloaded = 'CaseMessagingSAMNotDownloaded';
  public static readonly CaseMessagingSAMWillDownload = 'CaseMessagingSAMWillDownload';
  public static readonly CaseMessagingSendMessage = 'CaseMessagingSendMessage';
  public static readonly CaseMessagingSent = 'CaseMessagingSent';
  public static readonly CaseMessagingShowMessage = 'CaseMessagingShowMessage';
  public static readonly CaseMessagingTitle = 'CaseMessagingTitle';
  public static readonly CaseNotFound = 'CaseNotFound';
  public static readonly CaseOverviewActionsAppealCase = 'CaseOverviewActionsAppealCase';
  public static readonly CaseOverviewActionsApply = 'CaseOverviewActionsApply';
  public static readonly CaseOverviewActionsAttachAdminNote = 'CaseOverviewActionsAttachAdminNote';
  public static readonly CaseOverviewActionsChangeOwner = 'CaseOverviewActionsChangeOwner';
  public static readonly CaseOverviewActionsChangeStatusToAip = 'CaseOverviewActionsChangeStatusToAip';
  public static readonly CaseOverviewActionsChangeStatusToApp = 'CaseOverviewActionsChangeStatusToApp';
  public static readonly CaseOverviewActionsChangeStatusToUnderwriter = 'CaseOverviewActionsChangeStatusToUnderwriter';
  public static readonly CaseOverviewActionsEditAip = 'CaseOverviewActionsEditAip';
  public static readonly CaseOverviewActionsEditApp = 'CaseOverviewActionsEditApp';
  public static readonly CaseOverviewActionsEditKfi = 'CaseOverviewActionsEditKfi';
  public static readonly CaseOverviewActionsPrintSamBundle = 'CaseOverviewActionsPrintSamBundle';
  public static readonly CaseOverviewActionsReinstateCase = 'CaseOverviewActionsReinstateCase';
  public static readonly CaseOverviewActionsRelease = 'CaseOverviewActionsRelease';
  public static readonly CaseOverviewActionsSendCaseMessage = 'CaseOverviewActionsSendCaseMessage';
  public static readonly CaseOverviewActionsStatus = 'CaseOverviewActionsStatus';
  public static readonly CaseOverviewActionsViewAuditTrail = 'CaseOverviewActionsViewAuditTrail';
  public static readonly CaseOverviewActionsViewSubmissionBundle = 'CaseOverviewActionsViewSubmissionBundle';
  public static readonly CaseOverviewAmlDecision = 'CaseOverviewAmlDecision';
  public static readonly CaseOverviewAmlDecisionNA = 'CaseOverviewAmlDecisionNA';
  public static readonly CaseOverviewAmlModalHeader = 'CaseOverviewAmlModalHeader';
  public static readonly CaseOverviewAmlModalTitle = 'CaseOverviewAmlModalTitle';
  public static readonly CaseOverviewAmlModalWindowTitle = 'CaseOverviewAmlModalWindowTitle';
  public static readonly CaseOverviewBranchUserOriginatorName = 'CaseOverviewBranchUserOriginatorName';
  public static readonly CaseOverviewBranchDetails = 'CaseOverviewBranchDetails';
  public static readonly CaseOverviewBrokerOriginatorName = 'CaseOverviewBrokerOriginatorName';
  public static readonly CaseOverviewCaseAdministrators = 'CaseOverviewCaseAdministrators';
  public static readonly CaseOverviewCompareArtefacts = 'CaseOverviewCompareArtefacts';
  public static readonly CaseOverviewDecision = 'CaseOverviewDecision';
  public static readonly CaseOverviewDirectCustomerOriginatorName = 'CaseOverviewDirectCustomerOriginatorName';
  public static readonly CaseOverviewFeesAgreement = 'CaseOverviewFeesAgreement';
  public static readonly CaseOverviewFeesBODetailsText = 'CaseOverviewFeesBODetailsText';
  public static readonly CaseOverviewFeesBOFeesToPayOnApp = 'CaseOverviewFeesBOFeesToPayOnApp';
  public static readonly CaseOverviewFeesIAmCardholder = 'CaseOverviewFeesIAmCardholder';
  public static readonly CaseOverviewFeesPaid = 'CaseOverviewFeesPaid';
  public static readonly CaseOverviewFeesPaidWorldpay = 'CaseOverviewFeesPaidWorldpay';
  public static readonly CaseOverviewFeesPayNow = 'CaseOverviewFeesPayNow';
  public static readonly CaseOverviewFeesPaymentMethods = 'CaseOverviewFeesPaymentMethods';
  public static readonly CaseOverviewFeesPendingPaymentModalContent = 'CaseOverviewFeesPendingPaymentModalContent';
  public static readonly CaseOverviewFeesPendingPaymentModalHeader = 'CaseOverviewFeesPendingPaymentModalHeader';
  public static readonly CaseOverviewFeesPendingPaymentModalTitle = 'CaseOverviewFeesPendingPaymentModalTitle';
  public static readonly CaseOverviewFeesRefund = 'CaseOverviewFeesRefund';
  public static readonly CaseOverviewFeesRefundOnlinePayment = 'CaseOverviewFeesRefundOnlinePayment';
  public static readonly CaseOverviewFeesRefundStatement = 'CaseOverviewFeesRefundStatement';
  public static readonly CaseOverviewFeesRefunded = 'CaseOverviewFeesRefunded';
  public static readonly CaseOverviewFeesTakeOfflinePayment = 'CaseOverviewFeesTakeOfflinePayment';
  public static readonly CaseOverviewFeesTotalPaid = 'CaseOverviewFeesTotalPaid';
  public static readonly CaseOverviewFeesTotalRefunded = 'CaseOverviewFeesTotalRefunded';
  public static readonly CaseOverviewFeesTotalToPay = 'CaseOverviewFeesTotalToPay';
  public static readonly CaseOverviewFeesTransactionRef = 'CaseOverviewFeesTransactionRef';
  public static readonly CaseOverviewFeesTransactionReference = 'CaseOverviewFeesTransactionReference';
  public static readonly CaseOverviewHeaderCaseSummary = 'CaseOverviewHeaderCaseSummary';
  public static readonly CaseOverviewKycModalTitle = 'CaseOverviewKycModalTitle';
  public static readonly CaseOverviewMenuActions = 'CaseOverviewMenuActions';
  public static readonly CaseOverviewMenuAdminNotes = 'CaseOverviewMenuAdminNotes';
  public static readonly CaseOverviewMenuCaseMessaging = 'CaseOverviewMenuCaseMessaging';
  public static readonly CaseOverviewMenuCreditScores = 'CaseOverviewMenuCreditScores';
  public static readonly CaseOverviewMenuDocuments = 'CaseOverviewMenuDocuments';
  public static readonly CaseOverviewMenuFees = 'CaseOverviewMenuFees';
  public static readonly CaseOverviewMenuRecords = 'CaseOverviewMenuRecords';
  public static readonly CaseOverviewMenuSummary = 'CaseOverviewMenuSummary';
  public static readonly CaseOverviewOriginatorDetails = 'CaseOverviewOriginatorDetails';
  public static readonly CaseOverviewRecordsActionsCompareArtefacts = 'CaseOverviewRecordsActionsCompareArtefacts';
  public static readonly CaseOverviewRecordsActionsCopyNewAip = 'CaseOverviewRecordsActionsCopyNewAip';
  public static readonly CaseOverviewRecordsActionsCopyNewApp = 'CaseOverviewRecordsActionsCopyNewApp';
  public static readonly CaseOverviewRecordsActionsDisplaying = 'CaseOverviewRecordsActionsDisplaying';
  public static readonly CaseOverviewRecordsActionsDownloadPdf = 'CaseOverviewRecordsActionsDownloadPdf';
  public static readonly CaseOverviewRecordsActionsEditNewAip = 'CaseOverviewRecordsActionsEditNewAip';
  public static readonly CaseOverviewRecordsActionsEditNewApp = 'CaseOverviewRecordsActionsEditNewApp';
  public static readonly CaseOverviewRecordsActionsEditNewKFI = 'CaseOverviewRecordsActionsEditNewKFI';
  public static readonly CaseOverviewRecordsActionsGenerateIllustration =
    'CaseOverviewRecordsActionsGenerateIllustration';
  public static readonly CaseOverviewRecordsActionsNewIllustration = 'CaseOverviewRecordsActionsNewIllustration';
  public static readonly CaseOverviewRecordsActionsProgressAip = 'CaseOverviewRecordsActionsProgressAip';
  public static readonly CaseOverviewRecordsActionsProgressApp = 'CaseOverviewRecordsActionsProgressApp';
  public static readonly CaseOverviewRecordsActionsResubmitKFI = 'CaseOverviewRecordsActionsResubmitKFI';
  public static readonly CaseOverviewRuleHit = 'CaseOverviewRuleHit';
  public static readonly CaseOverviewScoreband = 'CaseOverviewScoreband';
  public static readonly CaseOverviewUnderwriterDecision = 'CaseOverviewUnderwriterDecision';
  public static readonly CaseOverviewUnderwrittenBy = 'CaseOverviewUnderwrittenBy';
  public static readonly CaseOverviewViewDetails = 'CaseOverviewViewDetails';
  public static readonly CaseParticulars = 'CaseParticulars';
  public static readonly CasePermissions = 'CasePermissions';
  public static readonly CaseSelectorAccountNumber = 'CaseSelectorAccountNumber';
  public static readonly CaseStatusRegionTitle = 'CaseStatusRegionTitle';
  public static readonly CaseSummaryActions = 'CaseSummaryActions';
  public static readonly CaseSummaryApplicants = 'CaseSummaryApplicants';
  public static readonly CaseSummaryBusinessWriter = 'CaseSummaryBusinessWriter';
  public static readonly CaseSummaryCaseActivity = 'CaseSummaryCaseActivity';
  public static readonly CaseSummaryCaseOwner = 'CaseSummaryCaseOwner';
  public static readonly CaseSummaryCaseStatus = 'CaseSummaryCaseStatus';
  public static readonly CaseSummaryCopyAsNewCase = 'CaseSummaryCopyAsNewCase';
  public static readonly CaseSummaryCurrentDecision = 'CaseSummaryCurrentDecision';
  public static readonly CaseSummaryDecision = 'CaseSummaryDecision';
  public static readonly CaseSummaryDecisions = 'CaseSummaryDecisions';
  public static readonly CaseSummaryHeaderProduct = 'CaseSummaryHeaderProduct';
  public static readonly CaseSummaryLastModified = 'CaseSummaryLastModified';
  public static readonly CaseSummaryOriginator = 'CaseSummaryOriginator';
  public static readonly CaseSummaryParticulars = 'CaseSummaryParticulars';
  public static readonly CaseSummaryPolicyRules = 'CaseSummaryPolicyRules';
  public static readonly CaseSummaryProgressAipToApp = 'CaseSummaryProgressAipToApp';
  public static readonly CaseSummarySamDownload = 'CaseSummarySamDownload';
  public static readonly CaseSummarySamId = 'CaseSummarySamId';
  public static readonly CaseSummaryStatus = 'CaseSummaryStatus';
  public static readonly CaseSummaryStatusUpdate = 'CaseActivityStatusUpdated';
  public static readonly CaseSummaryUnallocated = 'CaseSummaryUnallocated';
  public static readonly CaseSummaryViewSubmission = 'CaseSummaryViewSubmission';
  public static readonly CaseRequest = 'CaseRequest';
  public static readonly CaseTaskNoteLog = 'CaseTaskNoteLog';
  public static readonly CaseType = 'CaseType';
  public static readonly CaseTypes = 'CaseTypes';
  public static readonly CashEarningsPercentage = 'CashEarningsPercentage';
  public static readonly Cashback = 'Cashback';
  public static readonly Category = 'Category';
  public static readonly CertifyUploadedDocument = 'CertifyUploadedDocument';
  public static readonly CharactersCounterLabel = 'CharactersCounterLabel';
  public static readonly Change = 'Change';
  public static readonly ChangeAccountOwnerHeader = 'ChangeAccountOwnerHeader';
  public static readonly ChangeApplicant = 'ChangeApplicant';
  public static readonly ChangeApplicantDescription = 'ChangeApplicantDescription';
  public static readonly ChangeApplicantInformation = 'ChangeApplicantInformation';
  public static readonly ChangeApplicantModalTitle = 'ChangeApplicantModalTitle';
  public static readonly ChangeApplicantSuccessConfirmationMessage = 'ChangeApplicantSuccessConfirmationMessage';
  public static readonly ChangeApplicantSuccessConfirmationTitle = 'ChangeApplicantSuccessConfirmationTitle';
  public static readonly ChangeBranchDetails = 'ChangeBranchDetails';
  public static readonly ChangeCustomerDetails = 'ChangeCustomerDetails';
  public static readonly ChangeEmailAddressFor = 'ChangeEmailAddressFor';
  public static readonly ChangeEmailNote = 'ChangeEmailNote';
  public static readonly ChangeFeePreferences = 'ChangeFeePreferences';
  public static readonly ChangeMyEmail = 'ChangeMyEmail';
  public static readonly ChangeMyContactNumber = 'ChangeMyContactNumber';
  public static readonly ContactLMS = 'ContactLMS';
  public static readonly ContactNumberUpdated = 'ContactNumberUpdated';
  public static readonly ContactNumberExceededTries = 'ContactNumberExceededTries';
  public static readonly ChangePaymentDetails = 'ChangePaymentDetails';
  public static readonly ChangePaymentDetailsButton = 'ChangePaymentDetailsButton';
  public static readonly ChangePhoneNumberFor = 'ChangePhoneNumberFor';
  public static readonly ChangeRegisteredCompanyDetails = 'ChangeRegisteredCompanyDetails';
  public static readonly ChangeTaskAllocation = 'ChangeTaskAllocation';
  public static readonly ChangeTerm = 'ChangeTerm';
  public static readonly ChangeToPost = 'ChangeToPost';
  public static readonly ChangeType = 'ChangeType';
  public static readonly ChangedBy = 'ChangedBy';
  public static readonly Changes = 'Changes';
  public static readonly ChangeSamId = 'ChangeSamId';
  public static readonly ChangeSamIdConfirmButton = 'ChangeSamIdConfirmButton';
  public static readonly ChangeSamIdErrorMessage = 'ChangeSamIdErrorMessage';
  public static readonly ChangeSamIdInput = 'ChangeSamIdInput';
  public static readonly ChangeSamIdText = 'ChangeSamIdText';
  public static readonly ChangeSamIdWindowTitle = 'ChangeSamIdWindowTitle';
  public static readonly ChooseAnotherBankAccount = 'ChooseAnotherBankAccount';
  public static readonly ChopsRegisterHeaderSection = 'ChopsRegisterHeaderSection';
  public static readonly ChosenSwitchProduct = 'ChosenSwitchProduct';
  public static readonly ChosenSwitchProductContent = 'ChosenSwitchProductContent';
  public static readonly ChosenSwitchProductContentBtl = 'ChosenSwitchProductContentBtl';
  public static readonly CheckEmailAndPhoneNumber = 'CheckEmailAndPhoneNumber';
  public static readonly Clear = 'Clear';
  public static readonly ClearFilters = 'ClearFilters';
  public static readonly ClickResendToReceiveEmail = 'ClickResendToReceiveEmail';
  public static readonly ClickToSelectSwitchSubAccount = 'ClickToSelectSwitchSubAccount';
  public static readonly Close = 'Close';
  public static readonly ClosedAccountLozenge = 'ClosedAccountLozenge';
  public static readonly ClosedMortgageAccountCaseHeader = 'ClosedMortgageAccountCaseHeader';
  public static readonly ClosedMortgageAccountFor = 'ClosedMortgageAccountFor';
  public static readonly ClosedMortgageAccountHelpInformation = 'ClosedMortgageAccountHelpInformation';
  public static readonly ClosedMortgageAccountHelperLinks = 'ClosedMortgageAccountHelperLinks';
  public static readonly ClosedMortgageAccountInformation = 'ClosedMortgageAccountInformation';
  public static readonly ClosedMortgageAccountNumber = 'ClosedMortgageAccountNumber';
  public static readonly ClosedMortgageAccountProperty = 'ClosedMortgageAccountProperty';
  public static readonly ClosedMortgageAccountTitle = 'ClosedMortgageAccountTitle';
  public static readonly CloseProducts = 'CloseProducts';
  public static readonly CloseTaskButton = 'CloseTaskButton';
  public static readonly Company = 'Company';
  public static readonly CompanyDetailsCompany = 'CompanyDetailsCompany';
  public static readonly CompanyDetailsPrincipal = 'CompanyDetailsPrincipal';
  public static readonly CompanyName = 'CompanyName';
  public static readonly CompleteFF2 = 'CompleteFF2';
  public static readonly CompleteFactFind = 'CompleteFactFind';
  public static readonly CompleteFactFind1 = 'CompleteFactFind1';
  public static readonly CompleteFactFind2 = 'CompleteFactFind2';
  public static readonly CompleteId = 'Complete';
  public static readonly CompleteMortgageHolder = 'CompleteMortgageHolder';
  public static readonly CompletePaymentConfirmationMessage = 'CompletePaymentConfirmationMessage';
  public static readonly CompleteTaskButton = 'CompleteTaskButton';
  public static readonly CompleteYourSecurityQuestionsDescription = 'CompleteYourSecurityQuestionsDescription';
  public static readonly CompleteYourSecurityQuestionsTitle = 'CompleteYourSecurityQuestionsTitle';
  public static readonly ConcessionNature = 'ConcessionNature';
  public static readonly ConcurrencyWindowTitle = 'ConcurrencyWindowTitle';
  public static readonly Configuration = 'Configuration';
  public static readonly ConfigurationAttributes = 'ConfigurationAttributes';
  public static readonly ConfigurationAuditName = 'PropositionInterfaceTypeReferenceDataAuditName';
  public static readonly ConfigurationBy = 'ConfigurationBy';
  public static readonly ConfigurationCategoryMandatory = 'ConfigurationCategoryMandatory';
  public static readonly ConfigurationCode = 'ConfigurationCode';
  public static readonly ConfigurationCodeForFreeLegalServiceText = 'ConfigurationCodeForFreeLegalServiceText';
  public static readonly ConfigurationDropHere = 'ConfigurationDropHere';
  public static readonly ConfigurationFormatsAllowed = 'ConfigurationFormatsAllowed';
  public static readonly ConfigurationGridAmended = 'ConfigurationGridAmended';
  public static readonly ConfigurationGridImported = 'ConfigurationGridImported';
  public static readonly ConfigurationIgnore = 'ConfigurationIgnore';
  public static readonly ConfigurationInterface = 'ConfigurationInterface';
  public static readonly ConfigurationLastImported = 'ConfigurationLastImported';
  public static readonly ConfigurationLastUpdated = 'ConfigurationLastUpdated';
  public static readonly ConfigurationMaxFileSize = 'ConfigurationMaxFileSize';
  public static readonly ConfigurationName = 'ConfigurationName';
  public static readonly ConfigurationNotes = 'ConfigurationNotes';
  public static readonly ConfigurationProposition = 'ConfigurationProposition';
  public static readonly ConfigurationReleaseTag = 'ConfigurationReleaseTag';
  public static readonly ConfigurationSelectFile = 'ConfigurationSelectFile';
  public static readonly ConfigurationSortOrder = 'ConfigurationSortOrder';
  public static readonly ConfigurationUploadContent = 'ConfigurationUploadContent';
  public static readonly ConfigurationUploadDone = 'ConfigurationUploadDone';
  public static readonly ConfigurationUploadFile = 'ConfigurationUploadFile';
  public static readonly ConfigurationValue = 'ConfigurationValue';
  public static readonly ConfigurationWarning = 'ConfigurationWarning';
  public static readonly ConfirmLabel = 'ConfirmLabel';
  public static readonly Confirmation = 'Confirmation';
  public static readonly ConfirmAccountAuthentication = 'ConfirmAccountAuthentication';
  public static readonly ConfirmAndResendOfferEmail = 'ConfirmAndResendOfferEmail';
  public static readonly ConfirmCaseCopy = 'ConfirmCopyCase';
  public static readonly ConfirmCreationExistingCustomerFromBOLabel = 'ConfirmCreationExistingCustomerFromBOLabel';
  public static readonly ConfirmDirectDebitNonAuthorizingCustomer = 'ConfirmDirectDebitNonAuthorizingCustomer';
  public static readonly ConfirmEmail = 'ConfirmEmail';
  public static readonly ConfirmContactNumber = 'ConfirmContactNumber';
  public static readonly ConfirmEmailMismatch = 'ConfirmEmailMismatch';
  public static readonly ConfirmLinkCaseWindowDetails = 'ConfirmLinkCaseWindowDetails';
  public static readonly ConfirmLinkCaseWindowTitle = 'ConfirmLinkCaseWindowTitle';
  public static readonly ConfirmNewPassword = 'ConfirmNewPassword';
  public static readonly ConfirmPassword = 'ConfirmPassword';
  public static readonly PhoneNumber = 'PhoneNumber';
  public static readonly ConfirmProductWithSpecialFeature = 'ConfirmProductWithSpecialFeature';
  public static readonly ConfirmSamCustomerDetails = 'ConfirmSamCustomerDetails';
  public static readonly ConfirmSamCustomerIdButton = 'ConfirmSamCustomerIdButton';
  public static readonly ConfirmSamCustomerWindowTitle = 'ConfirmSamCustomerWindowTitle';
  public static readonly Contact = 'Contact';
  public static readonly ContactAddressHeader = 'ContactAddressHeader';
  public static readonly ContactAdvisor = 'ContactAdvisor';
  public static readonly ContactNameForAccessToProperty = 'ContactNameForAccessToProperty';
  public static readonly ContactNumber = 'ContactNumber';
  public static readonly ContactPhoneNo = 'ContactPhoneNo';
  public static readonly ContactTelephoneNumber = 'ContactTelephoneNumber';
  public static readonly ContactUs = 'ContactUs';
  public static readonly ContactUsDirectDebit = 'ContactUsDirectDebit';
  public static readonly ContactUsDirectDebitBack = 'ContactUsDirectDebitBack';
  public static readonly ContactUsDirectDebitConfirm = 'ContactUsDirectDebitConfirm';
  public static readonly ContactUsDirectDebitTelephone = 'ContactUsDirectDebitTelephone';
  public static readonly ContactUsDirectDebitModalTitle = 'ContactUsDirectDebitModalTitle';
  public static readonly ContactUsForAddAccount = 'ContactUsForAddAccountText';
  public static readonly ContactUsForUnableToSwitch = 'ContactUsForUnableToSwitch';
  public static readonly Contains = 'Contains';
  public static readonly ContextualHelpBoxShowLess = 'ContextualHelpBoxShowLess';
  public static readonly ContextualHelpBoxShowMore = 'ContextualHelpBoxShowMore';
  public static readonly ContextualHelpBoxTitle = 'ContextualHelpBoxTitle';
  public static readonly ContextualHelpRegisterForSwitch = 'ContextualHelpRegisterForSwitch';
  public static readonly ContextualHelpSwitch = 'ContextualHelpSwitch';
  public static readonly Continue = 'Continue';
  public static readonly ContinueAndReviewSwitch = 'ContinueAndReviewSwitch';
  public static readonly ContinueId = 'ContinueId';
  public static readonly ContinueToKfiId = 'ContinueToKfi';
  public static readonly ContinueToLogin = 'ContinueToLogin';
  public static readonly ContinueToMortgageApplicationId = 'ContinueToMortgageApplication';
  public static readonly ContinueToNextStep = 'ContinueToNextStep';
  public static readonly ContinueWithEligibleProducts = 'ContinueWithEligibleProducts';
  public static readonly ContinueWithIllustration = 'ContinueWithIllustration';
  public static readonly ContinueWithSwitch = 'ContinueWithSwitch';
  public static readonly ContinueWithoutInvalidProducts = 'ContinueWithoutInvalidProducts';
  public static readonly ContinuingMonthlyPaymentsOnOutgoings = 'ContinuingMonthlyPaymentsOnOutgoings';
  public static readonly ContractEndDate = 'ContractEndDate';
  public static readonly CookiePolicy = 'CookiePolicy';
  public static readonly CookieWarning = 'CookieWarning';
  public static readonly CookieWarningContent = 'CookieWarningContent';
  public static readonly CookieWarningTitle = 'CookieWarningTitle';
  public static readonly CookiesPolicyPageContent = 'CookiesPolicyPageContent';
  public static readonly CookiesPolicyPageTitle = 'CookiesPolicyPageTitle';
  public static readonly CopyCaseContent = 'CopyCaseContent';
  public static readonly CopyCaseDescription = 'CopyCaseDescription';
  public static readonly CopyCaseHeader = 'CopyCaseHeader';
  public static readonly Copyright = 'Copyright';
  public static readonly CopyRightLabel = 'CopyRightLabel';
  public static readonly CorrespondenceAddress = 'CorrespondenceAddress';
  public static readonly CountryId = 'Country';
  public static readonly CountryNonUk = 'Non-UKIncludingBFPO';
  public static readonly CountryOfBirthId = 'CountryOfBirth';
  public static readonly CountryUk = 'UK';
  public static readonly CountyId = 'County';
  public static readonly CourtJudgment = 'CourtJudgment';
  public static readonly CourtJudgmentDetails = 'CourtJudgmentDetails';
  public static readonly CreateAIPDescription = 'CreateAIPDescription';
  public static readonly CreateAIPTitle = 'CreateAIPTitle';
  public static readonly CreateAdvisedResidentialCaseDescription = 'CreateAdvisedResidentialCaseDescription';
  public static readonly CreateAdvisedResidentialCaseTitle = 'CreateAdvisedResidentialCaseTitle';
  public static readonly CreateAipButton = 'CreateAipButton';
  public static readonly CreateAssessTask = 'CreateAssessTask';
  public static readonly CreateCase = 'CreateCase';
  public static readonly CreateCaseDescription = 'CreateCaseDescription';
  public static readonly CreateCaseTitle = 'CreateCaseTitle';
  public static readonly CreateDirectCustomerTitle = 'CreateDirectCustomerTitle';
  public static readonly CreateExistingDirectCustomer = 'CreateExistingDirectCustomer';
  public static readonly CreateIllustration = 'CreateIllustration';
  public static readonly CreateNewIllustration = 'CreateNewIllustration';
  public static readonly CreateKfi = 'CreateKfi';
  public static readonly CreateKfiDescription = 'CreateKfiDescription';
  public static readonly CreateKfiDescriptionId = 'CreateKfiDescription';
  public static readonly CreateKfiTitleId = 'CreateKfiTitle';
  public static readonly CreateKfiWithExpiredProduct = 'CreateKfiWithExpiredProduct';
  public static readonly CreateMortgageApplicationDescriptionId = 'CreateMortgageApplicationDescription';
  public static readonly CreateMortgageApplicationTitleId = 'CreateMortgageApplicationTitle';
  public static readonly CreateNew = 'CreateNew';
  public static readonly CreateNewConfigurationItem = 'CreateNewConfigurationItem';
  public static readonly CreateNewDirectCustomer = 'CreateNewDirectCustomer';
  public static readonly CreateNewPassword = 'CreateNewPassword';
  public static readonly CreateNewPasswordSecurityInfo = 'CreateNewPasswordSecurityInfo';
  public static readonly CreateNewQuote = 'CreateNewQuote';
  public static readonly CreateNewVersion = 'CreateNewVersion';
  public static readonly CreateRecommendation = 'CreateRecommendation';
  public static readonly CreateRole = 'CreateRole';
  public static readonly CreateRomeUser = 'CreateRomeUser';
  public static readonly CreateTemplate = 'CreateTemplate';
  public static readonly CreationDate = 'CreationDate';
  public static readonly CreditLimit = 'CreditLimit';
  public static readonly CreditScoreNote = 'CreditScoreNote';
  public static readonly CreditSearch = 'CreditSearch';
  public static readonly CreditSearchProcess = 'CreditSearchProcess';
  public static readonly CreditSearchProcessContent = 'CreditSearchProcessContent';
  public static readonly Currency = 'Currency';
  public static readonly CurrentAddress = 'CurrentAddress';
  public static readonly CurrentCaseOwner = 'CurrentCaseOwner';
  public static readonly CurrentPaymentLabel = 'CurrentPaymentLabel';
  public static readonly CurrentEmailAddress = 'CurrentEmailAddress';
  public static readonly CurrentLTV = 'CurrentLTV';
  public static readonly CurrentMarginalTaxRateCode = 'CurrentMarginalTaxRateCode';
  public static readonly CurrentMonthlyPayment = 'CurrentMonthlyPayment';
  public static readonly CurrentPaymentDate = 'CurrentPaymentDate';
  public static readonly CurrentPhoneNumber = 'CurrentPhoneNumber';
  public static readonly CurrentPropertyId = 'CurrentProperty';
  public static readonly CurrentRate = 'CurrentRate';
  public static readonly CurrentTerm = 'CurrentTerm';
  public static readonly CurrentTotalMonthlyPayment = 'CurrentTotalMonthlyPayment';
  public static readonly CurrentValuationAmountError = 'CurrentValuationAmountError';
  public static readonly CustomerAdviceLevel = 'CustomerAdviceLevel';
  public static readonly CustomerDetailsHeaderSection = 'CustomerDetailsHeaderSection';
  public static readonly CustomerDetailsTitleSection = 'CustomerDetailsTitleSection';
  public static readonly CustomerHasProductSwitchInProgressInformation =
    'CustomerHasProductSwitchInProgressInformation';
  public static readonly CustomerHub = 'CustomerHub';
  public static readonly CutomerHubRegistration = 'CutomerHubRegistration';
  public static readonly CustomerHubRegistrationDialogDescription = 'CustomerHubRegistrationDialogDescription';
  public static readonly CustomerHubRegistrationDialogConfirmation = 'CustomerHubRegistrationDialogConfirmation';
  public static readonly CustomerHubRegistrationSuccessfulMessage = 'CustomerHubRegistrationSuccessfulMessage';
  public static readonly CustomerLinkedNotificationContent = 'CustomerLinkedNotificationContent';
  public static readonly CustomerLinkedNotificationTitle = 'CustomerLinkedNotificationTitle';
  public static readonly CustomerNumber = 'CustomerNumber';
  public static readonly CustomerOffer = 'CustomerOffer';
  public static readonly CustomerType = 'CustomerType';
  public static readonly CustomerTypeFirstTimeBuyer = 'F';
  public static readonly CustomerTypeOwnerMovingHouse = 'M';
  public static readonly CustomerTypePurchase = 'P';
  public static readonly CustomerTypeRemortgaging = 'R';
  public static readonly CustomerVerificationLoginDetailsInfo = 'CustomerVerificationLoginDetailsInfo';
  public static readonly CustomerVerificationMessage = 'CustomerVerificationMessage';
  public static readonly CustomerVerificationConfirmEmailFieldDescription =
    'CustomerVerificationConfirmEmailFieldDescription';
  public static readonly CustomerVerificationConfirmPhoneFieldDescription =
    'CustomerVerificationConfirmPhoneFieldDescription';
  public static readonly CustomerVerificationEditRestrictionModalDescription =
    'CustomerVerificationEditRestrictionModalDescription';
  public static readonly CustomerVerificationEditRestrictionModalTitle =
    'CustomerVerificationEditRestrictionModalTitle';
  public static readonly CustomerVerificationEmailFieldDescription = 'CustomerVerificationEmailFieldDescription';
  public static readonly CustomerVerificationEmailSectionTitle = 'CustomerVerificationEmailSectionTitle';
  public static readonly CustomerVerificationInfoConflictModalDescription =
    'CustomerVerificationInfoConflictModalDescription';
  public static readonly CustomerVerificationInfoConflictModalTitle = 'CustomerVerificationInfoConflictModalTitle';
  public static readonly CustomerVerificationNoUpdateModalDescription = 'CustomerVerificationNoUpdateModalDescription';
  public static readonly CustomerVerificationNoUpdateModalTitle = 'CustomerVerificationNoUpdateModalTitle';
  public static readonly CustomerVerificationPhoneFieldDescription = 'CustomerVerificationPhoneFieldDescription';
  public static readonly CustomerVerificationPhoneRequirements = 'CustomerVerificationPhoneRequirements';
  public static readonly CustomerVerificationPhoneSectionTitle = 'CustomerVerificationPhoneSectionTitle';
  public static readonly CustomerVerificationWindowAfterCheckTitle = 'CustomerVerificationWindowAfterCheckTitle';
  public static readonly CustomerVerificationWindowBeforeCheckTitle = 'CustomerVerificationWindowBeforeCheckTitle';
  public static readonly CustomerVerificationWindowNon2FAAfterGracePeriodInfo =
    'CustomerVerificationWindowNon2FAAfterGracePeriodInfo';
  public static readonly CustomerVerificationWindowNon2FAAfterGracePeriodNoExperianInfo =
    'CustomerVerificationWindowNon2FAAfterGracePeriodNoExperianInfo';
  public static readonly CustomerVerificationWindowNon2FAAfterGracePeriodNoIDVerseInfo =
    'CustomerVerificationWindowNon2FAAfterGracePeriodNoIDVerseInfo';
  public static readonly CustomerVerificationWindowNon2FADuringGracePeriodInfo =
    'CustomerVerificationWindowNon2FADuringGracePeriodInfo';
  public static readonly CustomerVerificationWindowNon2FADuringGracePeriodNoExperianInfo =
    'CustomerVerificationWindowNon2FADuringGracePeriodNoExperianInfo';
  public static readonly CustomerVerificationWindowNon2FADuringGracePeriodNoIDVerseInfo =
    'CustomerVerificationWindowNon2FADuringGracePeriodNoIDVerseInfo';
  public static readonly CustomerVerificationWindowWith2FAAfterCheckInfo =
    'CustomerVerificationWindowWith2FAAfterCheckInfo';
  public static readonly CustomerVerificationWindowWith2FAAfterCheckNoExperianInfo =
    'CustomerVerificationWindowWith2FAAfterCheckNoExperianInfo';
  public static readonly CustomerVerificationWindowWith2FAAfterCheckNoIDVerseInfo =
    'CustomerVerificationWindowWith2FAAfterCheckNoIDVerseInfo';
  public static readonly CustomerVerificationWindowWith2FABeforeCheckInfo =
    'CustomerVerificationWindowWith2FABeforeCheckInfo';
  public static readonly CustomerVerificationWindowWith2FABeforeCheckNoExperianInfo =
    'CustomerVerificationWindowWith2FABeforeCheckNoExperianInfo';
  public static readonly CustomerVerificationWindowWith2FABeforeCheckNoIDVerseInfo =
    'CustomerVerificationWindowWith2FABeforeCheckNoIDVerseInfo';
  public static readonly CustomerVerificationButton = 'CustomerVerificationButton';
  public static readonly RestartCustomerVerificationButton = 'RestartCustomerVerificationButton';
  public static readonly CustomerVerificationLabel = 'CustomerVerificationLabel';
  public static readonly CustomerVerificationDetailsStatusTechnicalFailure =
    'CustomerVerificationDetailsStatusTechnicalFailure';
  public static readonly CustomerVerificationDetailsStatusComplete = 'CustomerVerificationDetailsStatusComplete';
  public static readonly CustomerVerificationTransUnion = 'CustomerVerificationTransUnion';
  public static readonly CustomerVerificationExperian = 'CustomerVerificationExperian';
  public static readonly CustomerVerificationConsentDescription = 'CustomerVerificationConsentDescription';
  public static readonly CustomerVerificationProductSwitchInProgresssModalDescription =
    'CustomerVerificationProductSwitchInProgresssModalDescription';
  public static readonly CustomerVerificationProductSwitchInProgresssModalTitle =
    'CustomerVerificationProductSwitchInProgresssModalTitle';
  public static readonly CustomerVerificationEditRestrictedModalTitle = 'CustomerVerificationEditRestrictedModalTitle';
  public static readonly CustomerVerificationEditRestrictedModalDescription =
    'CustomerVerificationEditRestrictedModalDescription';
  public static readonly ResendCustomerVerificationEmail = 'ResendCustomerVerificationEmail';
  public static readonly CancelCustomerVerification = 'CancelCustomerVerification';
  public static readonly CustomerVerificationStartedPasswordChangeDenied =
    'CustomerVerificationStartedPasswordChangeDenied';
  public static readonly CustomerVerificationNoChangesModalDescription =
    'CustomerVerificationNoChangesModalDescription';
  public static readonly CustomerVerificationNoChangesModalTitle = 'CustomerVerificationNoChangesModalTitle';
  public static readonly Dashboard = 'Dashboard';
  public static readonly DateCIDDIssued = 'DateCIDDIssued';
  public static readonly DateCreated = 'DateCreated';
  public static readonly DateEffectOfAffectIncome = 'DateEffectOfAffectIncome';
  public static readonly DateEffectOfExpenditure = 'DateEffectOfExpenditure';
  public static readonly DateFirstTenantOccupiedTheProperty = 'DateFirstTenantOccupiedTheProperty';
  public static readonly DateImportedFrom = 'DateImportedFrom';
  public static readonly DateImportedTo = 'DateImportedTo';
  public static readonly DateNICHALetterReceived = 'DateNICHALetterReceived';
  public static readonly DateOfBirth = 'DateOfBirth';
  public static readonly DateOfBirthId = 'DateOfBirth';
  public static readonly DateOfEntry = 'DateOfEntry';
  public static readonly DateRange = 'DateRange';
  public static readonly DateRangeFrom = 'DateRangeFrom';
  public static readonly DateRangeLastDays1 = 'DateRangeLastDays1';
  public static readonly DateRangeLastDays2 = 'DateRangeLastDays2';
  public static readonly DateRangeTo = 'DateRangeTo';
  public static readonly DateTenacyAgreementFinishes = 'DateTenacyAgreementFinishes';
  public static readonly DecisionTextSummaryMoreInfo1 = 'DecisionTextSummaryMoreInfo1';
  public static readonly DecisionTextSummaryMoreInfo2 = 'DecisionTextSummaryMoreInfo2';
  public static readonly DecisionTextSummaryMoreInfoLink = 'DecisionTextSummaryMoreInfoLink';
  public static readonly Declaration = 'Declaration';
  public static readonly DeclarationAndConsent = 'DeclarationAndConsent';
  public static readonly DeclarationAndConsentContent = 'DeclarationAndConsentContent';
  public static readonly DeclarationContent = 'DeclarationContent';
  public static readonly DeclarationForSearchingAnExistingCustomer = 'DeclarationForSearchingAnExistingCustomer';
  public static readonly DeclarationsAgreement = 'DeclarationsAgreement';
  public static readonly Decline = 'Decline';
  public static readonly DeductionsLabel = 'DeductionsLabel';
  public static readonly DeductionsTooltip = 'DeductionsTooltip';
  public static readonly DefaultErrorMessage = 'DefaultErrorMessage';
  public static readonly DefaultNumberOfApplicants = 'Noa1';
  public static readonly Delete = 'Delete';
  public static readonly DeleteApplicant = 'DeleteApplicant';
  public static readonly DeleteApplicantModalButtonCancel = 'DeleteApplicantModalButtonCancel';
  public static readonly DeleteApplicantModalButtonConfirm = 'DeleteApplicantModalButtonConfirm';
  public static readonly DeleteApplicantModalText = 'DeleteApplicantModalText';
  public static readonly DeleteApplicantModalTitle = 'DeleteApplicantModalTitle';
  public static readonly Dependant = 'Dependant';
  public static readonly DependentId = 'Dependent';
  public static readonly DependentsDatesOfBirth = 'DependentsDatesOfBirth';
  public static readonly DepositSource = 'DepositSource';
  public static readonly DepositSourceForRemortgage = 'DepositSourceForRemortgage';
  public static readonly DescriptionLabelForAutoLinkToAccountStatusNotLinked =
    'DescriptionLabelForAutoLinkToAccountStatusNotLinked';
  public static readonly DepositSourceTypeAmount = 'DepositSourceTypeAmount';
  public static readonly DepositSourceTypeAmountForRemortgage = 'DepositSourceTypeAmountForRemortgage';
  public static readonly DepositSourceTypeDetails = 'DepositSourceTypeDetails';
  public static readonly DepositSourceTypeDetailsForRemortgage = 'DepositSourceTypeDetailsForRemortgage';
  public static readonly DetailsAboutYourProperty = 'DetailsAboutYourProperty';
  public static readonly DetailsAboutYourPropertyAip = 'DetailsAboutYourPropertyAip';
  public static readonly DetailsConfirmationInProgressBanner = 'DetailsConfirmationInProgressBanner';
  public static readonly DetailsConfirmationNotStartedBanner = 'DetailsConfirmationNotStartedBanner';
  public static readonly DetailsOfChangeExpenditure = 'DetailsOfChangeExpenditure';
  public static readonly DetailsOfChangeIncome = 'DetailsOfChangeIncome';
  public static readonly DirectCase = 'DirectCase';
  public static readonly DirectCustomerAdvisedDocuments = 'DirectCustomerAdvisedDocuments';
  public static readonly DirectCustomerAdvisedDocumentsText = 'DirectCustomerAdvisedDocumentsText';
  public static readonly DirectCustomerAdvisedKfiInfoText = 'DirectCustomerAdvisedKfiInfoText';
  public static readonly DirectCustomerAdvisedMortgageOffer = 'DirectCustomerAdvisedMortgageOffer';
  public static readonly DirectCustomerAdvisedMortgageOfferText = 'DirectCustomerAdvisedMortgageOfferText';
  public static readonly DirectCustomerAdvisedYou = 'DirectCustomerAdvisedYou';
  public static readonly DirectCustomerAdvisedYouText = 'DirectCustomerAdvisedYouText';
  public static readonly DirectCustomerAipIncompleteInfoText = 'DirectCustomerAipIncompleteInfoText';
  public static readonly DirectCustomerAipIncompleteInfoTextBtl = 'DirectCustomerAipIncompleteInfoTextBtl';
  public static readonly DirectCustomerAuditName = 'DirectCustomerAuditName';
  public static readonly DirectCustomerBoiWillContact = 'DirectCustomerBoiWillContact';
  public static readonly DirectCustomerBtlContinueWithoutAdvice = 'DirectCustomerBtlContinueWithoutAdvice';
  public static readonly DirectCustomerBuyToLetApplyNow = 'DirectCustomerBuyToLetApplyNow';
  public static readonly DirectCustomerBuyToLetApprovalPrinciple = 'DirectCustomerBuyToLetApprovalPrinciple';
  public static readonly DirectCustomerBuyToLetApprovalPrincipleText = 'DirectCustomerBuyToLetApprovalPrincipleText';
  public static readonly DirectCustomerBuyToLetComplaintInformation = 'DirectCustomerBuyToLetComplaintInformation';
  public static readonly DirectCustomerBuyToLetEligibilityText = 'DirectCustomerBuyToLetEligibilityText';
  public static readonly DirectCustomerBuyToLetEligibilityTitle = 'DirectCustomerBuyToLetEligibilityTitle';
  public static readonly DirectCustomerBuyToLetEligibleQuestion = 'DirectCustomerBuyToLetEligibleQuestion';
  public static readonly DirectCustomerBuyToLetEligibleQuestionText = 'DirectCustomerBuyToLetEligibleQuestionText';
  public static readonly DirectCustomerBuyToLetExistingMortgageText = 'DirectCustomerBuyToLetExistingMortgageText';
  public static readonly DirectCustomerBuyToLetExistingMortgageTitle = 'DirectCustomerBuyToLetExistingMortgageTitle';
  public static readonly DirectCustomerBuyToLetFooterBody = 'DirectCustomerBuyToLetFooterBody';
  public static readonly DirectCustomerBuyToLetFooterMonitoring = 'DirectCustomerBuyToLetFooterMonitoring';
  public static readonly DirectCustomerBuyToLetFooterTitle = 'DirectCustomerBuyToLetFooterTitle';
  public static readonly DirectCustomerBuyToLetFullApplication = 'DirectCustomerBuyToLetFullApplication';
  public static readonly DirectCustomerBuyToLetFullApplicationText = 'DirectCustomerBuyToLetFullApplicationText';
  public static readonly DirectCustomerBuyToLetGettingStartedText = 'DirectCustomerBuyToLetGettingStartedText';
  public static readonly DirectCustomerBuyToLetIntroText = 'DirectCustomerBuyToLetIntroText';
  public static readonly DirectCustomerBuyToLetMortgageOffer = 'DirectCustomerBuyToLetMortgageOffer';
  public static readonly DirectCustomerBuyToLetMortgageOfferText = 'DirectCustomerBuyToLetMortgageOfferText';
  public static readonly DirectCustomerBuyToLetMortgageQuote = 'DirectCustomerBuyToLetMortgageQuote';
  public static readonly DirectCustomerBuyToLetMortgageQuoteText = 'DirectCustomerBuyToLetMortgageQuoteText';
  public static readonly DirectCustomerBuyToLetMortgagesInformation = 'DirectCustomerBuyToLetMortgagesInformation';
  public static readonly DirectCustomerBuyToLetPageTitle = 'DirectCustomerBuyToLetPageTitle';
  public static readonly DirectCustomerBuyToLetStepParagraph = 'DirectCustomerBuyToLetStepParagraph';
  public static readonly DirectCustomerBuyToLetStepTitle = 'DirectCustomerBuyToLetStepTitle';
  public static readonly DirectCustomerBuyToLetSupportingDocumentation =
    'DirectCustomerBuyToLetSupportingDocumentation';
  public static readonly DirectCustomerBuyToLetSupportingDocumentationText =
    'DirectCustomerBuyToLetSupportingDocumentationText';
  public static readonly DirectCustomerBuyToLetSwitchToText = 'DirectCustomerBuyToLetSwitchToText';
  public static readonly DirectCustomerBuyToLetSwitchToTitle = 'DirectCustomerBuyToLetSwitchToTitle';
  public static readonly DirectCustomerBuyToLetTehnicalHelpAndSupport = 'DirectCustomerBuyToLetTehnicalHelpAndSupport';
  public static readonly DirectCustomerBuyToLetUsefulToKnowText = 'DirectCustomerBuyToLetUsefulToKnowText';
  public static readonly DirectCustomerCHOPSFooterBody = 'DirectCustomerCHOPSFooterBody';
  public static readonly DirectCustomerChooseAnotherProduct = 'DirectCustomerChooseAnotherProduct';
  public static readonly DirectCustomerCloneQuote = 'DirectCustomerCloneQuote';
  public static readonly DirectCustomerConfirmButtonText = 'DirectCustomerConfirmButtonText';
  public static readonly DirectCustomerCreateNewQuoteDlgContentBuyToLet =
    'DirectCustomerCreateNewQuoteDlgContentBuyToLet';
  public static readonly DirectCustomerCreateNewQuoteDlgContentResidential =
    'DirectCustomerCreateNewQuoteDlgContentResidential';
  public static readonly DirectCustomerCreateNewQuoteDlgTitleBuyToLet = 'DirectCustomerCreateNewQuoteDlgTitleBuyToLet';
  public static readonly DirectCustomerCreateNewQuoteDlgTitleResidential =
    'DirectCustomerCreateNewQuoteDlgTitleResidential';
  public static readonly DirectCustomerDirectiveHeaderArrangementFee = 'DirectCustomerDirectiveHeaderArrangementFee';
  public static readonly DirectCustomerDirectiveHeaderMaxLTV = 'DirectCustomerDirectiveHeaderMaxLTV';
  public static readonly DirectCustomerDirectiveHeaderMonthlyRepayment =
    'DirectCustomerDirectiveHeaderMonthlyRepayment';
  public static readonly DirectCustomerDirectiveHeaderOverallCost = 'DirectCustomerDirectiveHeaderOverallCost';
  public static readonly DirectCustomerDirectiveHeaderRepaymentFee = 'DirectCustomerDirectiveHeaderRepaymentFee';
  public static readonly DirectCustomerFeesErrorMessage = 'DirectCustomerFeesErrorMessage';
  public static readonly DirectCustomerFeesErrorPopupTitle = 'DirectCustomerFeesErrorPopupTitle';
  public static readonly DirectCustomerFooterBody = 'DirectCustomerFooterBody';
  public static readonly DirectCustomerFooterMonitoring = 'DirectCustomerFooterMonitoring';
  public static readonly DirectCustomerFooterTitle = 'DirectCustomerFooterTitle';
  public static readonly DirectCustomerHeaderBuyToLetApplication = 'DirectCustomerHeaderBuyToLetApplication';
  public static readonly DirectCustomerHeaderResidentialApplication = 'DirectCustomerHeaderResidentialApplication';
  public static readonly DirectCustomerKfiIssuedInfoText = 'DirectCustomerKfiIssuedInfoText';
  public static readonly DirectCustomerMyMortagageHubAIPCertificateMessage =
    'DirectCustomerMyMortagageHubAIPCertificateMessage';
  public static readonly DirectCustomerMyMortgageHubAIP = 'DirectCustomerMyMortgageHubAIP';
  public static readonly DirectCustomerMyMortgageHubAIPDecisionLinkMessage =
    'DirectCustomerMyMortgageHubAIPDecisionLinkMessage';
  public static readonly DirectCustomerMyMortgageHubAIPMessage = 'DirectCustomerMyMortgageHubAIPMessage';
  public static readonly DirectCustomerMyMortgageHubAipProgressed = 'DirectCustomerMyMortgageHubAipProgressed';
  public static readonly DirectCustomerMyMortgageHubAppDetails = 'DirectCustomerMyMortgageHubAppDetails';
  public static readonly DirectCustomerMyMortgageHubApplicants = 'DirectCustomerMyMortgageHubApplicants';
  public static readonly DirectCustomerMyMortgageHubCompleteAip = 'DirectCustomerMyMortgageHubCompleteAip';
  public static readonly DirectCustomerMyMortgageHubCompleteFullApplication =
    'DirectCustomerMyMortgageHubCompleteFullApplication';
  public static readonly DirectCustomerMyMortgageHubCreateNewQuote = 'DirectCustomerMyMortgageHubCreateNewQuote';
  public static readonly DirectCustomerMyMortgageHubFullAppMessage = 'DirectCustomerMyMortgageHubFullAppMessage';
  public static readonly DirectCustomerMyMortgageHubFullApplication = 'DirectMortgageFullApplication';
  public static readonly DirectCustomerMyMortgageHubHeaderMessageArea = 'DirectCustomerMyMortgageHubHeaderMessageArea';
  public static readonly DirectCustomerMyMortgageHubHome = 'DirectCustomerMyMortgageHubHome';
  public static readonly DirectCustomerMyMortgageHubLTV = 'DirectCustomerMyMortgageLTV';
  public static readonly DirectCustomerMyMortgageHubMessages = 'DirectCustomerMyMortgageHubMessages';
  public static readonly DirectCustomerMyMortgageHubNeedHelp = 'DirectCustomerMyMortgageHubNeedHelp';
  public static readonly DirectCustomerMyMortgageHubNextStep = 'DirectCustomerMyMortgageHubNextStep';
  public static readonly DirectCustomerMyMortgageHubProfile = 'DirectCustomerMyMortgageHubProfile';
  public static readonly DirectCustomerMyMortgageHubPropertyAddress = 'DirectCustomerMyMortgageHubPropertyAddress';
  public static readonly DirectCustomerMyMortgageHubPropertyValue = 'DirectCustomerMyMortgageHubPropertyValue';
  public static readonly DirectCustomerMyMortgageHubQuoteProgressed = 'DirectCustomerMyMortgageHubQuoteProgressed';
  public static readonly DirectCustomerMyMortgageHubQuotes = 'DirectCustomerMyMortgageHubQuotes';
  public static readonly DirectCustomerMyMortgageHubQuotesMessage = 'DirectCustomerMyMortgageHubQuotesMessages';
  public static readonly DirectCustomerMyMortgageHubViewAipSubmission = 'DirectCustomerMyMortgageHubViewAipSubmission';
  public static readonly DirectCustomerNeedAdviceApplyOnline = 'DirectCustomerNeedAdviceApplyOnline';
  public static readonly DirectCustomerNeedAdviceApplyOnlineTitle = 'DirectCustomerNeedAdviceApplyOnlineTitle';
  public static readonly DirectCustomerNeedHelpFaqModalTitle = 'DirectCustomerNeedHelpFaqModalTitle';
  public static readonly DirectCustomerNeedHelpForSwitch = 'DirectCustomerNeedHelpForSwitch';
  public static readonly DirectCustomerNeedHelpInfo = 'DirectCustomerNeedHelpInfo';
  public static readonly DirectCustomerNeedHelpModalWindowTitle = 'DirectCustomerNeedHelpModalWindowTitle';
  public static readonly DirectCustomerNeedHelpRequestACallBack = 'DirectCustomerNeedHelpRequestACallBack';
  public static readonly DirectCustomerNeedHelpRequestACallBackInfo = 'DirectCustomerNeedHelpRequestACallBackInfo';
  public static readonly DirectCustomerNeedHelpRequestCallbackTitle = 'DirectCustomerNeedHelpRequestCallbackTitle';
  public static readonly DirectCustomerNextStepsTitle = 'DirectCustomerNextStepsTitle';

  public static readonly DirectCustomerOverviewMenu = 'DirectCustomerOverviewMenu';
  public static readonly DirectCustomerPluginDetectionWindowContent = 'DirectCustomerPluginDetectionWindowContent';
  public static readonly DirectCustomerPluginDetectionWindowTitle = 'DirectCustomerPluginDetectionWindowTitle';
  public static readonly DirectCustomerPrintPdf = 'DirectCustomerPrintPdf';
  public static readonly DirectCustomerPrivacyStatement = 'DirectCustomerPrivacyStatement';
  public static readonly DirectCustomerProductExpiredErrorMessage = 'DirectCustomerProductExpiredErrorMessage';
  public static readonly DirectCustomerProgressAppHeader = 'DirectCustomerProgressAppHeader';
  public static readonly DirectCustomerRegistrationAgreeTermsAndConditionsText =
    'DirectCustomerRegistrationAgreeTermsAndConditionsText';
  public static readonly DirectCustomerRegistrationIntroText = 'DirectCustomerRegistrationIntroText';
  public static readonly DirectCustomerRegistrationPageTitle = 'DirectCustomerRegistrationPageTitle';
  public static readonly DirectCustomerRegistrationTermsAndConditionsLinkText =
    'DirectCustomerRegistrationTermsAndConditionsLinkText';
  public static readonly DirectCustomerRegistrationTermsAndConditionsHeader =
    'DirectCustomerRegistrationTermsAndConditionsHeader';
  public static readonly DirectCustomerRegistrationTermsAndConditionsText =
    'DirectCustomerRegistrationTermsAndConditionsText';
  public static readonly DirectCustomerResidentialApply = 'DirectCustomerResidentialApply';
  public static readonly DirectCustomerResidentialApplyText = 'DirectCustomerResidentialApplyText';
  public static readonly DirectCustomerResidentialApprovalPrinciple = 'DirectCustomerResidentialApprovalPrinciple';
  public static readonly DirectCustomerResidentialApprovalPrincipleText =
    'DirectCustomerResidentialApprovalPrincipleText';
  public static readonly DirectCustomerResidentialComplaintInformation =
    'DirectCustomerResidentialComplaintInformation';
  public static readonly DirectCustomerResidentialContinueWithoutAdvice =
    'DirectCustomerResidentialContinueWithoutAdvice';
  public static readonly DirectCustomerResidentialDataCollection = 'DirectCustomerResidentialDataCollection';
  public static readonly DirectCustomerResidentialDataCollectionText = 'DirectCustomerResidentialDataCollectionText';
  public static readonly DirectCustomerResidentialEligibilityText = 'DirectCustomerResidentialEligibilityText';
  public static readonly DirectCustomerResidentialEligibilityTitle = 'DirectCustomerResidentialEligibilityTitle';
  public static readonly DirectCustomerResidentialEligibleQuestion = 'DirectCustomerResidentialEligibleQuestion';
  public static readonly DirectCustomerResidentialEligibleQuestionText =
    'DirectCustomerResidentialEligibleQuestionText';
  public static readonly DirectCustomerResidentialExistingMortgageText =
    'DirectCustomerResidentialExistingMortgageText';
  public static readonly DirectCustomerResidentialExistingMortgageTitle =
    'DirectCustomerResidentialExistingMortgageTitle';
  public static readonly DirectCustomerResidentialFooterBody = 'DirectCustomerResidentialFooterBody';
  public static readonly DirectCustomerResidentialFooterMonitoring = 'DirectCustomerResidentialFooterMonitoring';
  public static readonly DirectCustomerResidentialFooterTitle = 'DirectCustomerResidentialFooterTitle';
  public static readonly DirectCustomerResidentialFullApplication = 'DirectCustomerResidentialFullApplication';
  public static readonly DirectCustomerResidentialFullApplicationText = 'DirectCustomerResidentialFullApplicationText';
  public static readonly DirectCustomerResidentialGetAdvice = 'DirectCustomerResidentialGetAdvice';
  public static readonly DirectCustomerResidentialGettingStartedText = 'DirectCustomerResidentialGettingStartedText';
  public static readonly DirectCustomerResidentialIntroText = 'DirectCustomerResidentialIntroText';
  public static readonly DirectCustomerResidentialLookingForAdviceText =
    'DirectCustomerResidentialLookingForAdviceText';
  public static readonly DirectCustomerResidentialLookingForAdviceTitle =
    'DirectCustomerResidentialLookingForAdviceTitle';
  public static readonly DirectCustomerResidentialMortgageOffer = 'DirectCustomerResidentialMortgageOffer';
  public static readonly DirectCustomerResidentialMortgageOfferText = 'DirectCustomerResidentialMortgageOfferText';
  public static readonly DirectCustomerResidentialMortgageQuote = 'DirectCustomerResidentialMortgageQuote';
  public static readonly DirectCustomerResidentialMortgageQuoteText = 'DirectCustomerResidentialMortgageQuoteText';
  public static readonly DirectCustomerResidentialMortgagesInformation =
    'DirectCustomerResidentialMortgagesInformation';
  public static readonly DirectCustomerResidentialPageTitle = 'DirectCustomerResidentialPageTitle';
  public static readonly DirectCustomerResidentialProvideAdvice = 'DirectCustomerResidentialProvideAdvice';
  public static readonly DirectCustomerResidentialProvideAdviceText = 'DirectCustomerResidentialProvideAdviceText';
  public static readonly DirectCustomerResidentialStepOneTitle = 'DirectCustomerResidentialStepOneTitle';
  public static readonly DirectCustomerResidentialStepParagraph = 'DirectCustomerResidentialStepParagraph';
  public static readonly DirectCustomerResidentialStepTitle = 'DirectCustomerResidentialStepTitle';
  public static readonly DirectCustomerResidentialStepTwoTitle = 'DirectCustomerResidentialStepTwoTitle';
  public static readonly DirectCustomerResidentialSupportingDocumentation =
    'DirectCustomerResidentialSupportingDocumentation';
  public static readonly DirectCustomerResidentialSupportingDocumentationText =
    'DirectCustomerResidentialSupportingDocumentationText';
  public static readonly DirectCustomerResidentialSwitchToText = 'DirectCustomerResidentialSwitchToText';
  public static readonly DirectCustomerResidentialSwitchToTitle = 'DirectCustomerResidentialSwitchToTitle';
  public static readonly DirectCustomerResidentialTehnicalHelpAndSupport =
    'DirectCustomerResidentialTehnicalHelpAndSupport';
  public static readonly DirectCustomerResidentialUsefulToKnowText = 'DirectCustomerResidentialUsefulToKnowText';
  public static readonly DirectCustomerTypeOfMortgageCaption = 'DirectCustomerTypeOfMortgageCaption';
  public static readonly DirectCustomerTypeOfMortgageContent = 'DirectCustomerTypeOfMortgageContent';
  public static readonly DirectCustomerTypeOfMortgageValidationError = 'DirectCustomerTypeOfMortgageValidationError';
  public static readonly DirectCustomerTypeOfMortgageWarning = 'DirectCustomerTypeOfMortgageWarning';
  public static readonly DirectCustomerUnableToHelpPageContent = 'DirectCustomerUnableToHelpPageContent';
  public static readonly DirectCustomerUnableToHelpPageLink = 'DirectCustomerUnableToHelpPageLink';
  public static readonly DirectCustomerUnableToHelpPageLinkText = 'DirectCustomerUnableToHelpPageLinkText';
  public static readonly DirectCustomerUserDetailsTitle = 'DirectCustomerUserDetailsTitle';
  public static readonly DirectCustomerViewQuote = 'DirectCustomerViewQuote';
  public static readonly DirectCustomerWelcomeMessage = 'DirectCustomerWelcomeMessage';
  public static readonly DirectCustomerYourDocumentsAipBundle = 'DirectCustomerYourDocumentsAipBundle';
  public static readonly DirectCustomerYourDocumentsAipCertificate = 'DirectCustomerYourDocumentsAipCertificate';
  public static readonly DirectCustomerYourDocumentsAppBundle = 'DirectCustomerYourDocumentsAppBundle';
  public static readonly DirectCustomerYourDocumentsDescription = 'DirectCustomerYourDocumentsDescription';
  public static readonly DirectCustomerYourDocumentsFullApp = 'DirectCustomerYourDocumentsFullApp';
  public static readonly DirectCustomerYourDocumentsKfi = 'DirectCustomerYourDocumentsKfi';
  public static readonly DirectCustomerYourDocumentsNeedAdviceButton = 'DirectCustomerYourDocumentsNeedAdviceButton';
  public static readonly DirectCustomerYourDocumentsRecommendation = 'YourDocumentsRecommendation';
  public static readonly DirectCustomerYourDocumentsTitle = 'DirectCustomerYourDocumentsTitle';
  public static readonly DirectDebitAcceptancePdfDialogTitle = 'DirectDebitAcceptancePdfDialogTitle';
  public static readonly DirectDebitAcceptancePdfDialogWarning = 'DirectDebitAcceptancePdfDialogWarning';
  public static readonly DirectDebitDeclarationTitle = 'DirectDebitDeclarationTitle';
  public static readonly DirectDebitDescription = 'DirectDebitDescription';
  public static readonly DirectDebitDetails = 'DirectDebitDetails';
  public static readonly DirectDebitFormInformation = 'DirectDebitFormInformation';
  public static readonly DirectDebitGuarantee = 'DirectDebitGuarantee';
  public static readonly DirectDebitLastFourDigits = 'DirectDebitLastFourDigits';
  public static readonly DirectDebitNonAuthorizingCustomerAcceptedBy = 'DirectDebitNonAuthorizingCustomerAcceptedBy';
  public static readonly DirectDebitNonAuthorizingCustomerAcceptedByDescription =
    'DirectDebitNonAuthorizingCustomerAcceptedByDescription';
  public static readonly DirectDebitNonAuthorizingCustomerDescription = 'DirectDebitNonAuthorizingCustomerDescription';
  public static readonly DirectDebitSortCode = 'DirectDebitSortCode';
  public static readonly DisableFeatureWindow = 'DisableFeatureWindow';
  public static readonly DisablePackagingReceivedNotificationTasks = 'DisablePackagingReceivedNotificationTasks';
  public static readonly Discard = 'Discard';
  public static readonly DiscussWithAdvisor = 'DiscussWithAdvisor';
  public static readonly DiscussWithAdvisorContactUs = 'DiscussWithAdvisorContactUs';
  public static readonly DiscussWithAdvisorTelephoneNumber = 'DiscussWithAdvisorTelephoneNumber';
  public static readonly DiscussWithAdvisorTelephoneNumberDescription = 'DiscussWithAdvisorTelephoneNumberDescription';
  public static readonly DistributedDocumentAddedOn = 'DistributedDocumentAddedOn';
  public static readonly DistributedDocumentConfirmRemove = 'DistributedDocumentConfirmRemove';
  public static readonly DistributedDocumentConfirmUpload = 'DistributedDocumentConfirmUpload';
  public static readonly DistributedDocumentDeletedOn = 'DistributedDocumentDeletedOn';
  public static readonly DistributedDocumentRemoveDetails = 'DistributedDocumentRemoveDetails';
  public static readonly DistributedDocumentRemoveWarningContent = 'DistributedDocumentRemoveWarningContent';
  public static readonly DistributedDocumentRemoveWarningTitle = 'DistributedDocumentRemoveWarningTitle';
  public static readonly DistributedDocumentRemovedBy = 'DistributedDocumentRemovedBy';
  public static readonly DistributedDocumentUploadDetails = 'DistributedDocumentUploadDetails';
  public static readonly DistributedDocumentUploadWarningContent = 'DistributedDocumentUploadWarningContent';
  public static readonly DistributedDocumentUploadWarningTitle = 'DistributedDocumentUploadWarningTitle';
  public static readonly DistributedDocumentUploadedBy = 'DistributedDocumentUploadedBy';
  public static readonly DistributedDocumentViewDetails = 'DistributedDocumentViewDetails';
  public static readonly DistributedDocumentsTab = 'DistributedDocumentsTab';
  public static readonly DistributedDocumentsUploadRomeIdWarningMessage =
    'DistributedDocumentsUploadRomeIdWarningMessage';
  public static readonly DistributedDocumentsUploadSamIdWarningMessage =
    'DistributedDocumentsUploadSamIdWarningMessage';
  public static readonly DistributedDocumentsUploadWarningMessage = 'DistributedDocumentsUploadWarningMessage';
  public static readonly DistributedFileSelect = 'DistributedFileSelect';
  public static readonly DistributedUploadDocumentType = 'DistributedUploadDocumentType';
  public static readonly DistributedUploadFileDescription = 'DistributedUploadFileDescription';
  public static readonly DistributedUploadFileDescriptionTooltip = 'DistributedUploadFileDescriptionTooltip';
  public static readonly DistributedUploadModalHeader = 'DistributedUploadModalHeader';
  public static readonly DistributedUploadTitle = 'DistributedUploadTitle';
  public static readonly DistributionChannelForcedToPostalDueToBankVerificationFailure =
    'DistributionChannelForcedToPostalDueToBankVerificationFailure';
  public static readonly DoNotExpireThisDocument = 'DoNotExpireThisDocument';
  public static readonly DoYouHaveAMortgageOnThisProperId = 'MortgageOnThisProperty';
  public static readonly DoYouOwn25OrMoreOfSharesInYouId = 'Own25percent';
  public static readonly DocumentAlertAllCases = 'DocumentAlertAllCases';
  public static readonly DocumentAlertCase = 'DocumentAlertCase';
  public static readonly DocumentAlertNoNotifications = 'DocumentAlertNoNotifications';
  public static readonly DocumentAlertUnchecked = 'DocumentAlertUnchecked';
  public static readonly DocumentChecked = 'DocumentChecked';
  public static readonly DocumentFailedToUpload = 'DocumentFailedToUpload';
  public static readonly DocumentReceivedByPost = 'DocumentReceivedByPost';
  public static readonly DocumentType = 'DocumentType';
  public static readonly DocumentUploadCaseClosedMessage = 'DocumentUploadCaseClosedMessage';
  public static readonly DocumentUploadCertificationConfirmation = 'DocumentUploadCertificationConfirmation';
  public static readonly DocumentUploadFailedMessage = 'DocumentUploadFailedMessage';
  public static readonly DocumentUploadHelp = 'DocumentUploadHelp';
  public static readonly DocumentUploadHelpDescription = 'DocumentUploadHelpDescription';
  public static readonly DocumentUploadInterruptedMessage = 'DocumentUploadInterruptedMessage';
  public static readonly DocumentUploadNotAllowedAllFirmsMessage = 'DocumentUploadNotAllowedAllFirmsMessage';
  public static readonly DocumentUploadNotAllowedForFirmMessage = 'DocumentUploadNotAllowedForFirmMessage';
  public static readonly DocumentVersion = 'DocumentVersion';
  public static readonly Documents = 'Documents';
  public static readonly DocumentsDescription = 'DocumentsDescription';
  public static readonly DocumentsUploadNoDescriptionPlaceholder = 'DocumentsUploadNoDescriptionPlaceholder';
  public static readonly DocumentsUploadWindowTitle = 'DocumentsUploadWindowTitle';
  public static readonly DomainUsername = 'DomainUsername';
  public static readonly DownloadDirectDebitGuarantee = 'DownloadDirectDebitGuarantee';
  public static readonly DownloadDraftReport = 'DownloadDraftReport';
  public static readonly DownloadOfferExecutionOnlyDeclaration = 'DownloadOfferExecutionOnlyDeclaration';
  public static readonly DownloadOfferInvestmentPropertyLoanDeclaration =
    'DownloadOfferInvestmentPropertyLoanDeclaration';
  public static readonly DropdownVirtualOfficeActions = 'DropdownVirtualOfficeActions';
  public static readonly Due = 'Due';
  public static readonly DueToBankAccountVerificationFailed = 'DueToBankAccountVerificationFailed';
  public static readonly DuplicateProduct = 'DuplicateProduct';
  public static readonly DuplicatingProduct = 'DuplicatingProduct';
  public static readonly EFT = 'EFT';
  public static readonly ERCAmount = 'ERCAmount';
  public static readonly ERCEndDate = 'ERCEndDate';
  public static readonly Edit = 'Edit';
  public static readonly EditApplicationWarningBody = 'EditApplicationWarningBody';
  public static readonly EditApplicationWarningHeader = 'EditApplicationWarningHeader';
  public static readonly EditApplicationWarningSubmitButton = 'EditApplicationWarningSubmitButton';
  public static readonly EditApplicationWarningTitle = 'EditApplicationWarningTitle';
  public static readonly EditEmailAddress = 'EditEmailAddress';
  public static readonly EditEmailAddressTitle = 'EditEmailAddressTitle';
  public static readonly EditFactFind1Data = 'EditFactFind1Data';
  public static readonly EditFactFind1WarningBody = 'EditFactFind1WarningBody';
  public static readonly EditFactFind1WarningHeader = 'EditFactFind1WarningHeader';
  public static readonly EditFactFind1WarningSubmitButton = 'EditFactFind1WarningSubmitButton';
  public static readonly EditFactFind1WarningTitle = 'EditFactFind1WarningTitle';
  public static readonly EditFactFind2 = 'EditFactFind2';
  public static readonly EditFactFindData = 'EditFactFindData';
  public static readonly EditIncompleteAip = 'EditIncompleteAip';
  public static readonly EditIncompleteApp = 'EditIncompleteApp';
  public static readonly EPCDateIssued = 'EPCDateIssued';
  public static readonly EPCRating = 'EPCRating';
  public static readonly EPCRatingBTLWarningBody = 'EPCRatingBTLWarningBody';
  public static readonly EPCRatingBTLWarningModalBody = 'EPCRatingBTLWarningModalBody';
  public static readonly EPCRatingBTLWarningModalButton = 'EPCRatingBTLWarningModalButton';
  public static readonly EPCRatingBTLWarningModalTitle = 'EPCRatingBTLWarningModalTitle';
  public static readonly EPCRatingNotQualifyInfo = 'EPCRatingNotQualifyInfo';
  public static readonly EPCRemortgageProductPicker = 'EPCRemortgageProductPicker';
  public static readonly EditIncompleteKFI = 'EditIncompleteKFI';
  public static readonly EditKfi = 'EditKfi';
  public static readonly EditPhoneNumber = 'EditPhoneNumber';
  public static readonly EditPhoneNumberTitle = 'EditPhoneNumberTitle';
  public static readonly EditSuitabilityReport = 'EditSuitabilityReport';
  public static readonly EditThisApplication = 'EditThisApplication';
  public static readonly EditWindowSubtitle = 'EditWindowSubtitle';
  public static readonly EditWindowTitle = 'EditWindowTitle';
  public static readonly EligibilityInterestOnlyQuestion = 'EligibilityInterestOnlyQuestion';
  public static readonly EligibilityInterestOnlyValidAssetsQuestion = 'EligibilityInterestOnlyValidAssetsQuestion';
  public static readonly EligibilityIsHelpToBuyQuestion = 'EligibilityIsHelpToBuyQuestion';
  public static readonly EligibilityPropertyTypeQuestion = 'EligibilityPropertyTypeQuestion';
  public static readonly EligibilityRemortgagingQuestion = 'EligibilityRemortgagingQuestion';
  public static readonly Email = 'Email';
  public static readonly EmailAddressId = 'EmailAddress';
  public static readonly EmailAlreadyConfirmedIntroduction = 'EmailAlreadyConfirmedIntroduction';
  public static readonly EmailAlreadyConfirmedSubtitle = 'EmailAlreadyConfirmedSubtitle';
  public static readonly EmailConfirmationError = 'EmailConfirmationError';
  public static readonly EmailRegisteredContent = 'EmailRegisteredContent';
  public static readonly EmailRegisteredTitle = 'EmailRegisteredTitle';
  public static readonly EmailResent = 'EmailResent';
  public static readonly EmailSuccessfullyConfirmed = 'EmailSuccessfullyConfirmed';
  public static readonly EmailUpdateConfirmationFailed = 'EmailUpdateConfirmationFailed';
  public static readonly EmailUpdateConfirmationSuccessfulIntroduction =
    'EmailUpdateConfirmationSuccessfulIntroduction';
  public static readonly EmailUpdateConfirmationSuccessfulSubtitle = 'EmailUpdateConfirmationSuccessfulSubtitle';
  public static readonly EmailUsername = 'EmailUsername';
  public static readonly EmailVerificationLabel = 'EmailVerificationLabel';
  public static readonly EmailVerificationLinkExpired = 'EmailVerificationLinkExpired';
  public static readonly EmailVerificationLinkExpiredValidation = 'EmailVerificationLinkExpiredValidation';
  public static readonly EmailVerificationLinkExpiredRegistration = 'EmailVerificationLinkExpiredRegistration';
  public static readonly EmailWillBeSent = 'EmailWillBeSent';
  public static readonly EmployeeNumberId = 'EmployeeNumber';
  public static readonly Employment = 'Employment';
  public static readonly EmploymentStatusId = 'EmploymentStatus';
  public static readonly EmploymentStatusInformation = 'EmploymentStatusInformation';
  public static readonly EnablePackagingReceivedNotificationTasks = 'EnablePackagingReceivedNotificationTasks';
  public static readonly EndDate = 'EndDate';
  public static readonly EnterEmailAddress = 'EnterEmailAddress';
  public static readonly EPCDateIssuedRemortgage = 'EPCDateIssuedRemortgage';
  public static readonly ERCFeeLabel = 'ERCFeeLabel';
  public static readonly ERCFeesApplicableInformation = 'ERCFeesApplicableInformation';
  public static readonly ErrorIncorrectPassword = 'IncorrectPassword';
  public static readonly ErrorTitle = 'ErrorTitle';
  public static readonly EstateAgentDetailsHeader = 'EstateAgentDetailsHeader';
  public static readonly EstateAgentName = 'EstateAgentName';
  public static readonly EstateAgentTelephoneNumber = 'EstateAgentTelephoneNumber';
  public static readonly EstimatedFurnishedMonthlyRental = 'EstimatedFurnishedMonthlyRental';
  public static readonly EstimatedPropertyAmount = 'EstimatedPropertyAmount';
  public static readonly EstimatedPropertyValue = 'EstimatedPropertyValue';
  public static readonly EstimatedUnfurnishedMonthlyRental = 'EstimatedUnfurnishedMonthlyRental';
  public static readonly EventsWhichAffectExpenditure = 'EventsWhichAffectExpenditure';
  public static readonly EventsWhichAffectIncome = 'EventsWhichAffectIncome';
  public static readonly ExceededMaximumOtpSendLimitErrorMessage = 'ExceededMaximumOtpSendLimitErrorMessage';
  public static readonly ExclusiveDocumentAllreadyUploaded = 'ExclusiveDocumentAllreadyUploaded';
  public static readonly ExecutionOnlyConsentAcceptAndContinue = 'ExecutionOnlyConsentAcceptAndContinue';
  public static readonly ExecutionOnlyConsentGetAdvice = 'ExecutionOnlyConsentGetAdvice';
  public static readonly ExecutionOnlyConsentGetHelp = 'ExecutionOnlyConsentGetHelp';
  public static readonly ExecutionOnlyConsentNote = 'ExecutionOnlyConsentNote';
  public static readonly ExecutionOnlyConsentPdfUrl = 'ExecutionOnlyConsentPdfUrl';
  public static readonly ExecutionOnlyConsentTitle = 'ExecutionOnlyConsentTitle';
  public static readonly ExecutionOnlyConsentWindowTitle = 'ExecutionOnlyConsentWindowTitle';
  public static readonly ExecutionOnlyDeclaration = 'ExecutionOnlyDeclaration';
  public static readonly ExecutionOnlyDeclarationConfirmation = 'ExecutionOnlyDeclarationConfirmation';
  public static readonly ExecutionOnlyDeclarationReadMore = 'ExecutionOnlyDeclarationReadMore';
  public static readonly ExecutionOnlyDeclarationUrl = 'ExecutionOnlyDeclarationUrl';
  public static readonly ExistingCustomer = 'ExistingCustomer';
  public static readonly ExistingCustomerDetails = 'ExistingCustomerDetails';
  public static readonly ExistingCustomerLastPayment = 'ExistingCustomerLastPayment';
  public static readonly ExistingMortgageDetails = 'ExistingMortgageDetails';
  public static readonly ExistingCustomerAlreadyRegisteredTitle = 'ExistingCustomerAlreadyRegisteredTitle';
  public static readonly ExistingCustomerAlreadyRegisteredContent = 'ExistingCustomerAlreadyRegisteredContent';
  public static readonly ExistingCustomerPasswordSaveSuccess = 'ExistingCustomerPasswordSaveSuccess';
  public static readonly ExistingCustomerPasswordSaveFailed = 'ExistingCustomerPasswordSaveFailed';
  public static readonly ExistingCustomerRegistrationContactDetailsOverrideInfo =
    'ExistingCustomerRegistrationContactDetailsOverrideInfo';
  public static readonly ExpiredLink = 'ExpiredLink';
  public static readonly ExpiredPassword = 'ExpiredPassword';
  public static readonly ExpiredPasswordDescription = 'ExpiredPasswordDescription';
  public static readonly ExpiredProductLozenge = 'ExpiredProductLozenge';
  public static readonly CustomerVerificationNewPassword = 'CustomerVerificationNewPassword';
  public static readonly CustomerVerificationNewPasswordDescription = 'CustomerVerificationNewPasswordDescription';
  public static readonly Export = 'Export';
  public static readonly FAQs = 'FAQs';
  public static readonly FCAFirm = 'FCAFirm';
  public static readonly FCANumberNotSearched = 'FCANumberNotSearched';
  public static readonly FaceToFaceConversation = 'FaceToFaceConversation';
  public static readonly FactFind = 'FactFind';
  public static readonly FactFind2InfoText = 'FactFind2InfoText';
  public static readonly FactFind2OtherDetails = 'FactFind2OtherDetails';
  public static readonly FactFind2Title = 'FactFind2Title';
  public static readonly FactFindData = 'FactFindData';
  public static readonly FactFindEditObsoleteFieldNotificationText = 'FactFindEditObsoleteFieldNotificationText';
  public static readonly FactFindEditObsoleteFieldNotificationTitle = 'FactFindEditObsoleteFieldNotificationTitle';
  public static readonly FactFindInformation = 'FactFindInformation';
  public static readonly FactFindInformationDescription = 'FactFindInformationDescription';
  public static readonly FactFindsShowTheLastTwo = 'FactFindsShowTheLastTwo';
  public static readonly Fail = 'Fail';
  public static readonly FailedLogins = 'FailedLogins';
  public static readonly FaxPhoneNo = 'FaxPhoneNo';
  public static readonly FcaFirmMortgageClubsAllowAppRep = 'FcaFirmMortgageClubsAllowAppRep';
  public static readonly FcaFirmMortgageClubsAllowIntermediaries = 'FcaFirmMortgageClubsAllowIntermediaries';
  public static readonly FcaFirmMortgageClubsAppRepCan = 'FcaFirmMortgageClubsAppRepCan';
  public static readonly FcaFirmMortgageClubsAppRepMust = 'FcaFirmMortgageClubsAppRepMust';
  public static readonly FcaFirmMortgageClubsHeader = 'FcaFirmMortgageClubsHeader';
  public static readonly FcaFirmMortgageClubsIntermediariesCan = 'FcaFirmMortgageClubsIntermediariesCan';
  public static readonly FcaFirmMortgageClubsIntermediariesMust = 'FcaFirmMortgageClubsIntermediariesMust';
  public static readonly FcaNumber = 'FcaNumber';
  public static readonly FeatureReleaseVersion = 'FeatureReleaseVersion';
  public static readonly FeatureWindow = 'FeatureWindow';
  public static readonly FeeAddedToThisLoan = 'FeeAddedToThisLoan';
  public static readonly FeeCodeText = 'FeeCodeText';
  public static readonly FeePayableAtApplicationId = 'FeePayableAtApplication';
  public static readonly FeePayableAtCompletionId = 'FeePayableAtCompletion';
  public static readonly FeePayableAtOfferId = 'FeePayableAtOffer';
  public static readonly FeeRefundable = 'FeeRefundable';
  public static readonly FeesApplicantsText = 'FeesApplicantsText';
  public static readonly FeesFreeTextPurchase = 'FeesFreeTextPurchase';
  public static readonly FeesFreeTextRemortgage = 'FeesFreeTextRemortgage';
  public static readonly FeesNotPaidInTimeDescription = 'FeesNotPaidInTimeDescription';
  public static readonly FeesOriginallyPaidOn = 'FeesOriginallyPaidOn';
  public static readonly FeesOutOfDateWarning = 'FeesOutOfDateWarning';
  public static readonly FeesPaidDescription = 'FeesPaidDescription';
  public static readonly FeesPaidOffline = 'FeesPaidOffline';
  public static readonly FeesPaidOn = 'FeesPaidOn';
  public static readonly FeesRefundStatement1 = 'FeesRefundStatement1';
  public static readonly FeesRefundStatement2 = 'FeesRefundStatement2';
  public static readonly FeesRefundStatement3 = 'FeesRefundStatement3';
  public static readonly FeesRefundedDescription = 'FeesRefundedDescription';
  public static readonly FeesRefundedOffline = 'FeesRefundedOffline';
  public static readonly FeesRefundedOn = 'FeesRefundedOn';
  public static readonly FeesToPay = 'FeesToPay';
  public static readonly FeesUnpaidDescription = 'FeesUnpaidDescription';
  public static readonly FeesUnpaidInTimePart1 = 'FeesUnpaidInTimePart1';
  public static readonly FeesUnpaidInTimePart2 = 'FeesUnpaidInTimePart2';
  public static readonly FeesUnpaidInTimePart3 = 'FeesUnpaidInTimePart3';
  public static readonly FemaleId = 'Female';
  public static readonly FileDescription = 'FileDescription';
  public static readonly FileSelect = 'FileSelect';
  public static readonly FileUploadDescriptionTooltip = 'FileUploadDescriptionTooltip';
  public static readonly FilterBy = 'FilterBy';
  public static readonly FilteringOptions = 'FilteringOptions';
  public static readonly FinaliseSubmission = 'FinaliseSubmission';
  public static readonly FindAddressId = 'FindAddress';
  public static readonly FindOutHowToGetAdvice = 'FindOutHowToGetAdvice';
  public static readonly FindOutHowToGetAdviceTitle = 'FindOutHowToGetAdviceTitle';
  public static readonly FindOutHowToGetAdviceContent = 'FindOutHowToGetAdviceContent';
  public static readonly FinishAndSubmit = 'FinishAndSubmit';
  public static readonly FirmAdminGroup = 'FirmAdminGroup';
  public static readonly FirmDelegationLevel = 'FirmDelegationLevel';
  public static readonly FirmDetails = 'FsaFirmDetails';
  public static readonly FirmDetailsAllowedMortgageClubs = 'FsaFirmDetailsAllowedMortgageClubs';
  public static readonly FirmDetailsBusinessType = 'FsaFirmDetailsBusinessType';
  public static readonly FirmDetailsFirm = 'FsaFirmDetailsFirm';
  public static readonly FirmDetailsInternalNumber = 'FirmInternalNumber';
  public static readonly FirmDetailsNotes = 'FsaFirmDetailsNotes';
  public static readonly FirmDetailsNotesAddPlaceholder = 'FsaFirmDetailsAddNotesPlaceholder';
  public static readonly FirmDetailsNotesBy = 'FsaFirmDetailsNotesBy';
  public static readonly FirmDetailsNotesCreated = 'FsaFirmDetailsNotesCreated';
  public static readonly FirmDetailsPrincipal = 'FsaFirmDetailsPrincipal';
  public static readonly FirmDetailsPropositionAllowAccess = 'FsaFirmDetailsAllowAccess';
  public static readonly FirmDetailsPropositionAvailableDate = 'FsaFirmDetailsPropositionAvailableDate';
  public static readonly FirmDetailsPropositionCompanyStartDate = 'FsaFirmDetailsCompanyStartDate';
  public static readonly FirmDetailsPropositionDetails = 'FsaFirmDetailsPropositionDetails';
  public static readonly FirmDetailsPropositionDocumentUpload = 'FsaFirmDocumentUpload';
  public static readonly FirmDetailsPropositionDocumentUploadAllowed = 'FsaFirmDocumentUploadAllowed';
  public static readonly FirmDetailsPropositionDocumentUploadDenied = 'FsaFirmDocumentUploadDenied';
  public static readonly FirmDetailsPropositionDocumentUploadInheritAllow = 'FsaFirmDocumentUploadInheritAllow';
  public static readonly FirmDetailsPropositionDocumentUploadInheritDeny = 'FsaFirmDocumentUploadInheritDenied';
  public static readonly FirmDetailsPropositionRegistrationText = 'FsaFirmDetailsRegistrationText';
  public static readonly FirmDetailsPropositionRegistrationTextPlaceholder =
    'FsaFirmDetailsRegistrationTextPlaceholder';
  public static readonly FirmDetailsPropositionStatus = 'FsaFirmDetailsPropositionStatus';
  public static readonly FirmDetailsStatus = 'FsaFirmDetailsStatus';
  public static readonly FirmDetailsTradingNames = 'FsaFirmDetailsTradingNames';
  public static readonly FirmName = 'FirmName';
  public static readonly FirstName = 'FirstName';
  public static readonly FirstNameAsPerId = 'FirstNameAsPerId';
  public static readonly FirstTimeBuyer = 'FirstTimeBuyer';
  public static readonly FlagCaseMaterialsChanged = 'FlagCaseMaterialsChanged';
  public static readonly FooterNote = 'FooterNote';
  public static readonly For = 'For';
  public static readonly ForSavedSearchName = 'ForSavedSearchName';
  public static readonly ForceChangePassword = 'ForceChangePassword';
  public static readonly Forename = 'Forename';
  public static readonly ForgotPassword = 'ForgotPassword';
  public static readonly ForgottenEmailAddress = 'ForgottenEmailAddress';
  public static readonly FosteringIncome = 'FosteringIncome';
  public static readonly Frn = 'FRN';
  public static readonly FrnNumber = 'FrnNumber';
  public static readonly From = 'From';
  public static readonly FsaFirmAddATemporaryRecord = 'FsaFirmAddATemporaryRecord';
  public static readonly FsaFirmColumnName = 'FsaFirmColumnName';
  public static readonly FsaFirmFSA = 'FsaFirmFSA';
  public static readonly FsaFirmNotFoundOrNotPrincipal = 'FsaFirmNotFoundOrNotPrincipal';
  public static readonly FsaFirmPrincipalFCANumber = 'FsaFirmPrincipalFCANumber';
  public static readonly FsaFirmPrincipalName = 'FsaFirmPrincipalName';
  public static readonly FsaFirmSearch = 'FsaFirmSearch';
  public static readonly FsaFirmSearchByAdminGroup = 'FsaFirmSearchByAdminGroup';
  public static readonly FsaFirmSearchByPrincipal = 'FsaFirmSearchByPrincipal';
  public static readonly FsaFirmSearchByProposition = 'FsaFirmSearchByProposition';
  public static readonly FsaFirmSearchByStatus = 'FsaFirmSearchByStatus';
  public static readonly FsaFirmSearchCompanyName = 'FsaFirmSearchCompanyName';
  public static readonly FsaFirmSearchFSANumber = 'FsaFirmSearchFSANumber';
  public static readonly FsaFirmSearchWithRegisteredIntermediaries = 'FsaFirmSearchWithRegisteredIntermediaries';
  public static readonly FsaFirmStatus = 'FsaFirmStatus';
  public static readonly FsaFirmTemporaryAllowMortgageClubs = 'FsaFirmTemporaryAllowMortgageClubs';
  public static readonly FsaFirmTemporaryAuditName = 'FsaFirmTemporaryAuditName';
  public static readonly FsaFirmTemporaryBusinessType = 'FsaFirmTemporaryBusinessType';
  public static readonly FsaFirmTemporaryCancel = 'FsaFirmTemporaryCancel';
  public static readonly FsaFirmTemporaryDetails = 'FsaFirmTemporaryDetails';
  public static readonly FsaFirmTemporaryEnterFRN = 'FsaFirmTemporaryEnterFRN';
  public static readonly FsaFirmTemporaryName = 'FsaFirmTemporaryName';
  public static readonly FsaFirmTemporaryNotAvailable = 'FsaFirmTemporaryNotAvailable';
  public static readonly FsaFirmTemporaryPrincipalNumber = 'FsaFirmTemporaryPrincipalNumber';
  public static readonly FsaFirmTemporarySave = 'FsaFirmTemporarySave';
  public static readonly FsaFirmTemporaryStatus = 'FsaFirmTemporaryStatus';
  public static readonly FsaFirmTemporarySuccessfulSaveNotification = 'FsaFirmTemporarySuccessfulSaveNotification';
  public static readonly FsaFirmType = 'FsaFirmType';
  public static readonly FutureCorrespondence = 'FutureCorrespondence';
  public static readonly FutureMonthlyPayment = 'FutureMonthlyPayment';
  public static readonly FutureTerm = 'FutureTerm';
  public static readonly FutureTotalMonthlyPayment = 'FutureTotalMonthlyPayment';
  public static readonly GDPRPrivacyNotice = 'GDPRPrivacyNotice';
  public static readonly GDPRPrivacyNoticeConsent = 'GDPRPrivacyNoticeConsent';
  public static readonly GDPRProfileNotification = 'GDPRProfileNotification';
  public static readonly GdprFilename = 'GdprFilename';
  public static readonly GdprModalTitle = 'GdprModalTitle';
  public static readonly GdprPolicyLogoHeader = 'GdprPolicyLogoHeader';
  public static readonly GdprPrivacyTitle = 'GdprPrivacyTitle';
  public static readonly GenderId = 'Sex';
  public static readonly GenerateAccessCodeLetter = 'GenerateAccessCodeLetter';
  public static readonly GenerateKfi = 'GenerateKfi';
  public static readonly GenerateKfiFromCase = 'GenerateKfiFromCase';
  public static readonly GenerateReport = 'GenerateReport';
  public static readonly GenericInvalidFieldError = 'GenericInvalidFieldError';
  public static readonly GiftDetailsSectionLabel = 'GiftDetailsSectionLabel';
  public static readonly GoBackToAdviceTab = 'GoBackToAdviceTab';
  public static readonly GoBackToCaseSummary = 'GoBackToCaseSummary';
  public static readonly GoToBankUKWebsite = 'GoToBankUKWebsite';
  public static readonly GoToCaseHub = 'GoToCaseHub';
  public static readonly GoToDesktopAppCoversheetText = 'GoToDesktopAppCoversheetText';
  public static readonly GoToDesktopAppText = 'GoToDesktopAppText';
  public static readonly GoToDesktopAppTitle = 'GoToDesktopAppTitle';
  public static readonly GoToLoginFromLogout = 'GoToLoginFromLogout';
  public static readonly GoToLoginPage = 'GoToLoginPage';
  public static readonly GoToMyMortgageHub = 'GoToMyMortgageHub';
  public static readonly GoToPreviousPage = 'GoToPreviousPage';
  public static readonly GoToUserProfileButton = 'GoToUserProfileButton';
  public static readonly GrossAnnualContractIncome = 'GrossAnnualContractIncome';
  public static readonly HRAddress = 'HRAddress';
  public static readonly HadIntentionToRentToStrangersCode = 'HadIntentionToRentToStrangersCode';
  public static readonly Has2YearsAccounts = 'Has2YearsAccounts';
  public static readonly HasAccountForPreviousFinancialYea = 'HasAccountForPreviousFinancialYea';
  public static readonly HasAnAccountant = 'HasAnAccountant';
  public static readonly HasDifferentHRAddress = 'HasDifferentHRAddress';
  public static readonly HasExternalUserConsent = 'HasExternalUserConsent';
  public static readonly HasIncomeFromOutsideUKCode = 'HasIncomeFromOutsideUKCode';
  public static readonly HasMortgageAnERC = 'HasMortgageAnERC';
  public static readonly HaveYouChosenASolicitor = 'HaveYouChosenASolicitor';
  public static readonly HaveYouEverBeenDeclaredBankrupt = 'HaveYouEverBeenDeclaredBankrupt';
  public static readonly HaveYouEverHadAMortgage = 'HaveYouEverHadAMortgage';
  public static readonly HaveYouEverMadeArrangements = 'HaveYouEverMadeArrangements';
  public static readonly HaveYouLivedOnThisPropertyCode = 'HaveYouLivedOnThisPropertyCode';
  public static readonly HaveYourEverBeenInArrears = 'HaveYourEverBeenInArrears';
  public static readonly HeldResidentialMortgage = 'HeldResidentialMortgage';
  public static readonly Help = 'Help';
  public static readonly HelpApplicationDepositSourceTypes = 'ApplicationDepositSourceTypes';
  public static readonly HelpApplicationDepositSourceTypesForRemortgage = 'ApplicationDepositSourceTypesForRemortgage';
  public static readonly HelpCenterAccessibility = 'HelpCenterAccessibility';
  public static readonly HelpCenterPolicies = 'HelpCenterPolicies';
  public static readonly HelpCenterPrivacy = 'HelpCenterPrivacy';
  public static readonly HelpCenterPrivacyContent = 'HelpCenterPrivacyContent';
  public static readonly HelpCenterSectionContains = 'HelpCenterSectionContains';
  public static readonly HelpCenterWebAccessibility = 'HelpCenterWebAccessibility';
  public static readonly HelpCenterWebAccessibilityContent = 'HelpCenterWebAccessibilityContent';
  public static readonly HelpCentre = 'HelpCentre';
  public static readonly HelpContent1 = 'HelpContent1';
  public static readonly HelpContent2 = 'HelpContent2';
  public static readonly HelpContent3 = 'HelpContent3';
  public static readonly HelpCurrentMarginalTaxRateCode = 'CurrentMarginalTaxRateCode';
  public static readonly HelpIncomeFromOutsideUK = 'IncomeFromOutsideUK';
  public static readonly HelpNewMonthlyMortgagePaymentPrediction = 'NewMonthlyMortgagePaymentPrediction';
  public static readonly HelpNewOutstandingBalancePrediction = 'NewOutstandingBalancePrediction';
  public static readonly HelpRemortgageCurrentResidentialPropertyCode = 'RemortgageCurrentResidentialPropertyCode';
  public static readonly HelpSourcesOfWealth = 'SourceOfWealth';
  public static readonly HelpTotalBalanceOutstandingBtlMortgage = 'TotalBalanceOutstandingBtlMortgage';
  public static readonly HelpTotalMonthlyRentalIncomeBtl = 'TotalMonthlyRentalIncomeBtl';
  public static readonly HideIgnored = 'HideIgnored';
  public static readonly HideRegistrationTermsAndConditions = 'HideRegistrationTermsAndConditions';
  public static readonly HigherLendingChargeId = 'HigherLendingCharge';
  public static readonly HoldAnyBTL = 'HoldAnyBTL';
  public static readonly HoldAnyNonBTL = 'HoldAnyNonBTL';
  public static readonly HoldMortgageOnBTL = 'HoldMortgageOnBTL';
  public static readonly HoldMortgageOnSponsorProperty = 'HoldMortgageOnSponsorProperty';
  public static readonly HomePhoneNumberId = 'HomePhoneNumber';
  public static readonly HowLongHaveYouBeenInThisSectorAsContractor = 'HowLongHaveYouBeenInThisSectorAsContractor';
  public static readonly HowLongHaveYouBeenWithThisLendId = 'HowLongWithLender';
  public static readonly HowLongHaveYouLivedHereId = 'HowLongLivedHere';
  public static readonly HowLongHaveYouWorkedForThisEmpId = 'HowLongWithThisEmployer';
  public static readonly HowLongLivedHere = 'HowLongLivedHere';
  public static readonly HowLongWithLender = 'HowLongWithLender';
  public static readonly HowLongWithThisEmployer = 'HowLongWithThisEmployer';
  public static readonly HowManyBtlInTotal = 'HowManyBtlInTotal';
  public static readonly HowManyBtlMortgages = 'HowManyBtlMortgages';
  public static readonly HowManyBtlWithUs = 'HowManyBtlWithUs';
  public static readonly HowManyOtherBTL = 'HowManyOtherBTL';
  public static readonly HowManyOtherNonBTL = 'HowManyOtherNonBTL';
  public static readonly HowManyPeopleOverTheAgeOf17WhoId = 'NoPeopleAgedOver17';
  public static readonly HowManyStoreysAreThereInBlock = 'HowManyStoreysAreThereInBlock';
  public static readonly HowManyWillYouHoldId = 'HowManyOtherNonBTL';
  public static readonly HowManyYearsWithLender = 'HowManyYearsWithLender';
  public static readonly HowMuchDoYouCurrentlyOweOnThePId = 'AmountOwedOnCurrentProperty';
  public static readonly HowRepayInterest = 'HowRepayInterest';
  public static readonly HowRepayLoan = 'HowRepayLoan';
  public static readonly HowToUseSlider = 'HowToUseSlider';
  public static readonly HowToUseSliderTitle = 'HowToUseSliderTitle';
  public static readonly IdentityVerification = 'IdentityVerification';
  public static readonly IdentityVerificationNoIDVerse = 'IdentityVerificationNoIDVerse';
  public static readonly IdentityVerificationNoExperian = 'IdentityVerificationNoExperian';
  public static readonly IdentityVerificationInformation = 'IdentityVerificationInformation';
  public static readonly IdentityVerificationInformationNoIDVerse = 'IdentityVerificationInformationNoIDVerse';
  public static readonly IdentityVerificationInformationNoExperian = 'IdentityVerificationInformationNoExperian';
  public static readonly IdentityVerificationOMTInformation = 'IdentityVerificationOMTInformation';
  public static readonly IWantAdvice = 'IWantAdvice';
  public static readonly IgnoredFilter = 'IgnoredFilter';
  public static readonly IllustrationIncompleteDetailsInformation = 'IllustrationIncompleteDetailsInformation';
  public static readonly IllustrationUploadDetails = 'IllustrationUploadDetails';
  public static readonly IllustrationManualModeTitle = 'IllustrationManualModeTitle';
  public static readonly IllustrationManualModeDescription = 'IllustrationManualModeDescription';
  public static readonly IllustrationPendingTitle = 'IllustrationPendingTitle';
  public static readonly IllustrationPendingDescription = 'IllustrationPendingDescription';
  public static readonly IllustrationProductExpiredError = 'IllustrationProductExpiredError';
  public static readonly IllustrationReadyTitle = 'IllustrationReadyTitle';
  public static readonly IllustrationReadyCaseDocumentsLabel = 'IllustrationReadyCaseDocumentsLabel';
  public static readonly IllustrationReadyGoToProductTransferLabel = 'IllustrationReadyGoToProductTransferLabel';
  public static readonly IllustrationRequestedLabel = 'IllustrationRequestedLabel';
  public static readonly IllustrationsImportantDetailsModalDescription =
    'IllustrationsImportantDetailsModalDescription';
  public static readonly IllustrationsImportantDetailsModalTitle = 'IllustrationsImportantDetailsModalTitle';
  public static readonly IllustrationsNotReadyError = 'IllustrationsNotReadyError';
  public static readonly ImpactOnExpenditure = 'ImpactOnExpenditure';
  public static readonly ImpactOnIncome = 'ImpactOnIncome';
  public static readonly Import = 'Import';
  public static readonly ImportantIllustrationDescription = 'ImportantIllustrationDescription';
  public static readonly ImportantIllustrationTitle = 'ImportantIllustrationTitle';
  public static readonly ImportBranchesDialogTitle = 'ImportBranchesDialogTitle';
  public static readonly ImportProducts = 'ImportProducts';
  public static readonly ImportProductsMaxFileSize = 'ImportProductsMaxFileSize';
  public static readonly ImportProductsFormatsAllowed = 'ImportProductsFormatsAllowed';
  public static readonly ImportProductsSelectFile = 'ImportProductsSelectFile';
  public static readonly ImportProductsDropHere = 'ImportProductsDropHere';
  public static readonly ImportProductsUploadDone = 'ImportProductsUploadDone';
  public static readonly ImportProductsUploadFile = 'ImportProductsUploadFile';
  public static readonly ImportantInformation = 'ImportantInformation';
  public static readonly IncomeFromOutsideUK = 'IncomeFromOutsideUK';
  public static readonly IncomeFromOutsideUKDescription = 'IncomeFromOutsideUKDescription';
  public static readonly IncomeFromOutsideUKPercentage = 'IncomeFromOutsideUKPercentage';
  public static readonly IncomeId = 'Income';
  public static readonly IncompleteId = 'Incomplete';
  public static readonly IncompleteProfile = 'IncompleteProfileWarning';
  public static readonly IndividualActing = 'IndividualActing';
  public static readonly IndividualPackagingNotificationTasks = 'IndividualPackagingNotificationTasks';
  public static readonly IneligibleToSwitchSubAccount = 'IneligibleToSwitchSubAccount';
  public static readonly InformationMiniForm = 'InformationMiniForm';
  public static readonly InformationRequest = 'InformationRequest';
  public static readonly InformationRequestDescription = 'InformationRequestDescription';
  public static readonly InformationRequestSubject = 'InformationRequestSubject';
  public static readonly InformActiveClientContactInfoOverrideWarning = 'InformActiveClientContactInfoOverrideWarning';
  public static readonly InformClientContactInfoOverrideWarning = 'InformClientContactInfoOverrideWarning';
  public static readonly InitiatedAt = 'InitiatedAt';
  public static readonly InputRecommendation = 'Recommendation';
  public static readonly InsidePromotionalText = 'InsidePromotionalText';
  public static readonly InsuranceDeclaration = 'InsuranceDeclaration';
  public static readonly IntendedRetirementAge = 'IntendedRetirementAge';
  public static readonly InterestAnyOtherProperty = 'InterestAnyOtherProperty';
  public static readonly InterestOnlyPartId = 'InterestOnlyPart';
  public static readonly InternalCompanyName = 'InternalCompanyName';
  public static readonly InternalUser = 'InternalUser';
  public static readonly InterstitialPageTitleAA = 'InterstitialPageTitleAA';
  public static readonly InterstitialPageContentAA = 'InterstitialPageContentAA';
  public static readonly InterstitialPageTitlePOD = 'InterstitialPageTitlePOD';
  public static readonly InterstitialPageContentPOD = 'InterstitialPageContentPOD';
  public static readonly InterstitialPageTitlePO = 'InterstitialPageTitlePO';
  public static readonly InterstitialPageContentPO = 'InterstitialPageContentPO';
  public static readonly InterviewRequestCallbackSuccessfulText = 'InterviewRequestCallbackSuccessfulText';
  public static readonly InterviewRequestCallbackSuccessfulTitle = 'InterviewRequestCallbackSuccessfulTitle';
  public static readonly IntroducerDeclaration = 'IntroducerDeclaration';
  public static readonly IntroducerDeclarationContent = 'IntroducerDeclarationContent';
  public static readonly IntroducerDeclarationTitle = 'IntroducerDeclarationTitle';
  public static readonly InvalidEmailConfirmationRequest = 'InvalidEmailConfirmationRequest';
  public static readonly InvalidEmailError = 'InvalidEmailError';
  public static readonly InvalidInformationEntered = 'InvalidInformationEntered';
  public static readonly InvalidInsuranceNumberError = 'InvalidInsuranceNumberError';
  public static readonly InvalidLink = 'InvalidLink';
  public static readonly InvalidMaxLength = 'InvalidMaxLength';
  public static readonly InvalidPhoneNumberError = 'InvalidPhoneNumberError';
  public static readonly InvalidProductCode = 'InvalidProductCode';
  public static readonly InvalidProductSelectionTitle = 'InvalidProductSelectionTitle';
  public static readonly InvalidProductStatus = 'InvalidProductStatus';
  public static readonly InvalidProductStatusForAllSelected = 'InvalidProductStatusForAllSelected';
  public static readonly InvalidResetForgottenPasswordRequest = 'InvalidResetForgottenPasswordRequest';
  public static readonly InvestmentLozenge = 'InvestmentLozenge';
  public static readonly InvestmentPropertyAppliesTo = 'InvestmentPropertyAppliesTo';
  public static readonly IsAbleToSupplyPayslips = 'IsAbleToSupplyPayslips';
  public static readonly IsAllIncomePaidInSterlingCode = 'IsAllIncomePaidInSterlingCode';
  public static readonly IsAnyPartOfThePropertyToBeLet = 'IsAnyPartOfThePropertyToBeLet';
  public static readonly IsEnvironment = 'IsEnvironment';
  public static readonly IsEnvironmentFilter = 'IsEnvironmentFilter';
  public static readonly IsForSwitchersOnly = 'IsForSwitchersOnly';
  public static readonly IsFurtherAdvance = 'IsFurtherAdvance';
  public static readonly IsHMOLicenceRequiredCode = 'IsHMOLicenceRequiredCode';
  public static readonly IsItSubjectToALease = 'IsItSubjectToALease';
  public static readonly IsLoanSponsorCode = 'IsLoanSponsorCode';
  public static readonly IsMortgageClubSubmissionId = 'IsMortgageClubSubmission';
  public static readonly IsNICHAApplication = 'IsNICHAApplication';
  public static readonly IsFirstRateNotPayedInfoMessage = 'IsFirstRateNotPayedInfoMessage';
  public static readonly IsOnDeedsCode = 'IsOnDeedsCode';
  public static readonly IsPartToRemortgageCode = 'IsPartToRemortgageCode';
  public static readonly IsPayedOffWithMortgage = 'IsPayedOffWithMortgage';
  public static readonly IsPortableMortgage = 'IsPortableMortgage';
  public static readonly IsPropertyInheritedCode = 'IsPropertyInheritedCode';
  public static readonly IsRecommendedCode = 'IsRecommendedCode';
  public static readonly IsRemortgageId = 'IsRemortgage';
  public static readonly IsRentalPaidInSterlingCode = 'IsRentalPaidInSterlingCode';
  public static readonly IsSecuredAgainstProperty = 'IsSecuredAgainstProperty';
  public static readonly IsSingleFamilyPropertyCode = 'IsSingleFamilyPropertyCode';
  public static readonly IsThePropertyExPublicSector = 'IsThePropertyExPublicSector';
  public static readonly IsThePropertySituatedAbove = 'IsThePropertySituatedAbove';
  public static readonly IsThisAPrivateSale = 'IsThisAPrivateSale';
  public static readonly IsThisToBeRepaidByTheTime = 'IsThisToBeRepaidByTheTime';
  public static readonly IsValuationCompletedBeforeId = 'IsValuationCompletedBefore';
  public static readonly IsValuationReportWithin12Weeks = 'IsValuationReportWithin12Weeks';
  public static readonly KeyFactsIllustrationKfiId = 'KfiTitle';
  public static readonly Kfi = 'Kfi';
  public static readonly KfiAndRecommendations = 'KfiAndRecommendations';
  public static readonly KfiSelection = 'KfiSelection';
  public static readonly KfiTitle = 'KfiTitle';
  public static readonly KfiSelectionUnavailable = 'KfiSelectionUnavailable';
  public static readonly KnowILASolicitorDetailsCode = 'KnowILASolicitorDetailsCode';
  public static readonly KycCalls = 'KycCalls';
  public static readonly LTV = 'LTV';
  public static readonly Last4DigitsOfYourDDAccount = 'Last4DigitsOfYourDDAccount';
  public static readonly CloseProductsInvalidCloseDate = 'CloseProductsInvalidCloseDate';
  public static readonly CloseProductsInvalidWithdrawDate = 'CloseProductsInvalidWithdrawDate';
  public static readonly CloseProductsSetDates = 'CloseProductsSetDates';
  public static readonly CloseProductsWrongDates = 'CloseProductsWrongDates';
  public static readonly LastLogin = 'LastLogin';
  public static readonly LastName = 'LastName';
  public static readonly LastNormalPaymentMade = 'LastNormalPaymentMade';
  public static readonly LastPartRepaymentAmount = 'LastPartRepaymentAmount';
  public static readonly LaunchProductPicker = 'LaunchProductPicker';
  public static readonly LaunchProducts = 'LaunchProducts';
  public static readonly LaunchProductsSetStartDate = 'LaunchProductsSetStartDate';
  public static readonly LaunchProdutctsInvalidStartDate = 'LaunchProdutctsInvalidStartDate';
  public static readonly LeadApplicant = 'LeadApplicant';
  public static readonly LegalSupport = 'Legal support';
  public static readonly LenderAddress = 'LenderAddress';
  public static readonly LenderAddressId = 'LenderAddress';
  public static readonly LengthOfUKResidency = 'LengthOfUKResidency';
  public static readonly ProductDetailsCloseDate = 'ProductDetailsCloseDate';
  public static readonly ProductDetailsWithdrawDate = 'ProductDetailsWithdrawDate';
  public static readonly ProductTransferFromIllustrationInfo = 'ProductTransferFromIllustrationInfo';
  public static readonly SuccessLaunchMessage = 'SuccessLaunchMessage';
  public static readonly LinkCase = 'LinkCase';
  public static readonly LinkSamCustomerNote = 'LinkSamCustomerNote';
  public static readonly LinkedToOfferLabel = 'LinkedToOfferLabel';
  public static readonly LinkToSAMCustomer = 'LinkToSAMCustomer';
  public static readonly LinkedToTask = 'LinkedToTask';
  public static readonly ListAnyOutstandingDebts = 'ListAnyOutstandingDebts';
  public static readonly LmsStatement = 'LmsStatement';
  public static readonly Loan = 'Loan';
  public static readonly LoanAmount = 'LoanAmount';
  public static readonly LocationOfDeeds = 'LocationOfDeeds';
  public static readonly LockedAccountForSearchingExistingCustomerMortgage =
    'LockedAccountForSearchingExistingCustomerMortgage';
  public static readonly LockedOut = 'LockedOut';
  public static readonly LoggedOut = 'LoggedOut';
  public static readonly LoginButton = 'LoginButton';
  public static readonly LoginCredential = 'LoginCredential';
  public static readonly LoginIntroduction = 'LoginIntroduction';
  public static readonly LoginIntroductionIntenal = 'LoginIntroductionIntenal';
  public static readonly LoginSubtitle = 'LoginSubtitle';
  public static readonly LoginToCustomerHub = 'LoginToCustomerHub';
  public static readonly Logout = 'Logout';
  public static readonly MainMenuPrefix = 'MainMenuPrefix';
  public static readonly MaintenanceIncome = 'MaintenanceIncome';
  public static readonly MakeOverpaymentButton = 'MakeOverpaymentButton';
  public static readonly MakePayment = 'MakePayment';
  public static readonly MakePaymentLogosSection = 'MakePaymentLogosSection';
  public static readonly MakePaymentSidebarContactBody = 'MakePaymentSidebarContactBody';
  public static readonly MakePaymentSidebarContactTitle = 'MakePaymentSidebarContactTitle';
  public static readonly MakePaymentSidebarHelpBody = 'MakePaymentSidebarHelpBody';
  public static readonly MakePaymentSidebarHelpTitle = 'MakePaymentSidebarHelpTitle';
  public static readonly MaleId = 'Male';
  public static readonly ManageCustomerAccount = 'ManageCustomerAccount';
  public static readonly ManageLocationGroups = 'ManageLocationGroups';
  public static readonly ManageProfile = 'ManageProfile';
  public static readonly ManageUser = 'ManageUser';
  public static readonly MandatoryFields = 'MandatoryFields';
  public static readonly MaritalStatus = 'MaritalStatus';
  public static readonly MarkAsSwitchNotProceeding = 'MarkAsSwitchNotProceeding';
  public static readonly MarkCaseAsAdvised = 'MarkCaseAsAdvised';
  public static readonly MarkCaseDuplicate = 'MarkCaseDuplicate';
  public static readonly MarkCaseForMaterialChangeReview = 'MarkCaseForMaterialChangeReview';
  public static readonly MarkCaseNotProceeding = 'MarkCaseNotProceeding';
  public static readonly MarkFeedPaid = 'MarkFeedPaid';
  public static readonly MarkFeesRefunded = 'MarkFeesRefunded';
  public static readonly MarketingConsent = 'MarketingConsent';
  public static readonly MarketingConsentContent = 'MarketingConsentContent';
  public static readonly MarketingConsentContentPart1 = 'MarketingConsentContentPart1';
  public static readonly MarketingConsentContentPart2 = 'MarketingConsentContentPart2';
  public static readonly MarketingReference = 'MarketingReference';
  public static readonly MaxRegistrationAttemptsReached = 'MaxRegistrationAttemptsReached';
  public static readonly MaxUploadWarning = 'MaxUploadWarning';
  public static readonly MaxValueExceeded = 'MaxValueExceeded';
  public static readonly MembershipNumber = 'MembershipNumber';
  public static readonly ContactMobilePhoneNumber = 'ContactMobilePhoneNumber';
  public static readonly MFChangeContactDetail = 'MF-ChangeContactDetail';
  public static readonly MessagesHeader = 'MessagesHeader';
  public static readonly MiddleName = 'MiddleName';
  public static readonly MiddleNameWarning = 'MiddleNameWarning';
  public static readonly MiniFormSubmittedSuccessMessage = 'MiniFormSubmittedSuccessMessage';
  public static readonly MinimumYearsAtPreviousAddresses = 'MinimumYearsAtPreviousAddresses';
  public static readonly MoreDetailsLabel = 'MoreDetailsLabel';
  public static readonly MobilePhoneNo = 'MobilePhoneNo';
  public static readonly MobilePhoneNumberId = 'MobilePhoneNumber';
  public static readonly MonthlyArrangementsDescription = 'MonthlyArrangementsDescription';
  public static readonly MonthlyConcessionsDescription = 'MonthlyConcessionsDescription';
  public static readonly MonthlyCostOnSponsorProperty = 'MonthlyCostOnSponsorProperty';
  public static readonly MonthlyDetails = 'MonthlyDetails';
  public static readonly MonthlyDetailsArrangementTitle = 'MonthlyDetailsArrangementTitle';
  public static readonly MonthlyDetailsConcessionTitle = 'MonthlyDetailsConcessionTitle';
  public static readonly MonthlyMortgageAmount = 'MonthlyMortgageAmount';
  public static readonly MonthlyMortgageOnSponsorProperty = 'MonthlyMortgageOnSponsorProperty';
  public static readonly MonthlyOutgoingsDeclared = 'MonthlyOutgoingsDeclared';
  public static readonly MonthlyPayment = 'MonthlyPayment';
  public static readonly MonthlyPaymentReductionInformation = 'MonthlyPaymentReductionInformation';
  public static readonly MonthlyRentCurrentlyPaidByTenants = 'MonthlyRentCurrentlyPaidByTenants';
  public static readonly MonthlyRentalAmount = 'MonthlyRentalAmount';
  public static readonly MonthlyRentalForNotPurchasedProperty = 'MonthlyRentalForNotPurchasedProperty';
  public static readonly MonthlySponsorOutgoings = 'MonthlySponsorOutgoings';
  public static readonly MonthlyPaymentEstimationLabel = 'MonthlyPaymentEstimationLabel';
  public static readonly MonthlyPaymentEstimationTooltip = 'MonthlyPaymentEstimationTooltip';
  public static readonly MonthlyPaymentCurrentRate = 'MonthlyPaymentCurrentRate';
  public static readonly MonthlyPaymentNewRate = 'MonthlyPaymentNewRate';
  public static readonly MonthsId = 'Months';
  public static readonly MoreThanOneSignatoryForDirectDebit = 'MoreThanOneSignatoryForDirectDebit';
  public static readonly MortgageAccountCustomers = 'MortgageAccountCustomers';
  public static readonly MortgageAccountNumber = 'MortgageAccountNumber';
  public static readonly MortgageAccountNumberId = 'MortgageAccountNumber';
  public static readonly MortgageAccountType = 'MortgageAccountType';
  public static readonly MortgageActivitySwitchTitle = 'MortgageActivitySwitchTitle';
  public static readonly MortgageApplicationId = 'MortgageApplication';
  public static readonly MortgageBreakdown = 'MortgageBreakdown';
  public static readonly MortgageClass = 'MortgageClass';
  public static readonly MortgageTypeHeading = 'MortgageTypeHeading';
  public static readonly MortgageClassFilterSection = 'MortgageClassFilterSection';
  public static readonly MortgageClub = 'MortgageClub';
  public static readonly MortgageDescription = 'MortgageDescription';
  public static readonly MortgageDetailsHeaderSection = 'MortgageDetailsHeaderSection';
  public static readonly MortgageEligibilityTitle = 'MortgageEligibilityTitle';
  public static readonly MortgageHolderDateOfBirth = 'MortgageHolderDateOfBirth';
  public static readonly MortgageHolderLastName = 'MortgageHolderLastName';
  public static readonly MortgageHolderMortgageAccountNumber = 'MortgageHolderMortgageAccountNumber';
  public static readonly MortgageHolderSubAccountNumber = 'MortgageHolderSubAccountNumber';
  public static readonly MortgageMembershipNumberInfo = 'MortgageMembershipNumberInfo';
  public static readonly MortgageOffer = 'MortgageOffer';
  public static readonly MortgageOfferAuthenticationError = 'MortgageOfferAuthenticationError';
  public static readonly MortgageOfferDocument = 'MortgageOfferDocument';
  public static readonly MortgageOfferDocumentsNeedHelp = 'MortgageOfferDocumentsNeedHelp';
  public static readonly MortgageOfferDocumentsNeedHelpExistingBusiness =
    'MortgageOfferDocumentsNeedHelpExistingBusiness';
  public static readonly MortgageOfferDownloadAllDocuments = 'MortgageOfferDownloadAllDocuments';
  public static readonly MortgageOfferInstructions = 'MortgageOfferInstructions';
  public static readonly MortgageOfferInstructionsHeader = 'MortgageOfferInstructionsHeader';
  public static readonly MortgageOfferInstructionsExistingBusiness = 'MortgageOfferInstructionsExistingBusiness';
  public static readonly MortgageOfferInstructionsExistingBusinessHeader =
    'MortgageOfferInstructionsExistingBusinessHeader';
  public static readonly MortgageOfferNeedHelp = 'MortgageOfferNeedHelp';
  public static readonly MortgageOfferNeedHelpExistingBusiness = 'MortgageOfferNeedHelpExistingBusiness';
  public static readonly MortgageOfferPackBreakdown = 'MortgageOfferPackBreakdown';
  public static readonly MortgageOfferPackDocuments = 'MortgageOfferPackDocuments';
  public static readonly MortgageOfferProceedToAccept = 'MortgageOfferProceedToAccept';
  public static readonly MortgageOfferStatus = 'MortgageOfferStatus';
  public static readonly MortgageOfferWelcomeInformation = 'MortgageOfferWelcomeInformation';
  public static readonly MortgageOfferWelcomeInformationExistingBusiness =
    'MortgageOfferWelcomeInformationExistingBusiness';
  public static readonly MortgageOfferWelcomeMessage = 'MortgageOfferWelcomeMessage';
  public static readonly MortgageActivitySwitchCompletedInfo = 'MortgageActivitySwitchCompletedInfo';
  public static readonly MortgageOfferYou = 'MortgageOfferYou';
  public static readonly MortgageOnThisInvestmentProperty = 'MortgageOnThisInvestmentProperty';
  public static readonly MortgageOnThisProperty = 'MortgageOnThisProperty';
  public static readonly MortgageOnThisPropertyWhileRemortgaging = 'MortgageOnThisPropertyWhileRemortgaging';
  public static readonly MortgagePayOffAmountBTL = 'MortgagePayOffAmountBTL';
  public static readonly MortgagePayOffAmountResidential = 'MortgagePayOffAmountResidential';
  public static readonly MortgageRemainderFundingDetails = 'MortgageRemainderFundingDetails';
  public static readonly MortgageRemainderFundingDetailsForApplicant = 'MortgageRemainderFundingDetailsForApplicant';
  public static readonly MortgageTransactionsHeader = 'MortgageTransactionsHeader';
  public static readonly MortgageYearsRemainingOnSponsorProperty = 'MortgageYearsRemainingOnSponsorProperty';
  public static readonly MortgageOfferLabel = 'MortgageOfferLabel';
  public static readonly MostRecentSurname = 'MostRecentSurname';
  public static readonly MostRecentSurnameId = 'MostRecentSurname';
  public static readonly MultipleDirectDebitSignaturesWarning = 'MultipleDirectDebitSignaturesWarning';
  public static readonly MyExistingMortgages = 'MyExistingMortgages';
  public static readonly MyMortgageApplications = 'MyMortgageApplications';
  public static readonly MyProfile = 'MyProfile';
  public static readonly MyProfileDetails = 'MyProfileDetails';
  public static readonly MyProfileDialogTitle = 'MyProfileDialogTitle';
  public static readonly NameId = 'Name';
  public static readonly NameMortgageClub = 'MortgageClubCode';
  public static readonly NameOfEmployerId = 'NameOfEmployer';
  public static readonly NameOfLender = 'NameOfLender';
  public static readonly NameOfSolicitorFirm = 'NameOfSolicitorFirm';
  public static readonly NameOfYourBusiness = 'NameOfYourBusiness';
  public static readonly NameSecurityQuestion = 'SecurityQuestions';
  public static readonly NationalInsuranceNumber = 'NationalInsuranceNumber';
  public static readonly NationalInsuranceNumberId = 'NationalInsuranceNumber';
  public static readonly NationalityId = 'Nationality';
  public static readonly NatureOfBusiness = 'NatureOfBusiness';
  public static readonly NeedAdviceCallUs = 'NeedAdviceCallUs';
  public static readonly NeedAdviceContactUsByPhone = 'NeedAdviceContactUsByPhone';
  public static readonly NeedAdviceDescription = 'NeedAdviceDescription';
  public static readonly NeedAdviceFindBranchesPageLink = 'DirectCustomerFindBranchesPageLink';
  public static readonly NeedAdvicePrefferedTimeToCall = 'NeedAdvicePrefferedTimeToCall';
  public static readonly NeedAdviceRequestCallbackButton = 'NeedAdviceRequestCallbackButton';
  public static readonly NeedAdviceRequestCallbackDescription = 'NeedAdviceRequestCallbackDescription';
  public static readonly NeedAdviceRequestCallbackSuccessfulText = 'NeedAdviceRequestCallbackSuccessfulText';
  public static readonly NeedAdviceRequestCallbackSuccessfulTitle = 'NeedAdviceRequestCallbackSuccessfulTitle';
  public static readonly NeedAdviceTelephoneNumber = 'NeedAdviceTelephoneNumber';
  public static readonly NeedAdviceTelephoneNumberDescription = 'NeedAdviceTelephoneNumberDescription';
  public static readonly NeedAdviceTitle = 'NeedAdviceTitle';
  public static readonly NeedAdviceUserContactNumberTooltip = 'NeedAdviceUserContactNumberTooltip';
  public static readonly NeedAdviceViewBranchList = 'NeedAdviceViewBranchList';
  public static readonly NeedAdviceVisitBranchDescription = 'NeedAdviceVisitBranchDescription';
  public static readonly NeedAdviceVisitBranchTitle = 'NeedAdviceVisitBranchTitle';
  public static readonly NeedAnotherIllustration = 'NeedAnotherIllustration';
  public static readonly NeedHelpModalWindowDescription = 'NeedHelpModalWindowDescription';
  public static readonly NegativeAffordabilitySuitabilityDescription = 'NegativeAffordabilitySuitabilityDescription';
  public static readonly NetProfit1 = 'NetProfit1';
  public static readonly NetProfit2 = 'NetProfit2';
  public static readonly NewApplicationVersionAvailableMessage = 'NewApplicationVersionAvailable';
  public static readonly NewArrearsBalanceLabel = 'NewArrearsBalanceLabel';
  public static readonly NewCustomer = 'NewCustomer';
  public static readonly NewEmail = 'NewEmail';
  public static readonly NewContactNumber = 'NewContactNumber';
  public static readonly NewEmailAddress = 'NewEmailAddress';
  public static readonly NewFeatureLinkName = 'NewFeatureLinkName';
  public static readonly NewFeaturesTitle = 'NewFeaturesTitle';
  public static readonly NewMonthlyMortgagePaymentPrediction = 'NewMonthlyMortgagePaymentPrediction';
  public static readonly NewMortgageMessagePart1 = 'NewMortgageMessagePart1';
  public static readonly NewMortgageMessagePart2 = 'NewMortgageMessagePart2';
  public static readonly NewOutboundCall = 'NewOutboundCall';
  public static readonly NewOutstandingBalancePrediction = 'NewOutstandingBalancePrediction';
  public static readonly NewPhoneNumber = 'NewPhoneNumber';
  public static readonly NewProductVersion = 'NewProductVersion';
  public static readonly NewQuoteFor = 'NewQuoteFor';
  public static readonly NewlyCreatedAgent = 'NewlyCreatedAgent';
  public static readonly Next = 'Next';
  public static readonly NextChasingNotificationDate = 'NextChasingNotificationDate';
  public static readonly NextPackagingNotificationDate = 'NextPackagingNotificationDate';
  public static readonly No = 'No';
  public static readonly NoAddressesFound = 'NoAddressesFound';
  public static readonly NoCaseAccess = 'NoCaseAccess';
  public static readonly NoCaseAdministratorsLinked = 'NoCaseAdministratorsLinked';
  public static readonly NoCaseDocumentsAvailableDescription = 'NoCaseDocumentsAvailableDescription';
  public static readonly NoCaseDocumentLinkedInfoTitle = 'NoCaseDocumentLinkedInfoTitle';
  public static readonly NoCaseDocumentLinkedInfoDescription = 'NoCaseDocumentLinkedInfoDescription';
  public static readonly NoCaseNotifications = 'NoCaseNotifications';
  public static readonly NoCurrentActiveMortgageAccounts = 'NoCurrentActiveMortgageAccounts';
  public static readonly NoEmailForOffer = 'NoEmailForOffer';
  public static readonly NoResultsDetails = 'NoResultsDetails';
  public static readonly NoFeesKfiFoundNotificationContent = 'NoFeesKfiFoundNotificationContent';
  public static readonly NoFeesKfiFoundNotificationTitle = 'NoFeesKfiFoundNotificationTitle';
  public static readonly NoFileDescription = 'NoFileDescription';
  public static readonly NoFileSelected = 'NoFileSelected';
  public static readonly NoFilesSelectedDescription = 'NoFilesSelectedDescription';
  public static readonly NoFirmsFound = 'NoFirmsFound';
  public static readonly NoMortgageAccountLocked = 'NoMortgageAccountLocked';
  public static readonly NoOfferProducedMessage = 'NoOfferProducedMessage';
  public static readonly NoOutgoingsDeclaration = 'NoOutgoingsDeclaration';
  public static readonly NoPeopleAgedOver17 = 'NoPeopleAgedOver17';
  public static readonly NoPeopleOnTenancyAgreement = 'NoPeopleOnTenancyAgreement';
  public static readonly NoPhoneForOffer = 'NoPhoneForOffer';
  public static readonly NoProductsAvailableForSwitch = 'NoProductsAvailableForSwitch';
  public static readonly NoProductSelectedDescription = 'NoProductSelectedDescription';
  public static readonly NoProductSelectedTitle = 'NoProductSelectedTitle';
  public static readonly NoRomeAccess = 'NoRomeAccess';
  public static readonly NoResults = 'NoResults';
  public static readonly NonGuaranteedBonus = 'NonGuaranteedBonus';
  public static readonly None = 'None';
  public static readonly NormalMonthlyPayment = 'NormalMonthlyPayment';
  public static readonly NotAgree = 'NotAgree';
  public static readonly NotApplicableLabel = 'NotApplicableLabel';
  public static readonly NotCaseRelated = 'NotCaseRelated';
  public static readonly NotImplemented = 'NotImplemented';
  public static readonly NotViaMortgageClub = 'NotViaMortgageClub';
  public static readonly NoteIndividualWillBeCrediId = 'CreditScoreNote';
  public static readonly NoteMustBeAdded = 'NoteMustBeAdded';
  public static readonly Notes = 'Notes';
  public static readonly NotesRequiringAction = 'NotesRequiringAction';
  public static readonly NotificationSaveSuccess = 'NotificationSaveSuccess';
  public static readonly NotificationTaskStatusChanged = 'NotificationTaskStatusChanged';
  public static readonly NotificationValidationErrors = 'NotificationValidationErrors';
  /* eslint-disable-next-line id-blacklist */
  public static readonly Number = 'Number';
  public static readonly NumberOfApplicantsId = 'NumberOfApplicants';
  public static readonly NumberOfBathrooms = 'NumberOfBathrooms';
  public static readonly NumberOfBedrooms = 'NumberOfBedrooms';
  public static readonly NumberOfDependentsBTL = 'NumberOfDependentsBTL';
  public static readonly NumberOfDependentsId = 'NumberOfDependents';
  public static readonly NumberOfFailedInsertedBranches = 'NumberOfFailedInsertedBranches';
  public static readonly NumberOfFailedUpdatedBranches = 'NumberOfFailedUpdatedBranches';
  public static readonly NumberOfFeatures = 'NumberOfFeatures';
  public static readonly NumberOfInsertedBranches = 'NumberOfInsertedBranches';
  public static readonly NumberOfKitchens = 'NumberOfKitchens';
  public static readonly NumberOfSponsorDependents = 'NumberOfSponsorDependents';
  public static readonly NumberOfUnreadMessagesPart1 = 'NumberOfUnreadMessagesPart1';
  public static readonly NumberOfUnreadMessagesPart2 = 'NumberOfUnreadMessagesPart2';
  public static readonly NumberOfUpdatedBranches = 'NumberOfUpdatedBranches';
  public static readonly NumberOfUploadedDocuments = 'NumberOfUploadedDocuments';
  public static readonly NumberOfUploadedDocumentsInternal = 'NumberOfUploadedDocumentsInternal';
  public static readonly ObsoleteFieldNotificationActionType = 'ObsoleteFieldNotificationActionType';
  public static readonly ObsoleteFieldNotificationApplicantName = 'ObsoleteFieldNotificationApplicantName';
  public static readonly ObsoleteFieldNotificationConfirm = 'ObsoleteFieldNotificationConfirm';
  public static readonly ObsoleteFieldNotificationMessage = 'ObsoleteFieldNotificationMessage';
  public static readonly ObsoleteFieldNotificationText = 'ObsoleteFieldNotificationText';
  public static readonly ObsoleteFieldNotificationTitle = 'ObsoleteFieldNotificationTitle';
  public static readonly ObsoleteFieldNotificationValue = 'ObsoleteFieldNotificationValue';
  public static readonly Occupation = 'Occupation';
  public static readonly OfTheMonth = 'OfTheMonth';
  public static readonly OfTheMortgagedProperty = 'OfTheMortgagedProperty';
  public static readonly OfferAcceptanceDDAcceptedFinalStep = 'OfferAcceptanceDDAcceptedFinalStep';
  public static readonly OfferAcceptanceDDAuthorizingStepOne = 'OfferAcceptanceDDAuthorizingStepOne';
  public static readonly OfferAcceptanceDDDeclinedFinalStep = 'OfferAcceptanceDDDeclinedFinalStep';
  public static readonly OfferAcceptanceDDNonAuthorizingFinalStep = 'OfferAcceptanceDDNonAuthorizingFinalStep';
  public static readonly OfferAcceptanceDDNonAuthorizingStepOne = 'OfferAcceptanceDDNonAuthorizingStepOne';
  public static readonly OfferAcceptanceTitle = 'OfferAcceptanceTitle';
  public static readonly OfferAcceptanceDescription = 'OfferAcceptanceDescription';
  public static readonly OfferAcceptedOn = 'OfferAcceptedOn';
  public static readonly OfferAcceptanceStepTwo = 'OfferAcceptanceStepTwo';
  public static readonly OfferApplicantEmailAddress = 'OfferApplicantEmailAddress';
  public static readonly OfferAuditEmailModalTitle = 'OfferAuditEmailModalTitle';
  public static readonly OfferAuditModalTitle = 'OfferAuditModalTitle';
  public static readonly OfferAuditViewDetails = 'OfferAuditViewDetails';
  public static readonly OfferAuditViewEmail = 'ViewEmail';
  public static readonly OfferAuthenticationNotification = 'OfferAuthenticationNotification';
  public static readonly OfferCaseAction = 'OfferCaseAction';
  public static readonly OfferClosedSessionDescription = 'OfferClosedSessionDescription';
  public static readonly OfferClosedSessionPageTitle = 'OfferClosedSessionPageTitle';
  public static readonly OfferCompletedDescription = 'OfferCompletedDescription';
  public static readonly OfferCompletedPageTitle = 'OfferCompletedPageTitle';
  public static readonly OfferDeclarationWindowTitle = 'OfferDeclarationWindowTitle';
  public static readonly OfferDistributedByPost = 'OfferDistributedByPost';
  public static readonly OfferDistributedOnline = 'OfferDistributedOnline';
  public static readonly OfferDistributionFilterName = 'OfferDistributionFilterName';
  public static readonly OfferDistributionPlaceholderConfirmByEmail = 'OfferDistributionPlaceholderConfirmByEmail';
  public static readonly OfferDistributionPlaceholderConfirmByPost = 'OfferDistributionPlaceholderConfirmByPost';
  public static readonly OfferDistributionPlaceholderDescription = 'OfferDistributionPlaceholderDescription';
  public static readonly OfferDistributionClientPlaceholderDescription =
    'OfferDistributionClientPlaceholderDescription';
  public static readonly OfferDistributionPlaceholderSendByPost = 'OfferDistributionPlaceholderSendByPost';
  public static readonly OfferDistributionPlaceholderSendByPostDescription =
    'OfferDistributionPlaceholderSendByPostDescription';
  public static readonly OfferDistributionLabel = 'OfferDistributionLabel';
  public static readonly OfferDistributionChannel = 'OfferDistributionChannel';
  public static readonly OfferDownloadBundleModalDescription = 'OfferDownloadBundleModalDescription';
  public static readonly OfferDownloadBundleModalTitle = 'OfferDownloadBundleModalTitle';
  public static readonly OfferEXOWindowDeclarationContent = 'OfferEXOWindowDeclarationContent';
  public static readonly OfferEXOWindowDeclarationContentForExistingBusiness =
    'OfferEXOWindowDeclarationContentForExistingBusiness';
  public static readonly OfferEXOWindowDeclarationContentHeader = 'OfferEXOWindowDeclarationContentHeader';
  public static readonly OfferEXOWindowDeclarationContentHeaderForExistingBusiness =
    'OfferEXOWindowDeclarationContentHeaderForExistingBusiness';
  public static readonly OfferEmailSendFailed = 'OfferEmailSendFailed';
  public static readonly OfferEndSessionLogInToHub = 'OfferEndSessionLogInToHub';
  public static readonly OfferEndSessionRegister = 'OfferEndSessionRegister';
  public static readonly OfferInProcessViaPostMessage = 'OfferInProcessViaPostMessage';
  public static readonly OfferInvestmentPropertyLoanWindowDeclarationContent =
    'OfferInvestmentPropertyLoanWindowDeclarationContent';
  public static readonly OfferInvestmentWindowDeclarationContentHeader =
    'OfferInvestmentWindowDeclarationContentHeader';
  public static readonly OfferLastViewedOn = 'OfferLastViewedOn';
  public static readonly OfferManagementToolTab = 'OfferManagementToolTab';
  public static readonly OfferManagementToolTitle = 'OfferManagementToolTitle';
  public static readonly OfferManualModeDescription = 'OfferManualModeDescription';
  public static readonly OfferManualModeTitle = 'OfferManualModeTitle';
  public static readonly OfferNotProceedingDescription = 'OfferNotProceedingDescription';
  public static readonly OfferNotProceedingTitle = 'OfferNotProceedingTitle';
  public static readonly OfferPendingDescription = 'OfferPendingDescription';
  public static readonly OfferPendingTitle = 'OfferPendingTitle';
  public static readonly OfferExpiredDescription = 'OfferExpiredDescription';
  public static readonly OfferExpiredTitle = 'OfferExpiredTitle';
  public static readonly OfferPlaceholderEmailAddress = 'OfferPlaceholderEmailAddress';
  public static readonly OfferPlaceholderPhoneNumber = 'OfferPlaceholderPhoneNumber';
  public static readonly OfferPlaceholderInfo = 'OfferPlaceholderInfo';
  public static readonly OfferPostPlaceholderInfo = 'OfferPostPlaceholderInfo';
  public static readonly OfferPlaceholderReceivedOnlineInformation = 'OfferPlaceholderReceivedOnlineInformation';
  public static readonly OfferPlaceholderReceivedPostalInformation = 'OfferPlaceholderReceivedPostalInformation';
  public static readonly OfferReadyCaseDocumentsLabel = 'OfferReadyCaseDocumentsLabel';
  public static readonly OfferReadyByPostDescription = 'OfferReadyByPostDescription';
  public static readonly OfferReadyOnlineDescription = 'OfferReadyOnlineDescription';
  public static readonly OfferReadyTitle = 'OfferReadyTitle';
  public static readonly OfferSessionAboutToExpireModalContent = 'OfferSessionAboutToExpireModalContent';
  public static readonly OfferSessionAboutToExpireModalContinue = 'OfferSessionAboutToExpireModalContinue';
  public static readonly OfferSessionAboutToExpireModalClose = 'OfferSessionAboutToExpireModalClose';
  public static readonly OfferSessionAboutToExpireModalTitle = 'OfferSessionAboutToExpireModalTitle';
  public static readonly OfferSequenceNumber = 'OfferSequenceNumber';
  public static readonly OfferSequenceNumberInput = 'OfferSequenceNumberInput';
  public static readonly OfferSequenceNumberModalContext = 'OfferSequenceNumberModalContext';
  public static readonly OfferSequenceNumberModalTitle = 'OfferSequenceNumberModalTitle';
  public static readonly OfferUnavailablePageDescription = 'OfferUnavailablePageDescription';
  public static readonly OfferUnavailablePageTitle = 'OfferUnavailablePageTitle';
  public static readonly OfferWithError = 'OfferWithError';
  public static readonly OfflineCaseMessagingWarning = 'OfflineCaseMessagingWarning';
  public static readonly OkText = 'OkText';
  public static readonly On = 'On';
  public static readonly OnTerm = 'OnTerm';
  public static readonly OneOfMortgageHolders = 'OneOfMortgageHolders';
  public static readonly OnlineOfferFooterContent = 'OnlineOfferFooterContent';
  public static readonly OnlineOfferFooterContentExistingBusiness = 'OnlineOfferFooterContentExistingBusiness';
  public static readonly OnlineOfferInfo = 'OnlineOfferInfo';
  public static readonly OnlyShowOnceDeclarationInfo = 'OnlyShowOnceDeclarationInfo';
  public static readonly OptShowOnlyAlerted = 'OptShowOnlyAlerted';
  public static readonly OptionListCurrentMarginalTaxRateCode = 'CurrentMarginalTaxRate';
  public static readonly OptionListECTransactionInProgressCodes = 'ECTransactionInProgressCodes';
  public static readonly OptionalConfirmEmail = 'OptionalConfirmEmail';
  public static readonly OptionalEmail = 'OptionalEmail';
  public static readonly OriginalDocumentRequired = 'OriginalDocumentRequired';
  public static readonly OriginalPricePaidForTheProp = 'OriginalPricePaidForTheProp';
  public static readonly Originator = 'Originator';
  public static readonly OtherAdditionalRemortgage = 'OtherAdditionalRemortgage';
  public static readonly OtherAdditionalRemortgageDetails = 'OtherAdditionalRemortgageDetails';
  public static readonly OtherBtlWithUsDetails = 'OtherBtlWithUsDetails';
  public static readonly OtherDebtsInformation = 'OtherDebtsInformation';
  public static readonly OtherIncomeDetailsSectionLabel = 'OtherIncomeDetailsSectionLabel';
  public static readonly OtherRegularIncomeId = 'OtherRegularIncome';
  public static readonly OtherRegularIncomeSource = 'OtherRegularIncomeSource';
  public static readonly OtherThanTheMortgageApplicants = 'OtherThanTheMortgageApplicants';
  public static readonly OtpHasNotBeenSentErrorMessage = 'OtpHasNotBeenSentErrorMessage';
  public static readonly OutgoingAddAnother = 'OutgoingAddAnother';
  public static readonly OutgoingIgnored = 'OutgoingIgnored';
  public static readonly OutgoingPleaseProvideDetails = 'OutgoingPleaseProvideDetails';
  public static readonly OutgoingsAppliesTo = 'OutgoingsAppliesTo';
  public static readonly OutgoingsTotal = 'OutgoingsTotal';
  public static readonly OutOf = 'OutOf';
  public static readonly OutsidePromotionalNoLastPartRedemptionText = 'OutsidePromotionalNoLastPartRedemptionText';
  public static readonly OutsidePromotionalText = 'OutsidePromotionalText';
  public static readonly OutstandingBalance = 'OutstandingBalance';
  public static readonly OutstandingBalanceOnSponsorProperty = 'OutstandingBalanceOnSponsorProperty';
  public static readonly OutstandingTerm = 'OutstandingTerm';
  public static readonly OverdraftLimit = 'OverdraftLimit';
  public static readonly Overpay = 'Overpay';
  public static readonly OverpayAllowance = 'OverpayAllowance';
  public static readonly OverpayLabel = 'OverpayLabel';
  public static readonly OverpayText = 'OverpayText';
  public static readonly OverpaymentButton = 'OverpaymentButton';
  public static readonly OverpaymentDetailsInformationLabel = 'OverpaymentDetailsInformationLabel';
  public static readonly OverpaymentDetailsSubtitle = 'OverpaymentDetailsSubtitle';
  public static readonly OverpaymentModalTitle = 'OverpaymentModalTitle';
  public static readonly OverpaymentUnavailableModalTitle = 'OverpaymentUnavailableModalTitle';
  public static readonly OverpaymentUnavailableDescription = 'OverpaymentUnavailableDescription';
  public static readonly OverrideIllustration = 'OverrideIllustration';
  public static readonly OverviewIllustrationSelectedProductSubtitle = 'OverviewIllustrationSelectedProductSubtitle';
  public static readonly OverviewProductTransferInfoTitle = 'OverviewProductTransferInfoTitle';
  public static readonly OverviewProductTransferInfoDescription = 'OverviewProductTransferInfoDescription';
  public static readonly OverwriteWindowConfirmationButton = 'OverwriteWindowConfirmationButton';
  public static readonly OverwriteWindowContent = 'OverwriteWindowContent';
  public static readonly OverwriteWindowTitle = 'OverwriteWindowTitle';
  public static readonly Own25percent = 'Own25percent';
  public static readonly PackagingAllApplicants = 'PackagingAllApplicants';
  public static readonly PackagingChangePriority = 'PackagingChangePriority';
  public static readonly PackagingDetailsDocument = 'PackagingDetailsDocument';
  public static readonly PackagingPrintCoversheet = 'PackagingPrintCoversheet';
  public static readonly PackagingReason = 'PackagingReason';
  public static readonly PackagingRequest = 'PackagingRequest';
  public static readonly PackagingResponse = 'PackagingResponse';
  public static readonly PackagingSaveReason = 'PackagingSaveReason';
  public static readonly PackagingSaveResponse = 'PackagingSaveResponse';
  public static readonly PackagingStageCode = 'BOResultsPackagingStageCode';
  public static readonly PackagingTabActions = 'PackagingTabActions';
  public static readonly PackagingTabAddPackagingItem = 'PackagingTabAddPackagingItem';
  public static readonly PackagingTabAddTaskItem = 'PackagingTabAddTaskItem';
  public static readonly PackagingTabAddedBy = 'PackagingTabAddedBy';
  public static readonly PackagingTabApplicant = 'PackagingTabApplicant';
  public static readonly PackagingTabConfirmPackagingList = 'PackagingTabConfirmPackagingList';
  public static readonly PackagingTabDocument = 'PackagingTabDocument';
  public static readonly PackagingTabPackagingList = 'PackagingTabPackagingList';
  public static readonly PackagingTabPlaceholder = 'PackagingTabPlaceholder';
  public static readonly PackagingTabPriority = 'PackagingTabPriority';
  public static readonly PackagingTabStatus = 'PackagingTabStatus';
  public static readonly PackagingTabTaskList = 'PackagingTabTaskList';
  public static readonly PackagingType3rdParty = 'PackagingType3rdParty';
  public static readonly PackagingType3rdPartyDescription = 'PackagingType3rdPartyDescription';
  public static readonly PackagingTypeInformation = 'PackagingTypeInformation';
  public static readonly PackagingUploadDisabledDescription = 'PackagingUploadDisabledDescription';
  public static readonly PageNotFoundBody = 'PageNotFoundBody';
  public static readonly PageNotFoundHeader = 'PageNotFoundHeader';
  public static readonly PageTitle = 'PageTitle';
  public static readonly PartRedemptionPaymentModalTitle = 'PartRedemptionPaymentModalTitle';
  public static readonly PartRedemptionMaxAmountLimit = 'PartRedemptionMaxAmountLimit';
  public static readonly Pass = 'Pass';
  public static readonly Password = 'Password';
  public static readonly PasswordChanged = 'PasswordChanged';
  public static readonly PasswordChangeExceededTries = 'PasswordChangeExceededTries';
  public static readonly PasswordConfirmationError = 'PasswordConfirmationError';
  public static readonly PasswordRegistrationStaticHint = 'PasswordRegistrationStaticHint';
  public static readonly PasswordStaticHint = 'PasswordStaticHint';
  public static readonly PasswordStrengthMinCharacters = 'PasswordStrengthMinCharacters';
  public static readonly PasswordStrengthSpecialCharacter = 'PasswordStrengthSpecialCharacter';
  public static readonly PasswordStrengthUpperLowerCaseLetters = 'PasswordStrengthUpperLowerCaseLetters';
  public static readonly PayedOnSpecificDateOfMonth = 'PayedOnSpecificDateOfMonth';
  public static readonly PayeeName = 'PayeeName';
  public static readonly PayeePhoneNumber = 'PayeePhoneNumber';
  public static readonly PayeePostCode = 'PayeePostCode';
  public static readonly PaymentAfterDeductionLabel = 'PaymentAfterDeductionLabel';
  public static readonly PaymentAgreementLabel = 'PaymentAgreementLabel';
  public static readonly PaymentAmount = 'PaymentAmount';
  public static readonly PaymentAndAllowance = 'PaymentAndAllowance';
  public static readonly PaymentAndAllowanceTooltip = 'PaymentAndAllowanceTooltip';
  public static readonly PaymentBreakdown = 'PaymentBreakdown';
  public static readonly PaymentCompleteLozenge = 'PaymentCompleteLozenge';
  public static readonly PaymentDateTime = 'PaymentDateTime';
  public static readonly PaymentDetails = 'PaymentDetails';
  public static readonly PaymentDetailsBodySection = 'PaymentDetailsBodySection';
  public static readonly PaymentDetailsHeaderSection = 'PaymentDetailsHeaderSection';
  public static readonly PaymentInformationButton = 'PaymentInformationButton';
  public static readonly PaymentInformationDescription = 'PaymentInformationDescription';
  public static readonly PaymentInformationModalTitle = 'PaymentInformationModalTitle';
  public static readonly PaymentNumber = 'PaymentNumber';
  public static readonly PaymentSearch = 'PaymentSearch';
  public static readonly PaymentStatus = 'PaymentStatus';
  public static readonly PaymentType = 'PaymentType';
  public static readonly PaymentUserName = 'PaymentUserName';
  public static readonly PayPartRedemptionButtonLabel = 'PayPartRedemptionButtonLabel';
  public static readonly PdfViewerPaging = 'PdfViewerPaging';
  public static readonly PEARating = 'PEARating';
  public static readonly PEARatingInfo = 'PEARatingInfo';
  public static readonly PendingId = 'PendingId';
  public static readonly PendingOverpaymentModalDescription = 'PendingOverpaymentModalDescription';
  public static readonly PendingOverpaymentModalTitle = 'PendingOverpaymentModalTitle';
  public static readonly PendingPaymentOperationModalContent = 'PendingPaymentOperationModalContent';
  public static readonly PendingPaymentOperationModalHeader = 'PendingPaymentOperationModalHeader';
  public static readonly PendingPaymentOperationModalTitle = 'PendingPaymentOperationModalTitle';
  public static readonly PerformAmlSearch = 'PerformAmlSearch';
  public static readonly PeriodBusinessOwned = 'PeriodBusinessOwned';
  public static readonly PersonId = 'Person';
  public static readonly PersonalDetails = 'PersonalDetails';
  public static readonly PlaceholderApplicant = 'PlaceholderApplicant';
  public static readonly PlaceholderAppliedTo = 'PlaceholderAppliedTo';
  public static readonly PlaceholderAppointment = 'PlaceholderAppointment';
  public static readonly PlaceholderAppointmentDate = 'PlaceholderAppointmentDate';
  public static readonly PlaceholderCategory = 'PlaceholderCategory';
  public static readonly PlaceholderConcurrencyMessage = 'PlaceholderConcurrencyMessage';
  public static readonly PlaceholderDocument = 'PlaceholderDocumentLabel';
  public static readonly PlaceholderDocumentUploadAllowed = 'PlaceholderDocumentUploadAllowed';
  public static readonly PlaceholderItem = 'PlaceholderItem';
  public static readonly PlaceholderMultipleApplicants = 'PlaceholderMultipleApplicants';
  public static readonly PlaceholderNotes = 'PlaceholderNotes';
  public static readonly PlaceholderNotificationExternalDocument = 'PlaceholderNotificationExternalDocument';
  public static readonly PlaceholderNotificationExternalDocumentName = 'PlaceholderNotificationExternalDocumentName';
  public static readonly PlaceholderNotificationOriginalRequired = 'PlaceholderNotificationOriginalRequired';
  public static readonly PlaceholderPurpose = 'PlaceholderPurposeLabel';
  public static readonly PlaceholderRequiredFor = 'PlaceholderRequiredFor';
  public static readonly PlaceholderSetDate = 'PlaceholderSetDate';
  public static readonly PlaceholderType = 'PlaceholderType';
  public static readonly PlaceholderUploadCertification = 'PlaceholderUploadCertificationLabel';
  public static readonly PlaceholderUploadModalDetails = 'PlaceholderUploadModalDetails';
  public static readonly PlaceholderUploadUsefulInformation = 'PlaceholderUploadUsefulInformation';
  public static readonly PlaceholderUploadingInProgress = 'PlaceholderUploadingInProgress';
  public static readonly PlaceholderVORespond = 'PlaceholderVORespond';
  public static readonly PlaceholderVOUpload = 'PlaceholderVOUpload';
  public static readonly PlacesYouHaveLived = 'PlacesYouHaveLived';
  public static readonly PleaseAnswerSecurityQuestion = 'PleaseAnswerSecurityQuestion';
  public static readonly PleaseClickOkText = 'PleaseClickOkText';
  public static readonly PleaseContactAccessController = 'PleaseContactAccessController';
  public static readonly PleaseCreatePassword = 'PleaseCreatePassword';
  public static readonly PleaseCreatePasswordForRegistration = 'PleaseCreatePasswordForRegistration';
  public static readonly PleaseProvideAnyAdditionalInfo = 'PleaseProvideAnyAdditionalInfo';
  public static readonly PleaseProvideDetails = 'PleaseProvideDetails';
  public static readonly PleaseProvideDetailsOfBalanceOId = 'ReasonForMortgage';
  public static readonly PleaseSelect = 'PleaseSelect';
  public static readonly PleaseTellUsIfLetToRelatice = 'PleaseTellUsIfLetToRelatice';
  public static readonly PopupBlockerWarning = 'PopupBlockerWarning';
  public static readonly PopupBlockerWarningTitle = 'PopupBlockerWarningTitle';
  public static readonly PositiveAffordabilitySuitabilityDescription = 'PositiveAffordabilitySuitabilityDescription';
  public static readonly Post = 'Post';
  public static readonly PostCode = 'PostcodeRequired';
  public static readonly PostcodeId = 'Postcode';
  public static readonly PostcodeMandatory = 'PostcodeMandatory';
  public static readonly PredefinedTaskName = 'PredefinedTaskName';
  public static readonly Preview = 'Preview';
  public static readonly PreRegistrationDetailsTitle = 'PreRegistrationDetailsTitle';
  public static readonly PreRegistrationDetailsVerification = 'PreRegistrationDetailsVerification';
  public static readonly PreRegistrationDetailsVerificationEmail = 'PreRegistrationDetailsVerificationEmail';
  public static readonly PreRegistrationDetailsVerificationOtp = 'PreRegistrationDetailsVerificationOtp';
  public static readonly PreRegistrationDetailsConfirmation = 'PreRegistrationDetailsConfirmation';
  public static readonly PreRegistrationDetailsConfirmationExperian = 'PreRegistrationDetailsConfirmationExperian';
  public static readonly PreRegistrationDetailsOtpAttempsReached = 'PreRegistrationDetailsOtpAttempsReached';
  public static readonly PreRegistrationDetailsConfirmationResendEmail =
    'PreRegistrationDetailsConfirmationResendEmail';
  public static readonly PreRegistrationDetailsVerificationResendEmail =
    'PreRegistrationDetailsVerificationResendEmail';
  public static readonly PreRegistrationDetailsConfirmationEmail = 'PreRegistrationDetailsConfirmationEmail';
  public static readonly PreRegistrationDetailsConfirmationOtp = 'PreRegistrationDetailsConfirmationOtp';
  public static readonly PreRegistrationDetailsStatusNotStarted = 'PreRegistrationDetailsStatusNotStarted';
  public static readonly PreRegistrationDetailsStatusInitiated = 'PreRegistrationDetailsStatusInitiated';
  public static readonly PreRegistrationDetailsStatusCompleted = 'PreRegistrationDetailsStatusCompleted';
  public static readonly PreRegistrationDetailsStatusPending = 'PreRegistrationDetailsStatusPending';
  public static readonly PreRegistrationDetailsStatusExpired = 'PreRegistrationDetailsStatusExpired';
  public static readonly PreRegistrationDetailsStatusInProgress = 'PreRegistrationDetailsStatusInProgress';
  public static readonly PreRegistrationDetailsStatusPass = 'PreRegistrationDetailsStatusPass';
  public static readonly PreRegistrationDetailsStatusFail = 'PreRegistrationDetailsStatusFail';
  public static readonly PreRegistrationDetailsStatusNoDecision = 'PreRegistrationDetailsStatusNoDecision';
  public static readonly PreRegistrationDetailsStatusBypassed = 'PreRegistrationDetailsStatusBypassed';
  public static readonly PreRegistrationMoreDetails = 'PreRegistrationMoreDetails';
  public static readonly PreRegistrationDetailsExpiredWithTechFailureStatus =
    'PreRegistrationDetailsExpiredWithTechFailureStatus';
  public static readonly PreRegistrationDetailsCompleteStatus = 'PreRegistrationDetailsCompleteStatus';
  public static readonly PreRegistrationClientReferenceId = 'PreRegistrationClientReferenceId';
  public static readonly PreRegistrationRBNumber = 'PreRegistrationRBNumber';
  public static readonly PreRegistrationDetailsVerificationOverallStatusDescription =
    'PreRegistrationDetailsVerificationOverallStatusDescription';
  public static readonly PreRegistrationDetailsCrossCoreVerificationStatusDescription =
    'PreRegistrationDetailsCrossCoreVerificationStatusDescription';
  public static readonly PreRegistrationDetailsCrossCoreVerificationResponseDescription =
    'PreRegistrationDetailsCrossCoreVerificationResponseDescription';
  public static readonly PreRegistrationDetailsIDVerseVerificationStatusDescription =
    'PreRegistrationDetailsIDVerseVerificationStatusDescription';
  public static readonly PreRegistrationDetailsIDVerseVerificationResponseDescription =
    'PreRegistrationDetailsIDVerseVerificationResponseDescription';
  public static readonly PreRegistrationDetailsSummitUpdateStatusDescription =
    'PreRegistrationDetailsSummitUpdateStatusDescription';
  public static readonly PreRegistrationDetailsNotStartedStatus = 'PreRegistrationDetailsNotStartedStatus';
  public static readonly PreRegistrationDetailsInitiatedStatus = 'PreRegistrationDetailsInitiatedStatus';
  public static readonly PreRegistrationDetailsInProgressStatus = 'PreRegistrationDetailsInProgressStatus';
  public static readonly PreRegistrationDetailsSuccessfulStatus = 'PreRegistrationDetailsSuccessfulStatus';
  public static readonly PreRegistrationDetailsUnsuccessfulStatus = 'PreRegistrationDetailsUnsuccessfulStatus';
  public static readonly PreRegistrationDetailsExpiredStatus = 'PreRegistrationDetailsExpiredStatus';
  public static readonly PreRegistrationDetailsContinueResponse = 'PreRegistrationDetailsContinueResponse';
  public static readonly PreRegistrationDetailsReferResponse = 'PreRegistrationDetailsReferResponse';
  public static readonly PreRegistrationDetailsNoDecisionResponse = 'PreRegistrationDetailsNoDecisionResponse';
  public static readonly PreRegistrationDetailsStopResponse = 'PreRegistrationDetailsStopResponse';
  public static readonly PreRegistrationDetailsBypassedResponse = 'PreRegistrationDetailsBypassedResponse';
  public static readonly PreviewSuitabilityReport = 'PreviewSuitabilityReport';
  public static readonly PreviousAddress = 'PreviousAddress';
  public static readonly PreviousTaxYearInterest = 'PreviousTaxYearInterest';
  public static readonly PrimaryContactId = 'PrimaryContact';
  public static readonly Principal = 'Principal';
  public static readonly PrintAmlResult = 'PrintAmlResult';
  public static readonly PrintCoversheetText = 'PrintCoversheetText';
  public static readonly PrintCoversheetTitle = 'PrintCoversheetTitle';
  public static readonly PrintDownloadPDF = 'PrintDownloadPDF';
  public static readonly PrintKycRequest = 'PrintKycRequest';
  public static readonly PrintPluginDetectionWindowContent = 'PrintPluginDetectionWindowContent';
  public static readonly PrintPluginDetectionWindowTitle = 'PrintPluginDetectionWindowTitle';
  public static readonly PrivacyAndCookiePolicy = 'PrivacyAndCookiePolicy';
  public static readonly PrivacyConfirm = 'PrivacyConfirm';
  public static readonly PrivacyDecline = 'PrivacyDecline';
  public static readonly PrivacyNoticeAccepted = 'PrivacyNoticeAccepted';
  public static readonly PrivacyNoticeMessage = 'PrivacyNoticeMessage';
  public static readonly PrivacyNoticeModalTitle = 'PrivacyNoticeModalTitle';
  public static readonly PrivacyNoticeNotAccepted = 'PrivacyNoticeNotAccepted';
  public static readonly PrivacyPolicy = 'PrivacyPolicy';
  public static readonly PrivatePensionSourceIncome = 'PrivatePensionSourceIncome';
  public static readonly PrivatePensionSourceProvider = 'PrivatePensionSourceProvider';
  public static readonly ProceedAndSubmit = 'ProceedAndSubmit';
  public static readonly ProceedButton = 'ProceedButton';
  public static readonly ProceedToDeclaration = 'ProceedToDeclaration';
  public static readonly ProceedWithSwitch = 'ProceedWithSwitch';
  public static readonly ProcurationFeePayableTo = 'ProcurationFeePayableTo';
  public static readonly ProductAboutToExpireApplication = 'ProductAboutToExpireApplication';
  public static readonly ProductAboutToExpireKfi = 'ProductAboutToExpireKFI';
  public static readonly ProductAdministration = 'ProductAdministration';
  public static readonly ProductArrangementFee = 'ProductArrangementFee';
  public static readonly ProductAuditName = 'ProductAuditName';
  public static readonly ProductAvailabilityCriteria = 'ProductAvailabilityCriteria';
  public static readonly ProductCode = 'ProductCode';
  public static readonly ProductCodeRequired = 'ProductCodeRequired';
  public static readonly ProductDescription = 'ProductDescription';
  public static readonly ProductDetailsAmendedBy = 'ProductDetailsAmendedBy';
  public static readonly ProductDetailsApr = 'ProductDetailsApr';
  public static readonly ProductDetailsAprRequired = 'ProductDetailsAprRequired';
  public static readonly ProductDetailsArrangementFee = 'ProductDetailsArrangementFee';
  public static readonly ProductDetailsBonusRate = 'ProductDetailsBonusRate';
  public static readonly ProductDetailsBookingFee = 'ProductDetailsBookingFee';
  public static readonly ProductDetailsBtlMultiplier = 'ProductDetailsBtlMultiplier';
  public static readonly ProductDetailsBtlRate = 'ProductDetailsBtlRate';
  public static readonly ProductDetailsCalulator = 'ProductDetailsCalulator';
  public static readonly ProductDetailsCode = 'ProductDetailsCode';
  public static readonly ProductDetailsCreateAip = 'ProductDetailsCreateAip';
  public static readonly ProductDetailsCreateApp = 'ProductDetailsCreateApp';
  public static readonly ProductDetailsCreateKfi = 'ProductDetailsCreateKfi';
  public static readonly ProductEPCRatingDateIssued = 'ProductEPCRatingDateIssued';
  public static readonly ProductDetailsDescription = 'ProductDetailsDescription';
  public static readonly ProductEPCRating = 'ProductEPCRating';
  public static readonly ProductDetailsEarlyRedemption = 'ProductDetailsEarlyRedemption';
  public static readonly ProductDetailsEndDate = 'ProductDetailsEndDate';
  public static readonly ProductDetailsExclusive = 'ProductDetailsExclusive';
  public static readonly ProductDetailsExclusiveFor = 'ProductDetailsExclusiveFor';
  public static readonly ProductDetailsExclusiveProduct = 'ProductDetailsExclusiveProduct';
  public static readonly ProductDetailsFooter = 'ProductDetailsFooter';
  public static readonly ProductDetailsFreeLegalsForPurchase = 'ProductDetailsFreeLegalsForPurchase';
  public static readonly ProductDetailsFreeLegalsForRemortgage = 'ProductDetailsFreeLegalsForRemortgage';
  public static readonly ProductDetailsFunctionality = 'ProductDetailsFunctionality';
  public static readonly ProductDetailsFunctionalityRequired = 'ProductDetailsFunctionalityRequired';
  public static readonly ProductDetailsHeader = 'ProductDetailsHeader';
  public static readonly ProductDetailsHigherLending = 'ProductDetailsHigherLending';
  public static readonly ProductDetailsHow = 'ProductDetailsHow';
  public static readonly ProductDetailsIncludeFeesLtv = 'ProductDetailsIncludeFeesLtv';
  public static readonly ProductDetailsInterfaceTypes = 'ProductDetailsInterfaceTypes';
  public static readonly ProductDetailsInterfaceTypesRequired = 'ProductDetailsInterfaceTypesRequired';
  public static readonly ProductDetailsTermChangeAvailable = 'ProductDetailsTermChangeAvailable';
  public static readonly ProductDetailsLoanType = 'ProductDetailsLoanType';
  public static readonly ProductDetailsLoanTypeRequired = 'ProductDetailsLoanTypeRequired';
  public static readonly ProductDetailsLocations = 'ProductDetailsLocations';
  public static readonly ProductDetailsLocationsRequired = 'ProductDetailsLocationsRequired';
  public static readonly ProductDetailsLtvInterest = 'ProductDetailsLtvInterest';
  public static readonly ProductDetailsLtvInterestRequired = 'ProductDetailsLtvInterestRequired';
  public static readonly ProductDetailsMaxAge = 'ProductDetailsMaxAge';
  public static readonly ProductDetailsMaxAgeRequired = 'ProductDetailsMaxAgeRequired';
  public static readonly ProductDetailsMaxLtv = 'ProductDetailsMaxLtv';
  public static readonly ProductDetailsMaxLtvPAndP = 'ProductDetailsMaxLtvPAndP';
  public static readonly ProductDetailsMaxLtvRequired = 'ProductDetailsMaxLtvRequired';
  public static readonly ProductDetailsMaxTerm = 'ProductDetailsMaxTerm';
  public static readonly ProductDetailsMaxTermRequired = 'ProductDetailsMaxTermRequired';
  public static readonly ProductDetailsMaxValue = 'ProductDetailsMaxValue';
  public static readonly ProductDetailsMaxValueRequired = 'ProductDetailsMaxValueRequired';
  public static readonly ProductDetailsMinAge = 'ProductDetailsMinAge';
  public static readonly ProductDetailsMinAgeRequired = 'ProductDetailsMinAgeRequired';
  public static readonly ProductDetailsMinTerm = 'ProductDetailsMinTerm';
  public static readonly ProductDetailsMinTermRequired = 'ProductDetailsMinTermRequired';
  public static readonly ProductDetailsMinValue = 'ProductDetailsMinValue';
  public static readonly ProductDetailsMinValueRequired = 'ProductDetailsMinValueRequired';
  public static readonly ProductDetailsName = 'ProductDetailsName';
  public static readonly ProductDetailsProcurationFee = 'ProductDetailsProcurationFee';
  public static readonly ProductDetailsProposition = 'ProductDetailsProposition';
  public static readonly ProductDetailsPropositionRequired = 'ProductDetailsPropositionRequired';
  public static readonly ProductDetailsRate = 'ProductDetailsRate';
  public static readonly ProductDetailsRateRequired = 'ProductDetailsRateRequired';
  public static readonly ProductDetailsSpecialFeatures = 'ProductDetailsSpecialFeatures';
  public static readonly ProductDetailsStartDate = 'ProductDetailsStartDate';
  public static readonly ProductDetailsStartImmediately = 'ProductDetailsStartImmediately';
  public static readonly ProductDetailsStatus = 'ProductDetailsStatus';
  public static readonly ProductDetailsStressRate = 'ProductDetailsStressRate';
  public static readonly ProductDetailsTags = 'ProductDetailsTags';
  public static readonly ProductDetailsTerm = 'ProductDetailsTerm';
  public static readonly ProductDetailsWhat = 'ProductDetailsWhat';
  public static readonly ProductDetailsWhen = 'ProductDetailsWhen';
  public static readonly ProductDetailsWho = 'ProductDetailsWho';
  public static readonly ProductDetailsWithdrawalDate = 'ProductDetailsWithdrawalDate';
  public static readonly ProductDetailsWithdrawn = 'ProductDetailsWithdrawn';
  public static readonly ProductFeatures = 'ProductFeatures';
  public static readonly ProductFeePaymentMethod = 'ProductFeePaymentMethod';
  public static readonly ProductFeePreferencesDescription = 'ProductFeePreferencesDescription';
  public static readonly ProductFeePreferencesNotificationMessage = 'ProductFeePreferencesNotificationMessage';
  public static readonly ProductFeePreferencesTitle = 'ProductFeePreferencesTitle';
  public static readonly ProductFeeSelectAnAccount = 'ProductFeeSelectAnAccount';
  public static readonly ProductLTV = 'ProductLTV';
  public static readonly ProductName = 'ProductName';
  public static readonly ProductOverallCost = 'ProductOverallCost';
  public static readonly ProductOverview = 'ProductOverview';
  public static readonly ProductPickerAmend = 'ProductPickerAmend';
  public static readonly ProductPickerAvailableProducts = 'ProductPickerAvailableProducts';
  public static readonly ProductPickerBorrowAmount = 'ProductPickerBorrowAmount';
  public static readonly ProductPickerConcessionaryPrice = 'ProductPickerConcessionaryPrice';
  public static readonly ProductPickerConfirmSwitchStep = 'ProductPickerConfirmSwitchStep';
  public static readonly ProductPickerEnterCriteria = 'ProductPickerEnterCriteria';
  public static readonly ProductPickerEnterCriteriaForBalanceRemaining =
    'ProductPickerEnterCriteriaForBalanceRemaining';
  public static readonly ProductPickerEnterCriteriaForComparativeTotal =
    'ProductPickerEnterCriteriaForComparativeTotal';
  public static readonly ProductPickerEnterCriteriaForPromotionalRatePeriodCost =
    'ProductPickerEnterCriteriaForPromotionalRatePeriodCost';
  public static readonly ProductPickerErrorMessage = 'ProductPickerErrorMessage';
  public static readonly ProductPickerGridBalanceRemaining = 'ProductPickerGridBalanceRemaining';
  public static readonly ProductPickerGridComparativeTotal = 'ProductPickerGridComparativeTotal';
  public static readonly ProductPickerGridEarlyRepaymentFees = 'ProductPickerGridEarlyRepaymentFees';
  public static readonly ProductPickerGridFees = 'ProductPickerGridFees';
  public static readonly ProductPickerGridMaximumLTV = 'ProductPickerGridMaximumLTV';
  public static readonly ProductPickerGridMonthlyRepayments = 'ProductPickerGridMonthlyRepayments';
  public static readonly ProductPickerGridOverallCost = 'ProductPickerGridOverallCost';
  public static readonly ProductPickerGridPromotionalRatePeriodCost = 'ProductPickerGridPromotionalRatePeriodCost';
  public static readonly ProductPickerGridStandardRate = 'ProductPickerGridStandardRate';
  public static readonly ProductPickerIncludeArrangment = 'ProductPickerIncludeArrangment';
  public static readonly ProductPickerInformationText = 'ProductPickerInformationText';
  public static readonly ProductPickerInterest = 'ProductPickerInterest';
  public static readonly ProductPickerLTV = 'ProductPickerLTV';
  public static readonly ProductPickerLoanTermYears = 'ProductPickerLoanTermYears';
  public static readonly ProductPickerModalTitle = 'ProductPickerModalTitle';
  public static readonly ProductPickerMortgageConfirm = 'ProductPickerMortgageConfirm';
  public static readonly ProductPickerMortgageOffer = 'ProductPickerMortgageOffer';
  public static readonly ProductPickerMortgageProductName = 'ProductPickerMortgageProductName';
  public static readonly ProductPickerMortgageProducts = 'ProductPickerMortgageProducts';
  public static readonly ProductPickerMortgageSelect = 'ProductPickerMortgageSelect';
  public static readonly ProductPickerMortgageSelectDecription = 'ProductPickerMortgageSelectDecription';
  public static readonly ProductPickerMortgageTerm = 'ProductPickerMortgageTerm';
  public static readonly ProductPickerNextButton = 'ProductPickerNextButton';
  public static readonly ProductPickerNoResults = 'ProductPickerNoResults';
  public static readonly ProductPickerNote = 'ProductPickerNote';
  public static readonly ProductPickerPropertyValue = 'ProductPickerPropertyValue';
  public static readonly ProductPickerPurchasePropertyPrice = 'ProductPickerPurchasePropertyPrice';
  public static readonly ProductPickerRepayment = 'ProductPickerRepayment';
  public static readonly ProductPickerRepaymentMethod = 'ProductPickerRepaymentMethod';
  public static readonly ProductPickerReset = 'ProductPickerReset';
  public static readonly ProductPickerReturnToHubButton = 'ProductPickerReturnToHubButton';
  public static readonly ProductPickerSecureYourFuture = 'ProductPickerSecureYourFuture';
  public static readonly ProductPickerSelectNewRateStep = 'ProductPickerSelectNewRateStep';
  public static readonly ProductPickerSelectSubAccountsStep = 'ProductPickerSelectSubAccountsStep';
  public static readonly ProductPickerShowing = 'ProductPickerShowing';
  public static readonly ProductPickerSortBy = 'ProductPickerSortBy';
  public static readonly ProductPickerSpecialFeatureContent = 'ProductPickerSpecialFeatureContent';
  public static readonly ProductPickerSpecialFeatureTitle = 'ProductPickerSpecialFeatureTitle';
  public static readonly ProductPickerText = 'ProductPickerText';
  public static readonly ProductPickerTitle = 'ProductPickerTitle';
  public static readonly ProductPickerTrueMarketValue = 'ProductPickerTrueMarketValue';
  public static readonly ProductPickerUpdate = 'ProductPickerUpdate';
  public static readonly ProductRate = 'ProductRate';
  public static readonly ProductSearch = 'ProductSearch';
  public static readonly ProductSearchAvailability = 'ProductSearchAvailability';
  public static readonly ProductSearchAvailableTo = 'ProductSearchAvailableTo';
  public static readonly ProductSearchCode = 'ProductSearchCode';
  public static readonly ProductSearchCreateNew = 'ProductSearchCreateNew';
  public static readonly ProductSearchHeader = 'ProductSearchHeader';
  public static readonly ProductSearchInterface = 'ProductSearchInterface';
  public static readonly ProductSearchLoanGroup = 'ProductSearchLoanGroup';
  public static readonly ProductSearchLoanType = 'ProductSearchLoanType';
  public static readonly ProductSearchLtvMax = 'ProductSearchLtvMax';
  public static readonly ProductSearchMaxLtvTitle = 'ProductSearchMaxLtvTitle';
  public static readonly ProductSearchOfferedTo = 'ProductSearchOfferedTo';
  public static readonly ProductSearchProductName = 'ProductSearchProductName';
  public static readonly ProductSearchProposition = 'ProductSearchProposition';
  public static readonly ProductSearchShowResult = 'ProductSearchShowResult';
  public static readonly ProductSearchStatus = 'ProductSearchStatus';
  public static readonly ProductSearchTag = 'ProductSearchTag';
  public static readonly ProductStatusLastChanged = 'ProductStatusLastChanged';
  public static readonly ProductSwitchConfirmationContent = 'ProductSwitchConfirmationContent';
  public static readonly ProductSwitchConfirmationLozenge = 'ProductSwitchConfirmationLozenge';
  public static readonly ProductSwitchConfirmationNotNowButton = 'ProductSwitchConfirmationNotNowButton';
  public static readonly ProductSwitchConfirmationRedirectUrl = 'ProductSwitchConfirmationRedirectUrl';
  public static readonly ProductSwitchConfirmationRegisterButton = 'ProductSwitchConfirmationRegisterButton';
  public static readonly ProductSwitchConfirmationTitle = 'ProductSwitchConfirmationTitle';
  public static readonly ProductTags = 'ProductTags';
  public static readonly ProductTransferDetails = 'ProductTransferDetails';
  public static readonly ProductTransferForMortgage = 'ProductTransferForMortgage';
  public static readonly ProductType = 'ProductType';
  public static readonly ProductWithdrawn = 'ProductWithdrawn';
  public static readonly ProductWithdrawnKFI = 'ProductWithdrawnKFI';
  public static readonly Products = 'Products';
  public static readonly ProductsHeader = 'ProductsHeader';
  public static readonly ProfileUpdateConfirmPasswordModalContent = 'ProfileUpdateConfirmPasswordModalContent';
  public static readonly ProfileUpdateConfirmPasswordModalTitle = 'ProfileUpdateConfirmPasswordModalTitle';
  public static readonly ProfileUpdateContactNumberConstraints = 'ProfileUpdateContactNumberConstraints';
  public static readonly ProgressAipToApp = 'ProgressAipToApp';
  public static readonly ProgressBarDefaultBody = 'ProgressBarDefaultBody';
  public static readonly ProgressBarDefaultHeader = 'ProgressBarDefaultHeader';
  public static readonly ProgressBarSubmitAppBody = 'ProgressBarSubmitAppBody';
  public static readonly ProgressBarSubmitAppHeader = 'ProgressBarSubmitAppHeader';
  public static readonly ProgressBarSubmitFactFindBody = 'ProgressBarSubmitFactFindBody';
  public static readonly ProgressBarSubmitFactFindHeader = 'ProgressBarSubmitFactFindHeader';
  public static readonly ProgressKfiToAip = 'ProgressKfiToAip';
  public static readonly ProgressKfiToApp = 'ProgressKfiToApp';
  public static readonly PromotionalRateEndDate = 'PromotionalRateEndDate';
  public static readonly PropertyAddress = 'PropertyAddress';
  public static readonly PropertyContacts = 'PropertyContacts';
  public static readonly PropertyDetailsForApplication = 'PropertyDetailsForApplication';
  public static readonly PropertyEstimatedValue = 'PropertyEstimatedValue';
  public static readonly PropertyLocation = 'PropertyLocation';
  public static readonly PropertyPostCode = 'PropertyPostCode';
  public static readonly PropertySellingPriceId = 'PropertySellingPrice';
  public static readonly PropertySharePercentage = 'PropertySharePercentage';
  public static readonly PropertyValueContactUsText = 'PropertyValueContactUsText';
  public static readonly ProposedBorrowingAmount = 'ProposedBorrowingAmount';
  public static readonly ProposedEmailUsername = 'ProposedEmailUsername';
  public static readonly ProposedTermId = 'ProposedTerm';
  public static readonly PropositionAvailableDate = 'PropositionAvailableDate';
  public static readonly PropositionCrossSystemIdentifier = 'PropositionCrossSystemIdentifier';
  public static readonly PropositionFilterSection = 'PropositionFilterSection';
  public static readonly PropositionID = 'PropositionID';
  public static readonly PropositionName = 'PropositionName';
  public static readonly PropositionStatusCode = 'PropositionStatusCode';
  public static readonly Propositions = 'Propositions';
  public static readonly ProvideAdditionalInfoNoCard = 'ProvideAdditionalInfoNoCard';
  public static readonly ProvideAtLeastOneContactNumber = 'ProvideAtLeastOneContactNumber';
  public static readonly ProvideDetails = 'ProvideDetails';
  public static readonly ProvidePhoneNo = 'ProvidePhoneNo';
  public static readonly ProvideTelephoneNumber = 'ProvideTelephoneNumber';
  public static readonly ProvideEmailAndPhoneNumber = 'ProvideEmailAndPhoneNumber';
  public static readonly ProvideAtLeastOnePhoneNumber = 'ProvideAtLeastOnePhoneNumber';
  public static readonly ProvidePhoneNumber = 'ProvidePhoneNumber';
  public static readonly PublishIllustration = 'PublishIllustration';
  public static readonly PurchaseAnotherPropertyId = 'PurchasingAnotherProperty';
  public static readonly PurchaseDateOfPropertyRemortgaging = 'PurchaseDateOfPropertyRemortgaging';
  public static readonly PurchaseId = 'Purchase';
  public static readonly PurchasePrice = 'PurchasePrice';
  public static readonly Purpose = 'Purpose';
  public static readonly Question = 'Question';
  public static readonly Range = 'Range';
  public static readonly ReductionDecisionLabel = 'ReductionDecisionLabel';
  public static readonly ReductionDecisionTooltip = 'WhatToReduceTooltipLabel';
  public static readonly ReInspectionFeeId = 'ReInspectionFee';
  public static readonly RemainingBalanceAfterPRInformation = 'RemainingBalanceAfterPRInformation';
  public static readonly ReMortgageAdditionalProperty = 'ReMortgageAdditionalProperty';
  public static readonly ReMortgageAdditionalPropertyBTL = 'ReMortgageAdditionalPropertyBTL';
  public static readonly ReMortgageAdditionalPropertyDetails = 'ReMortgageAdditionalPropertyDetails';
  public static readonly ReMortgageBusinessInvestment = 'ReMortgageBusinessInvestment';
  public static readonly ReMortgageBusinessInvestmentDetails = 'ReMortgageBusinessInvestmentDetails';
  public static readonly ReMortgageCostsAndFees = 'ReMortgageCostsAndFees';
  public static readonly ReMortgageCostsAndFeesDetails = 'ReMortgageCostsAndFeesDetails';
  public static readonly ReMortgageHomeImprovement = 'ReMortgageHomeImprovement';
  public static readonly ReMortgageHomeImprovementBTL = 'ReMortgageHomeImprovementBTL';
  public static readonly ReMortgageHomeImprovementDetails = 'ReMortgageHomeImprovementDetails';
  public static readonly ReMortgageLoanRepayment = 'ReMortgageLoanRepayment';
  public static readonly ReMortgageOtherPropertyImprovement = 'ReMortgageOtherPropertyImprovement';
  public static readonly ReMortgageOutrightPropertyPurchase = 'ReMortgageOutrightPropertyPurchase';
  public static readonly ReMortgageOutrightPropertyPurchaseBTL = 'ReMortgageOutrightPropertyPurchaseBTL';
  public static readonly ReMortgageOutrightPropertyPurchaseDetails = 'ReMortgageOutrightPropertyPurchaseDetails';
  public static readonly ReMortgageSchoolFeesOrPension = 'ReMortgageSchoolFeesOrPension';
  public static readonly ReMortgageSchoolFeesOrPensionDetails = 'ReMortgageSchoolFeesOrPensionDetails';
  public static readonly ReRecommend = 'ReRecommend';
  public static readonly ReactivateCase = 'ReactivateCase';
  public static readonly ReadDeclaration = 'ReadDeclaration';
  public static readonly ReadRegistrationTermsAndConditions = 'ReadRegistrationTermsAndConditions';
  public static readonly ReadonlyObsoleteFieldNotificationText = 'ReadonlyObsoleteFieldNotificationText';
  public static readonly ReadonlyObsoleteFieldNotificationTitle = 'ReadonlyObsoleteFieldNotificationTitle';
  public static readonly OfferDownloadZipBundle = 'OfferDownloadZipBundle';
  public static readonly ReasonForMortgage = 'ReasonForMortgage';
  public static readonly ReasonForRefound = 'ReasonForRefound';
  public static readonly ReasonForRefund = 'ReasonForRefund';
  public static readonly ReceiveCaseNotifications = 'ReceiveCaseNotifications';
  public static readonly Recommendation = 'Recommendation';
  public static readonly RecommendationCreated = 'RecommendationCreated';
  public static readonly RecommendationHeader = 'RecommendationHeader';
  public static readonly RecordsBy = 'RecordsBy';
  public static readonly RecordsChangesNotFound = 'RecordsChangesNotFound';
  public static readonly RecordsCompareAnd = 'RecordsCompareAnd';
  public static readonly RecordsCompareButton = 'RecordsCompareButton';
  public static readonly RecordsCompareChangesBetween = 'RecordsCompareChangesBetween';
  public static readonly RecordsCompareError = 'RecordsCompareError';
  public static readonly RecordsCompareOr = 'RecordsCompareOr';
  public static readonly RecordsCurrentlyComparingChangesFrom = 'RecordsCurrentlyComparingChangesFrom';
  public static readonly RecordsSavedBy = 'RecordsSavedBy';
  public static readonly RecordsShowTheLastTwo = 'RecordsShowTheLastTwo';
  public static readonly RecordsSubmitted = 'RecordsSubmitted';
  public static readonly RecordsSubmittedBy = 'RecordsSubmittedBy';
  public static readonly RecordsTo = 'RecordsTo';
  public static readonly RedemptionMortgageOnOtherProperty = 'RedemptionMortgageOnOtherProperty';
  public static readonly RedemptionMortgageOnOtherPropertyDetails = 'RedemptionMortgageOnOtherPropertyDetails';
  public static readonly RedirectText = 'RedirectText';
  public static readonly RedirectTitle = 'RedirectTitle';
  public static readonly ReductionLabel = 'ReductionLabel';
  public static readonly ReferenceDataCategory = 'ReferenceDataCategory';
  public static readonly ReferenceNumber = 'ReferenceNumber';
  public static readonly ReferencesNumber = 'ReferencesNumber';
  public static readonly ReferringBranch = 'ReferringBranch';
  public static readonly RefferingIndividual = 'RefferingIndividual';
  public static readonly Refresh = 'Refresh';
  public static readonly RefreshAccount = 'RefreshAccount';
  public static readonly RefreshKycStatus = 'RefreshKycStatus';
  public static readonly RefreshNotificationMessage = 'RefreshNotificationMessage';
  public static readonly Refund = 'Refund';
  public static readonly RefundAuthorizedMessage = 'RefundAuthorizedMessage';
  public static readonly RefundFees = 'RefundFees';
  public static readonly RefundMadeForPayment = 'RefundMadeForPayment';
  public static readonly RefundOfflineButton = 'RefundOfflineButton';
  public static readonly RefundPaymentConfirmationMessage = 'RefundPaymentConfirmationMessage';
  public static readonly RefundReason = 'RefundReason';
  public static readonly RefundTotalAmount = 'RefundTotalAmount';
  public static readonly RefundUnauthorizedMessage = 'RefundUnauthorizedMessage';
  public static readonly RefundWindowTitle = 'RefundWindowTitle';
  public static readonly RefundableId = 'Refundable';
  public static readonly RefusedLoan = 'RefusedLoan';
  public static readonly RefusedLoanDetails = 'RefusedLoanDetails';
  public static readonly RegenerateBrokenPdf = 'RegenerateBrokenPdf';
  public static readonly Register = 'Register';
  public static readonly RegisterDetails = 'RegisterDetails';
  public static readonly RegisterHeaderSection = 'RegisterHeaderSection';
  public static readonly RegisterToCustomerHub = 'RegisterToCustomerHub';
  public static readonly Registered = 'Registered';
  public static readonly RegisteredForProposition = 'RegisteredForProposition';
  public static readonly RegisteredUsers = 'RegisteredUsers';
  public static readonly RegisteredUsersBranchMenu = 'RegisteredUsersBranchMenu';
  public static readonly RegisteredUsersDirectMenu = 'RegisteredUsersDirectMenu';
  public static readonly RegisteredUsersIntermediariesMenu = 'RegisteredUsersIntermediariesMenu';
  public static readonly Registering = 'Registering';
  public static readonly RegistrationConfirmEmail = 'RegistrationConfirmEmail';
  public static readonly RegistrationDetails = 'RegistrationDetails';
  public static readonly RegistrationEmail = 'RegistrationEmail';
  public static readonly RegistrationPrincipal = 'RegistrationPrincipal';
  public static readonly RegistrationRoles = 'RegistrationRoles';
  public static readonly RegularMonthlyPaymentError = 'RegularMonthlyPaymentError';
  public static readonly ReinstateAdvice = 'ReinstateAdvice';
  public static readonly ReinstateCase = 'ReinstateCase';
  public static readonly Reject = 'Reject';
  public static readonly RejectionConfirmation = 'RejectionConfirmation';
  public static readonly RejectionConfirmationText = 'RejectionConfirmationText';
  public static readonly RejectionNotes = 'RejectionNotes';
  public static readonly RejectionReason = 'RejectionReason';
  public static readonly RelationshipToYouId = 'RelationshipToYou';
  public static readonly ReleaseAssessment = 'ReleaseAssessment';
  public static readonly ReleaseTag = 'ReleaseTag';
  public static readonly ReleasedFromAdvised = 'ReleasedFromAdvised';
  public static readonly RemortgageCurrentResidentialPropertyCode = 'RemortgageCurrentResidentialPropertyCode';
  public static readonly RemortgageId = 'Remortgage';
  public static readonly RemortgagingId = 'Remortgaging';
  public static readonly RemoveCaseLinkButton = 'RemoveCaseLinkButton';
  public static readonly RemoveCaseLinkWindowDetails = 'RemoveCaseLinkWindowDetails';
  public static readonly RemoveCaseLinkWindowTitle = 'RemoveCaseLinkWindowTitle';
  public static readonly RemoveLinkToSamCustomer = 'RemoveLinkToSamCustomer';
  public static readonly RemoveSamCustomerLinkWindowButton = 'RemoveSamCustomerLinkWindowButton';
  public static readonly RemoveSamCustomerLinkWindowDetails = 'RemoveSamCustomerLinkWindowDetails';
  public static readonly RemoveSamCustomerLinkWindowTitle = 'RemoveSamCustomerLinkWindowTitle';
  public static readonly RemoveSamCustomerNote = 'RemoveSamCustomerNote';
  public static readonly RemoveSelectedRate = 'RemoveSelectedRate';
  public static readonly RepaymentMaturityDate = 'RepaymentMaturityDate';
  public static readonly RepaymentMethodInterestOnly = 'RepaymentMethodInterestOnly';
  public static readonly RepaymentMethodInterestOnlyFF = 'RepaymentMethodInterestOnlyFF';
  public static readonly RepaymentMethodLoan = 'RepaymentMethodLoan';
  public static readonly RepaymentMethodLoanFF = 'RepaymentMethodLoanFF';
  public static readonly RepaymentMonthlyCost = 'RepaymentMonthlyCost';
  public static readonly RepaymentPartId = 'RepaymentPart';
  public static readonly RepaymentProjectedValue = 'RepaymentProjectedValue';
  public static readonly RepaymentStrategy = 'RepaymentStrategy';
  public static readonly RepaymentStrategyDescription = 'RepaymentStrategyDescription';
  public static readonly RepaymentStrategyOnSponsorProperty = 'RepaymentStrategyOnSponsorProperty';
  public static readonly RepaymentStrategyTitle = 'RepaymentStrategyTitle';
  public static readonly RepaymentStrategyType = 'RepaymentStrategyType';
  public static readonly RepaymentTypeFFId = 'RepaymentTypeFF';
  public static readonly RepaymentTypeId = 'RepaymentType';
  public static readonly RepaymentTypeReason = 'RepaymentTypeReason';
  public static readonly ReplaceIllustration = 'ReplaceIllustration';
  public static readonly ReplaceMortgageQuoteDialogTitle = 'ReplaceMortgageQuoteDialogTitle';
  public static readonly RepresentativeExampleBtl = 'RepresentativeExampleBtl';
  public static readonly RepresentativeExampleResidential = 'RepresentativeExampleResidential';
  public static readonly RequestAdvice = 'RequestAdvice';
  public static readonly RequestAdviceBtl = 'RequestAdviceBtl';
  public static readonly RequestAnEsisButtonLabel = 'RequestAnEsisButtonLabel';
  public static readonly RequestEsisInformationWindowDescription = 'RequestEsisInformationWindowDescription';
  public static readonly RequestIllustration = 'RequestIllustration';
  public static readonly RequestInterviewAction = 'RequestInterviewAction';
  public static readonly RequestInterviewBackLink = 'RequestInterviewBackLink';
  public static readonly RequestInterviewDescription = 'RequestInterviewDescription';
  public static readonly RequestInterviewSubtitle = 'RequestInterviewSubtitle';
  public static readonly RequestInterviewTitle = 'RequestInterviewTitle';
  public static readonly RequestSwitch = 'RequestSwitch';
  public static readonly RequestSwitchDescription = 'RequestSwitchDescription';
  public static readonly CannotSwitchDescription = 'CannotSwitchDescription';
  public static readonly RequestSwitchOrIllustration = 'RequestSwitchOrIllustration';
  public static readonly RequestSwitchOrIllustrationDescription = 'RequestSwitchOrIllustrationDescription';
  public static readonly RequestSwitchOrIllustrationModalTitle = 'RequestSwitchOrIllustrationModalTitle';
  public static readonly RequestSwitchOrIllustrationText = 'RequestSwitchOrIllustrationText';
  public static readonly RequiredFieldError = 'RequiredFieldError';
  public static readonly RequiresAdvice = 'RequiresAdvice';
  public static readonly Resend = 'Resend';
  public static readonly ResendAccessCodeInformation = 'ResendAccessCodeInformation';
  public static readonly ResendAccessCodeTo = 'ResendAccessCodeTo';
  public static readonly ResendAccessLetter = 'ResendAccessLetter';
  public static readonly ResendEmail = 'ResendEmail';
  public static readonly ResendLetterAccessTokenTitle = 'ResendLetterAccessTokenTitle';
  public static readonly ResendOfferEmail = 'ResendOfferEmail';
  public static readonly ResendOfferEmailDescription = 'ResendOfferEmailDescription';
  public static readonly ResendOfferEmailTitle = 'ResendOfferEmailTitle';
  public static readonly ResendOfferEmailTo = 'ResendOfferEmailTo';
  public static readonly ResendRegistrationEmail = 'ResendRegistrationEmail';
  public static readonly ResendSms = 'ResendSms';
  public static readonly ResendSmsConfirmationText = 'ResendSmsConfirmationText';
  public static readonly ResendSmsText = 'ResendSmsText';
  public static readonly ResendSmsTryAgainLaterText = 'ResendSmsTryAgainLaterText';
  public static readonly ResendUserChangeConfirmation = 'ResendUserChangeConfirmation';
  public static readonly ResetDefault = 'ResetDefault';
  public static readonly ResetForgottenPasswordSuccess = 'ResetForgottenPasswordSuccess';
  public static readonly ResetPassword = 'ResetPassword';
  public static readonly ResetPasswordError = 'ResetPasswordError';
  public static readonly ResetPasswordNote = 'ResetPasswordNote';
  public static readonly ResetPasswordTitle = 'ResetPasswordTitle';
  public static readonly ResetTermChange = 'ResetTermChange';
  public static readonly ResetYourPassword = 'ResetYourPassword';
  public static readonly ResidentialAIP = 'ResidentialAIP';
  public static readonly ResidentialApplyWithAdvice = 'ResidentialApplyWithAdvice';
  public static readonly ResidentialApplyWithoutAdvice = 'ResidentialApplyWithoutAdvice';
  public static readonly ResidentialInterestOnlyConfirmationMessage = 'ResidentialInterestOnlyConfirmationMessage';
  public static readonly ResidentialInterestOnlyReadGuide = 'ResidentialInterestOnlyReadGuide';
  public static readonly ResidentialOnlineAdvisedComplaintInformation = 'ResidentialOnlineAdvisedComplaintInformation';
  public static readonly ResidentialOnlineAdvisedExistingMortgageText = 'ResidentialOnlineAdvisedExistingMortgageText';
  public static readonly ResidentialOnlineAdvisedExistingMortgageTitle =
    'ResidentialOnlineAdvisedExistingMortgageTitle';
  public static readonly ResidentialOnlineAdvisedGettingStartedText = 'ResidentialOnlineAdvisedGettingStartedText';
  public static readonly ResidentialOnlineAdvisedIntroText = 'ResidentialOnlineAdvisedIntroText';
  public static readonly ResidentialOnlineAdvisedLookingForAdviceText = 'ResidentialOnlineAdvisedLookingForAdviceText';
  public static readonly ResidentialOnlineAdvisedLookingForAdviceTitle =
    'ResidentialOnlineAdvisedLookingForAdviceTitle';
  public static readonly ResidentialOnlineAdvisedMortgagesInformation = 'ResidentialOnlineAdvisedMortgagesInformation';
  public static readonly ResidentialOnlineAdvisedPageTitle = 'ResidentialOnlineAdvisedPageTitle';
  public static readonly ResidentialOnlineAdvisedStepParagraph = 'ResidentialOnlineAdvisedStepParagraph';
  public static readonly ResidentialOnlineAdvisedStepTitle = 'ResidentialOnlineAdvisedStepTitle';
  public static readonly ResidentialOnlineAdvisedUsefulToKnowText = 'ResidentialOnlineAdvisedUsefulToKnowText';
  public static readonly ResidentialStatus = 'ResidentialStatus';
  public static readonly ResidentialStepTwoConsolidateDebtQuestion = 'ResidentialStepTwoConsolidateDebtQuestion';
  public static readonly ResidentialStepTwoReceivedAdviceQuestion = 'ResidentialStepTwoReceivedAdviceQuestion';
  public static readonly RespondButton = 'RespondButton';
  public static readonly Restart = 'Restart';
  public static readonly ResendCustomerVerification = 'ResendCustomerVerification';
  public static readonly ResubmitSam = 'ResubmitSam';
  public static readonly ResultsPerPage = 'ResultsPerPage';
  public static readonly Return = 'Return';
  public static readonly RetryFromLastSuccessfulStepLabel = 'RetryFromLastSuccessfulStepLabel';
  public static readonly RetryOfferGeneration = 'RetryOfferGeneration';
  public static readonly RevertMonthlyPayment = 'RevertMonthlyPayment';
  public static readonly RevertMonthlyPaymentError = 'RevertMonthlyPaymentError';
  public static readonly RevertRate = 'RevertRate';
  public static readonly RevertRateContextualMessage = 'RevertRateContextualMessage';
  public static readonly Right = 'Right';
  public static readonly Role = 'Role';
  public static readonly RolePermissionsAuditName = 'RoleAuditName';
  public static readonly RolePermissionsBO = 'RolePermissionsBO';
  public static readonly RolePermissionsTitle = 'RolePermissionsTitle';
  public static readonly RoleTitle = 'RoleTitle';
  public static readonly RoleType = 'RegistrationRoleType';
  public static readonly Roles = 'Roles';
  public static readonly RolesQA = 'RolesQA';
  public static readonly RolesStripAdvice = 'RolesStripAdvice';
  public static readonly RolesStripContent = 'RolesStripContent';
  public static readonly RolesStripTitle = 'RolesStripTitle';
  public static readonly Rome = 'Rome';
  public static readonly RomeCustomer = 'RomeCustomer';
  public static readonly RomeIdLinkedWarning = 'RomeIdLinkedWarning';
  public static readonly RomeIdLinkedWarningTitle = 'RomeIdLinkedWarningTitle';
  public static readonly Rule = 'Rule';
  public static readonly SCCViewResult = 'SCCViewResult';
  public static readonly SMS = 'SMS';
  public static readonly SamAccountType = 'SamAccountType';
  public static readonly SamClass = 'SamClass';
  public static readonly SamCustomerDoesNotMatchWarning = 'SamCustomerDoesNotMatchWarning';
  public static readonly SamCustomerDoesNotMatchWarningTitle = 'SamCustomerDoesNotMatchWarningTitle';
  public static readonly SamCustomerID = 'SamCustomerID';
  public static readonly SamCustomerNumber = 'SamCustomerNumber';
  public static readonly Save = 'Save';
  public static readonly SaveAndCloseButton = 'SaveAndCloseButton';
  public static readonly SaveAndSendValidationEmail = 'SaveAndSendValidationEmail';
  public static readonly SaveChanges = 'SaveChanges';
  public static readonly SaveContinueId = 'SaveAndContinue';
  public static readonly SaveContinueToNextStepId = 'SaveAndContinueNextStep';
  public static readonly SaveMortgageOfferBundle = 'SaveMortgageOfferBundle';
  public static readonly SaveNameMissing = 'MissingSaveNameError';
  public static readonly SaveSearch = 'SaveSearch';
  public static readonly SaveSearchApply = 'SaveSearchApply';
  public static readonly SaveSearchDelete = 'SaveSearchDelete';
  public static readonly SaveSearchDeleteConfirmation = 'SaveSearchDeleteConfirmation';
  public static readonly SaveSearches = 'SaveSearches';
  public static readonly Score = 'Score';
  public static readonly SearchAndSelectProduct = 'SearchAndSelectProduct';
  public static readonly SearchCaseWindowDetails = 'SearchCaseWindowDetails';
  public static readonly SearchCaseWindowTitle = 'SearchCaseWindowTitle';
  public static readonly SearchCustomer = 'SearchCustomer';
  public static readonly SearchDone = 'SearchDone';
  public static readonly SearchExistingCaseInformation = 'SearchExistingCaseInformation';
  public static readonly SearchExistingMortgageDataDoesNotMatch = 'SearchExistingMortgageDataDoesNotMatch';
  public static readonly SearchForBranch = 'SearchForBranch';
  public static readonly SearchForDirectCustomer = 'SearchForDirectCustomer';
  public static readonly SearchForIntermediary = 'SearchForIntermediary';
  public static readonly SearchForRegisteredUsersHeader = 'SearchForRegisteredUsersHeader';
  public static readonly SearchRates = 'SearchRates';
  public static readonly SearchResults = 'SearchResults';
  public static readonly SearchRomeUsers = 'SearchRomeUsers';
  public static readonly SearchSamCustomerDetails = 'SearchSamCustomerDetails';
  public static readonly SearchSamCustomerIdButton = 'SearchSamCustomerIdButton';
  public static readonly SearchSamCustomerTitle = 'SearchSamCustomerTitle';
  public static readonly SearchSolicitorButton = 'SearchSolicitorButtonLabel';
  public static readonly SearchTextPlaceholder = 'SearchTextPlaceholder';
  public static readonly SectionComplete = 'SectionComplete';
  public static readonly SectionContains = 'SectionContains';
  public static readonly SectionIncomplete = 'SectionIncomplete';
  public static readonly SectionMortgageAccountTitle = 'SectionMortgageAccountTitle';
  public static readonly SectionTitleDeclaration = 'SectionTitleDeclaration';
  public static readonly SectionTitleMortgage = 'SectionTitleMortgage';
  public static readonly SectionTitleOutgoings = 'SectionTitleOutgoings';
  public static readonly SectionTitleProperty = 'SectionTitleProperty';
  public static readonly SectionYourActions = 'SectionYourActions';
  public static readonly SectionYourDocuments = 'SectionYourDocuments';
  public static readonly SectionYourFees = 'SectionYourFees';
  public static readonly SectionYourMortgage = 'SectionYourMortgage';
  public static readonly Security = 'Security';
  public static readonly SecurityQuestion = 'SecurityQuestion';
  public static readonly SecurityQuestions = 'SecurityQuestions';
  public static readonly SeeAllCasesWithNotifications = 'SeeAllCasesWithNotifications';
  public static readonly SelectAddress = 'SelectAddress';
  public static readonly SelectAProductId = 'SelectProduct';
  public static readonly SelectApplicant = 'SelectApplicant';
  public static readonly SelectCategory = 'SelectCategory';
  public static readonly SelectMortgageClub = 'SelectMortgageClub';
  public static readonly SelectOwner = 'SelectOwner';
  public static readonly SelectTeam = 'SelectTeam';
  public static readonly SelfEmplyedWarning = 'SelfEmplyedWarning';
  public static readonly SellingCurrentResidentialProperty = 'SellingCurrentResidentialProperty';
  public static readonly SendMeNotifications = 'SendMeNotifications';
  public static readonly SendOfferByPostConfirmationDescription = 'SendOfferByPostConfirmationDescription';
  public static readonly SendOfferByPostConfirmationTitle = 'SendOfferByPostConfirmationTitle';
  public static readonly SendRegistrationEmail = 'SendRegistrationEmail';
  public static readonly SendRegistrationEmailAlreadyRegistered = 'SendRegistrationEmailAlreadyRegistered';
  public static readonly SendRegistrationEmailDetails = 'SendRegistrationEmailDetails';
  public static readonly SendRegistrationEmailSuccessful = 'SendRegistrationEmailSuccessful';
  public static readonly SendRegistrationEmailTitle = 'SendRegistrationEmailTitle';
  public static readonly SendSms = 'SendSms';
  public static readonly SendSmsText = 'SendSmsText';
  public static readonly SentOn = 'SentOn';
  public static readonly ServiceLevelSection = 'ServiceLevelSection';
  public static readonly ServiceUserNumber = 'ServiceUserNumber';
  public static readonly SetAwaitingCustomer = 'SetAwaitingCustomer';
  public static readonly SetPassword = 'SetPassword';
  public static readonly SetToInProgressButton = 'SetToInProgressButton';
  public static readonly Sex = 'Sex';
  public static readonly ShowActivityButton = 'ShowActivityButton';
  public static readonly ShowAllTransactions = 'ShowAllTransactions';
  public static readonly ShowOnlySAMFailedUpdateAccountsLabel = 'ShowOnlySAMFailedUpdateAccountsLabel';
  public static readonly ShowSearchResults = 'ShowSearchResults';
  public static readonly SingleAcceptanceApplicantName = 'SingleAcceptanceApplicantName';
  public static readonly Skip = 'Skip';
  public static readonly SoftCreditCheckResults = 'SoftCreditCheckResults';
  public static readonly SoftCreditCheckResultsDecision = 'SoftCreditCheckResultsDecision';
  public static readonly SoftCreditCheckResultsPolicyRules = 'SoftCreditCheckResultsPolicyRules';
  public static readonly SoftCreditCheckResultsScoreband = 'SoftCreditCheckResultsScoreband';
  public static readonly SoftCreditSearchProcessContent = 'SoftCreditSearchProcessContent';
  public static readonly SoftCreditWarning = 'SoftCreditWarning';
  public static readonly SoftCreditWarningContent = 'SoftCreditWarningContent';
  public static readonly Solicitor = 'Solicitor';
  public static readonly SolicitorAddress = 'SolicitorAddress';
  public static readonly SolicitorDescription = 'SolicitorDescription';
  public static readonly SolicitorChoose = 'SolicitorChoose';
  public static readonly SolicitorFirmCaveat = 'SolicitorFirmCaveat';
  public static readonly SolicitorFirmName = 'SolicitorFirmName';
  public static readonly SolicitorFirmPostcode = 'SolicitorFirmPostcode';
  public static readonly SolicitorFirmWarning = 'SolicitorFirmWarning';
  public static readonly UnableProceedWithoutSolicitorFromPanel = 'UnableProceedWithoutSolicitorFromPanel';
  public static readonly UpdateLoginDetailsButtonLabel = 'UpdateLoginDetailsButtonLabel';
  public static readonly UpdateLoginDetailsModalDescription = 'UpdateLoginDetailsModalDescription';
  public static readonly UpdateLoginDetailsModalTitle = 'UpdateLoginDetailsModalTitle';
  public static readonly SolicitorLegalServiceParagraph = 'SolicitorLegalServiceParagraph';
  public static readonly SolicitorListWarning = 'SolicitorListWarning';
  public static readonly SolicitorManuallyEnterButton = 'SolicitorManuallyEnterButtonLabel';
  public static readonly SolicitorFirmNotShown = 'SolicitorFirmNotShown';
  public static readonly SolicitorPlaceholderGroupName = 'SolicitorPlaceholderGroupName';
  public static readonly SolicitorPostcodeWarning = 'SolicitorPostcodeWarning';
  public static readonly SolicitorSelectButton = 'SolicitorSelectButtonLabel';
  public static readonly SortCode = 'SortCode';
  public static readonly Source = 'Source';
  public static readonly SourceOfFunds = 'SourceOfFunds';
  public static readonly SourceOfFundsLabel = 'SourceOfFundsLabel';
  public static readonly SourceOfOtherRegularIncomeId = 'OtherRegularIncomeSource';
  public static readonly SourceOfWealth = 'SourceOfWealth';
  public static readonly SourceOfWealthDetails = 'SourceOfWealthDetails';
  public static readonly SpamEmails = 'SpamEmails';
  public static readonly SpamEmailsContent = 'SpamEmailsContent';
  public static readonly SpamEmailsTitle = 'SpamEmailsTitle';
  public static readonly SpeakWithAdvisorButton = 'SpeakWithAdvisorButton';
  public static readonly StaffAuditName = 'StaffAuditName';
  public static readonly StandardValuationFeePaidByLender = 'StandardValuationFeePaidByLender';
  public static readonly StartWritingBusiness = 'StartWritingBusiness';
  public static readonly StaticOverlay = 'StaticOverlay';
  public static readonly StatusEmployeedId = 'E';
  public static readonly StatusLastChanged = 'StatusLastChanged';
  public static readonly StatusNotEmployeedId = 'U';
  public static readonly StatusRetiredEmployeedId = 'R';
  public static readonly StatusSelfEmployeedId = 'S';
  public static readonly StepsIndicatorText = 'StepsIndicatorText';
  public static readonly SubaccountPart = 'SubaccountPart';
  public static readonly Submit = 'Submit';
  public static readonly SubmitApplication = 'SubmitApplication';
  public static readonly SubmitButtonMiniForm = 'SubmitButtonMiniForm';
  public static readonly SubmitFactFind = 'SubmitFactFind';
  public static readonly SubmitKfiErrorMessage = 'SubmitKfiErrorMessage';
  public static readonly SubmitRegistration = 'SubmitRegistration';
  public static readonly Submited = 'Submited';
  public static readonly SubmittedFactFind = 'SubmittedFactFind';
  public static readonly SuitabilityReport = 'SuitabilityReport';
  public static readonly SuitabilityReportAffordabilityWarning = 'SuitabilityReportAffordabilityWarning';
  public static readonly SuitabilityReportConfigurationTitle = 'SuitabilityReportConfigurationTitle';
  public static readonly SuitabilityReportIconText = 'SuitabilityReportIconText';
  public static readonly SummitAccountsNotFound = 'SummitAccountsNotFound';
  public static readonly SummitCorrespondenceAddress = 'SummitCorrespondenceAddress';
  public static readonly SummitCustomerNotFound = 'SummitCustomerNotFound';
  public static readonly SummitEmailAddress = 'SummitEmailAddress';
  public static readonly SummitHomePhoneNumber = 'SummitHomePhoneNumber';
  public static readonly SummitMobilePhoneNumber = 'SummitMobilePhoneNumber';
  public static readonly SummitWorkPhoneNumber = 'SummitWorkPhoneNumber';
  public static readonly Surname = 'Surname';
  public static readonly SurveyCompletedById = 'SurveyCompletedBy';
  public static readonly SwitchButtonText = 'SwitchButtonText';
  public static readonly SwitchCaseStatus = 'SwitchCaseStatus';
  public static readonly SwitchConfigurationConfirmButton = 'SwitchConfigurationConfirmButton';
  public static readonly SwitchConfigurationDeclineMessage = 'SwitchConfigurationDeclineMessage';
  public static readonly SwitchConfigurationInformationMessage = 'SwitchConfigurationInformationMessage';
  public static readonly SwitchConfigurationTitle = 'SwitchConfigurationTitle';
  public static readonly SwitchDate = 'SwitchDate';
  public static readonly SwitchFeePayableAtApplication = 'SwitchFeePayableAtApplication';
  public static readonly SwitchFeePayableAtCompletion = 'SwitchFeePayableAtCompletion';
  public static readonly SwitchFeePayableAtOffer = 'SwitchFeePayableAtOffer';
  public static readonly SwitchHeaderSection = 'SwitchHeaderSection';
  public static readonly SwitchHelpContent = 'SwitchHelpContent';
  public static readonly SwitchInProgressLozenge = 'SwitchInProgressLozenge';
  public static readonly SwitchMortgageProductsAvailable = 'SwitchMortgageProductsAvailable';
  public static readonly SwitchNewRateText = 'SwitchNewRateText';
  public static readonly SwitchOffer = 'SwitchOffer';
  public static readonly SwitchOfferCommunicationMethodToLetter = 'SwitchOfferCommunicationMethodToLetter';
  public static readonly SwitchOfferDistributionChannel = 'SwitchOfferDistributionChannel';
  public static readonly SwitchPayFee = 'SwitchPayFee';
  public static readonly SwitchProductOverviewTitle = 'SwitchProductOverviewTitle';
  public static readonly SwitchProductPickerGetAdvice = 'SwitchProductPickerGetAdvice';
  public static readonly SwitchProductPickerGridFees = 'SwitchProductPickerGridFees';
  public static readonly SwitchProductPickerGridMaximumLTV = 'SwitchProductPickerGridMaximumLTV';
  public static readonly SwitchProductPickerGridMonthlyRepayments = 'SwitchProductPickerGridMonthlyRepayments';
  public static readonly SwitchProductPickerGridOverallCost = 'SwitchProductPickerGridOverallCost';
  public static readonly SwitchProductPickerGridStandardRate = 'SwitchProductPickerGridStandardRate';
  public static readonly SwitchProductPickerRepresentativeExampleResidential =
    'SwitchProductPickerRepresentativeExampleResidential';
  public static readonly SwitchProductPickerRepresentativeExampleResidentialTitle =
    'SwitchProductPickerRepresentativeExampleResidentialTitle';
  public static readonly SwitchProductPickerSkipAndRegister = 'SwitchProductPickerSkipAndRegister';
  public static readonly SwitchProductPickerUnsureOfProduct = 'SwitchProductPickerUnsureOfProduct';
  public static readonly SwitchProductPickerUnsureOfProductLoggedIn = 'SwitchProductPickerUnsureOfProductLoggedIn';
  public static readonly SwitchProductPickerAccordionAvailableTitle = 'SwitchProductPickerAccordionAvailableTitle';
  public static readonly SwitchProductPickerAccordionUnAvailableTitle = 'SwitchProductPickerAccordionUnAvailableTitle';
  public static readonly SwitchProductPickerAccordionAvailableBoxTitle =
    'SwitchProductPickerAccordionAvailableBoxTitle';
  public static readonly SwitchProductPickerAccordionAvailableBoxInfo = 'SwitchProductPickerAccordionAvailableBoxInfo';
  public static readonly SwitchProductPickerAccordionUnAvailableBoxTitle =
    'SwitchProductPickerAccordionUnAvailableBoxTitle';
  public static readonly SwitchProductPickerAccordionUnAvailableBoxInfo =
    'SwitchProductPickerAccordionUnAvailableBoxInfo';
  public static readonly SwitchRatePreferences = 'SwitchRatePreferences';
  public static readonly SwitchRateTitle = 'SwitchRateTitle';
  public static readonly SwitchReturnToRate = 'SwitchReturnToRate';
  public static readonly SwitchReviewOrder = 'SwitchReviewOrder';
  public static readonly SwitchReviewOrderDescription = 'SwitchReviewOrderDescription';
  public static readonly SwitchReviewOrderTitle = 'SwitchReviewOrderTitle';
  public static readonly SwitchingImportantDetailsModalTitle = 'SwitchingImportantDetailsModalTitle';
  public static readonly SwitchingImportantDetailsModalDescription = 'SwitchingImportantDetailsModalDescription';
  public static readonly SwitchStepInProgress = 'SwitchStepInProgress';
  public static readonly SwitchStepReady = 'SwitchStepReady';
  public static readonly SwitchStepOfferAcceptance = 'SwitchStepOfferAcceptance';
  public static readonly SwitchTransactionSwitchNotProceeding = 'SwitchTransactionSwitchNotProceeding';
  public static readonly SwitchTransactionSwitchNotProceedingDescription =
    'SwitchTransactionSwitchNotProceedingDescription';
  public static readonly SwitchTransactionOfferAccepted = 'SwitchTransactionOfferAccepted';
  public static readonly SwitchTransactionOfferAcceptedDescription = 'SwitchTransactionOfferAcceptedDescription';
  public static readonly SwitchTransactionOfferAcceptedDescriptionLink =
    'SwitchTransactionOfferAcceptedDescriptionLink';
  public static readonly SwitchTransactionSwitchReady = 'SwitchTransactionSwitchReady';
  public static readonly SwitchTransactionSwitchReadyDescription = 'SwitchTransactionSwitchReadyDescription';
  public static readonly SwitchTransactionSwitchInProgress = 'SwitchTransactionSwitchInProgress';
  public static readonly SwitchTransactionSwitchInProgressDescription = 'SwitchTransactionSwitchInProgressDescription';
  public static readonly SwitchTransactionSwitchOfferIssuedOnline = 'SwitchTransactionSwitchOfferIssuedOnline';
  public static readonly SwitchTransactionSwitchOfferIssuedOnlineDescription =
    'SwitchTransactionSwitchOfferIssuedOnlineDescription';
  public static readonly SwitchTransactionSwitchOfferIssuedPostal = 'SwitchTransactionSwitchOfferIssuedPostal';
  public static readonly SwitchTransactionSwitchOfferIssuedPostalDescription =
    'SwitchTransactionSwitchOfferIssuedPostalDescription';
  public static readonly SwitchTransactionSwitchOfferIssuedForcedPostal =
    'SwitchTransactionSwitchOfferIssuedForcedPostal';
  public static readonly SwitchTransactionSwitchOfferIssuedForcedPostalDescription =
    'SwitchTransactionSwitchOfferIssuedForcedPostalDescription';
  public static readonly SwitchTransactionStatus = 'SwitchTransactionStatus';
  public static readonly SwitchTransactionOfferExpired = 'SwitchTransactionOfferExpired';
  public static readonly SwitchTransactionOfferExpiredDescription = 'SwitchTransactionOfferExpiredDescription';
  public static readonly SystemUnavailableBody = 'SystemUnavailableBody';
  public static readonly SystemUnavailableHeader = 'SystemUnavailableHeader';
  public static readonly SwitchUnavailableInProgress = 'SwitchUnavailableInProgress';
  public static readonly SwitchUnavailableNotEligible = 'SwitchUnavailableNotEligible';
  public static readonly TabAdvice = 'TabAdvice';
  public static readonly TabFactFind2 = 'TabFactFind2';
  public static readonly TagFreeText = 'TagFreeText';
  public static readonly TakesEffectOn = 'TakesEffectOn';
  public static readonly TaskAllocatedTo = 'TaskAllocatedTo';
  public static readonly TaskAppliedTo = 'TaskAppliedTo';
  public static readonly TaskCreatedDate = 'TaskCreatedDate';
  public static readonly TaskDescription = 'TaskDescription';
  public static readonly TaskDescriptionModalTitle = 'TaskDescriptionModalTitle';
  public static readonly TaskDescriptionNotMandatory = 'TaskDescriptionNotMandatory';
  public static readonly TaskEditTitle = 'TaskEditTitle';
  public static readonly TaskHub = 'TaskHub';
  public static readonly TaskHubRecentActivity = 'TaskHubRecentActivity';
  public static readonly TaskHubSearchAllocatedTeamSort = 'TaskHubSearchAllocatedTeamSort';
  public static readonly TaskHubSearchAllocation = 'TaskHubSearchAllocation';
  public static readonly TaskHubSearchDateFrom = 'TaskHubSearchDateFrom';
  public static readonly TaskHubSearchDateGreaterThan = 'TaskHubSearchDateGreaterThan';
  public static readonly TaskHubSearchDateRange = 'TaskHubSearchDateRange';
  public static readonly TaskHubSearchDateTo = 'TaskHubSearchDateTo';
  public static readonly TaskHubSearchFilterByToday = 'TaskHubSearchFilterByToday';
  public static readonly TaskHubSearchPublishedDate = 'TaskHubSearchPublishedDate';
  public static readonly TaskHubSearchTaskName = 'TaskHubSearchTaskName';
  public static readonly TaskHubSearchTaskStatus = 'TaskHubSearchTaskStatus';
  public static readonly TaskHubSearchTaskType = 'TaskHubSearchTaskType';
  public static readonly TaskHubSortByAddedStaff = 'TaskHubSortByAddedStaff';
  public static readonly TaskHubSortByAllocatedStaff = 'TaskHubSortByAllocatedStaff';
  public static readonly TaskHubSortByApplicant = 'TaskHubSortByApplicant';
  public static readonly TaskHubSortByName = 'TaskHubSortByName';
  public static readonly TaskHubSortByStatus = 'TaskHubSortByStatus';
  public static readonly TaskLetterBackEditing = 'TaskLetterBackEditing';
  public static readonly TaskLetterDownload = 'TaskLetterDownload';
  public static readonly TaskLetterHeader = 'TaskLetterHeader';
  public static readonly TaskLetterPreview = 'TaskLetterPreview';
  public static readonly TaskLetterSaveAndDownload = 'TaskLetterSaveAndDownload';
  public static readonly TaskLetterTitle = 'TaskLetterTitle';
  public static readonly TaskName = 'TaskName';
  public static readonly TaskNotes = 'TaskNotes';
  public static readonly TaskSave = 'TaskSave';
  public static readonly TaskType = 'TaskType';
  public static readonly TasksGridHeaderAddedBy = 'TasksGridHeaderAddedBy';
  public static readonly TasksGridHeaderDateAdded = 'TasksGridHeaderDateAdded';
  public static readonly TasksGridHeaderAllocatedTo = 'TasksGridHeaderAllocatedTo';
  public static readonly TasksGridHeaderApplicant = 'TasksGridHeaderApplicant';
  public static readonly TasksGridHeaderCaseID = 'TasksGridHeaderCaseID';
  public static readonly TasksGridHeaderMortgageAccountNumber = 'TasksGridHeaderMortgageAccountNumber';
  public static readonly TasksGridHeaderCaseStatus = 'TasksGridHeaderCaseStatus';
  public static readonly TasksGridHeaderStatus = 'TasksGridHeaderStatus';
  public static readonly TasksGridHeaderTask = 'TasksGridHeaderTask';
  public static readonly TaxReferenceNumber = 'TaxReferenceNumber';
  public static readonly TaxYearInterest = 'TaxYearInterest';
  public static readonly Team = 'Team';
  public static readonly TeamName = 'TeamName';
  public static readonly Telephone = 'Telephone';
  public static readonly Term = 'Term';
  public static readonly TermChangeExtensionInformation = 'TermChangeExtensionInformation';
  public static readonly TermChangeExtensionInformationBTL = 'TermChangeExtensionInformationBTL';
  public static readonly TermChangeNotAvailableError = 'TermChangeNotAvailableError';
  public static readonly TermChangeOptionInformation = 'TermChangeOptionInformation';
  public static readonly TermChangeOptionTitle = 'TermChangeOptionTitle';
  public static readonly TermChangeReductionInformation = 'TermChangeReductionInformation';
  public static readonly TermChangeReductionInformationBTL = 'TermChangeReductionInformationBTL';
  public static readonly TermChangeReductionNotAllowedInformation = 'TermChangeReductionNotAllowedInformation';
  public static readonly TermChangeType = 'TermChangeType';
  public static readonly TermEndsOn = 'TermEndsOn';
  public static readonly TermExtensionAdditionalDataTitle = 'TermExtensionAdditionalDataTitle';
  public static readonly TermExtensionReason = 'TermExtensionReason';
  public static readonly TermExtensionReasonInformation = 'TermExtensionReasonInformation';
  public static readonly TermExtensionRetirementAge = 'TermExtensionRetirementAge';
  public static readonly TermExtensionRetirementAgeInformation = 'TermExtensionRetirementAgeInformation';
  public static readonly TermMonths = 'TermMonths';
  public static readonly TermReductionForbiddenOnInterestOnlyLabel = 'TermReductionForbiddenOnInterestOnlyLabel';
  public static readonly TermReductionInformation = 'TermReductionInformation';
  public static readonly TermYears = 'TermYears';
  public static readonly TermsAndConditions = 'TermsAndConditions';
  public static readonly TermsAndConditionsFilename = 'TermsAndConditionsFilename';
  public static readonly TermEstimationLabel = 'TermEstimationLabel';
  public static readonly TermEstimationTooltip = 'TermEstimationTooltip';
  public static readonly TermEstimationCurrentTerm = 'TermEstimationCurrentTerm';
  public static readonly TermEstimationNewTerm = 'TermEstimationNewTerm';
  public static readonly ThereIsAProblemWithTheInformatId = 'InvalidInformationEntered';
  public static readonly ThisSelectionHasBeenId = 'Selection type';
  public static readonly ThisStepContains = 'ThisStepContains';
  public static readonly Title = 'Title';
  public static readonly To = 'To';
  public static readonly ToAccessYourAccount = 'ToAccessYourAccount';
  public static readonly ToggleOfflineCase = 'ToggleOfflineCase';
  public static readonly TotalAmountToBorrowId = 'TotalAmoutToBorrow';
  public static readonly TotalAmoutToBorrow = 'TotalAmoutToBorrow';
  public static readonly TotalAnnualIncomePreviousYear = 'TotalAnnualIncomePreviousYear';
  public static readonly TotalAnnualIncomePreviousYearToolTip = 'TotalAnnualIncomePreviousYearToolTip';
  public static readonly TotalAnnualPrivatePension = 'TotalAnnualPrivatePension';
  public static readonly TotalBalanceOutstandingBtlMortgage = 'TotalBalanceOutstandingBtlMortgage';
  public static readonly TotalExpectedAnnualPension = 'TotalExpectedAnnualPension';
  public static readonly TotalIncome = 'TotalIncome';
  public static readonly TotalLoan = 'TotalLoan';
  public static readonly TotalLoanAmounts = 'TotalLoanAmounts';
  public static readonly TotalMonthlyPayment = 'TotalMonthlyPayment';
  public static readonly TotalMonthlyRentalIncomeBtl = 'TotalMonthlyRentalIncomeBtl';
  public static readonly TotalNormalMonthlyPayment = 'TotalNormalMonthlyPayment';
  public static readonly TotalNumberOfLocations = 'TotalNumberOfLocations';
  public static readonly TotalOutstandingBalance = 'TotalOutstandingBalance';
  public static readonly TotalProcurationFeePayable = 'TotalProcurationFeePayable';
  public static readonly TownOfBirthId = 'TownOfBirth';
  public static readonly TransUnionOutputPlaceholder = 'TransUnionOutputPlaceholder';
  public static readonly TransactUnavailableErrorMessage = 'TransactUnavailableErrorMessage';
  public static readonly TransactionStatus = 'TransactionStatus';
  public static readonly Transactions = 'Transactions';
  public static readonly TransactionsCaseId = 'TransactionsCaseId';
  public static readonly TransactionsInformation = 'TransactionsInformation';
  public static readonly TryUploadAgain = 'TryUploadAgain';
  public static readonly TurnOffChasingNotifications = 'TurnOffChasingNotifications';
  public static readonly TurnOffNotification = 'TurnOffNotification';
  public static readonly TurnOffPackagingNotifications = 'TurnOffPackagingNotifications';
  public static readonly TurningOffCaseNotificationsInfo = 'TurningOffCaseNotificationsInfo';
  public static readonly TurnTasksOff = 'TurnTasksOff';
  public static readonly TurnTasksOn = 'TurnTasksOn';
  public static readonly TypeOfEmploymentId = 'TypeOfEmployment';
  public static readonly TypeOfMortgage = 'TypeOfMortgage';
  public static readonly Unable = 'Unable';
  public static readonly UnableProceedStatement = 'UnableProceedStatement';
  public static readonly UnableProceedWithoutSolicitor = 'UnableProceedWithoutSolicitor';
  public static readonly UnableToLoadAccountInformationText = 'UnableToLoadAccountInformationText';
  public static readonly UnableToLoadAccountInformationTitle = 'UnableToLoadAccountInformationTitle';
  public static readonly UnableToLoadClosedMortgageDataTitle = 'UnableToLoadClosedMortgageDataTitle';
  public static readonly UnableToLoadMortgageDataText = 'UnableToLoadMortgageDataText';
  public static readonly UnableToLoadMortgageDataTitle = 'UnableToLoadMortgageDataTitle';
  public static readonly UnableToSupplyDocumentContent = 'UnableToSupplyDocumentContent';
  public static readonly UnlimitedAllowanceLabel = 'UnlimitedAllowanceLabel';
  public static readonly UnallocatedTask = 'UnallocatedTask';
  public static readonly UnderwriterInfoBox = 'UnderwriterInfoBox';
  public static readonly UnableToChangePasswordAgain = 'UnableToChangePasswordAgain';
  public static readonly UnlinkCase = 'UnlinkCase';
  public static readonly Unlock = 'Unlock';
  public static readonly UnlockAccount = 'UnlockAccount';
  public static readonly UnlockMortgageAccount = 'UnlockMortgageAccount';
  public static readonly UnpublishedPackagingItemsLozenge = 'UnpublishedPackagingItemsLozenge';
  public static readonly UnsupportedActionOnMobileDeviceText = 'UnsupportedActionOnMobileDeviceText';
  public static readonly UnsupportedActionOnMobileDeviceTitle = 'UnsupportedActionOnMobileDeviceTitle';
  public static readonly UnsupportedDevicePageDescription = 'UnsupportedDevicePageDescription';
  public static readonly UnsupportedDevicePageTitle = 'UnsupportedDevicePageTitle';
  public static readonly UnsuspendAccount = 'UnsuspendAccount';
  public static readonly UpdateBranchDetails = 'UpdateBranchDetails';
  public static readonly UpdateDetailsBtn = 'UpdateDetailsBtn';
  public static readonly UpdateEmailAddressDetails = 'UpdateEmailAddressDetails';
  public static readonly UpdateContactNumberDetails = 'UpdateContactNumberDetails';
  public static readonly UpdateEmailAddressTitle = 'UpdateEmailAddressTitle';
  public static readonly UpdateContactNumberTitle = 'UpdateContactNumberTitle';
  public static readonly UpdatingEmailAddress = 'UpdatingEmailAddress';
  public static readonly Upload = 'Upload';
  public static readonly UploadBranchesModal = 'UploadBranchesModal';
  public static readonly UploadDistributedDocument = 'UploadDistributedDocument';
  public static readonly UploadDocument = 'UploadDocument';
  public static readonly UploadDocumentMaxNumberReached = 'UploadDocumentMaxNumberReached';
  public static readonly UploadFiles = 'UploadFiles';
  public static readonly UploadModalDescription = 'UploadModalDescription';
  public static readonly UploadModalHeader = 'UploadModalHeader';
  public static readonly UploadMoreFiles = 'UploadMoreFiles';
  public static readonly UploadMortgage = 'UploadMortgage';
  public static readonly Uploaded = 'Uploaded';
  public static readonly UploadedDocuments = 'UploadedDocuments';
  public static readonly UploadedOn = 'UploadedOn';
  public static readonly Uploading = 'Uploading';
  public static readonly UsefulInformationId = 'UsefulInformationId';
  public static readonly User = 'User';
  public static readonly UserAccountActivationFailed = 'UserAccountActivationFailed';
  public static readonly UserAccountConfirmLogin = 'UserAccountConfirmLogin';
  public static readonly UserContactNumber = 'UserContactNumber';
  public static readonly UserEmailUpdateConfirmationContactLine1 = 'UserEmailUpdateConfirmationContactLine1';
  public static readonly UserEmailUpdateConfirmationContactLine2 = 'UserEmailUpdateConfirmationContactLine2';
  public static readonly UserEmailUpdateConfirmationDetails = 'UserEmailUpdateConfirmationDetails';
  public static readonly UserEmailUpdateConfirmationFollowInstructions =
    'UserEmailUpdateConfirmationFollowInstructions';
  public static readonly UserEmailUpdateConfirmationNeedResend = 'UserEmailUpdateConfirmationNeedResend';
  public static readonly UserEmailUpdateConfirmationResentEmail = 'UserEmailUpdateConfirmationResentEmail';
  public static readonly UserEmailUpdateConfirmationSentEmail = 'UserEmailUpdateConfirmationSentEmail';
  public static readonly UserExpireUnits = 'UserExpireUnits';
  public static readonly UserFullName = 'UserFullName';
  public static readonly UserId = 'UserId';
  public static readonly UserIncorrectLoginCombination = 'UserIncorrectLoginCombination';
  public static readonly UserManagement = 'UserManagement';
  public static readonly UserManagementTitle = 'UserManagementTitle';
  public static readonly UserNotificationError = 'UserNotificationError';
  public static readonly UserPasswordReset = 'UserPasswordReset';
  public static readonly UserProfileHelpText = 'UserProfileHelpText';
  public static readonly UserProfileLoginDetailsConfirmationPending = 'UserProfileLoginDetailsConfirmationPending';
  public static readonly UserProfileNeedHelp = 'UserProfileNeedHelp';
  public static readonly UserProposition = 'UserProposition';
  public static readonly UserRegistrationFailed = 'UserRegistrationFailed';
  public static readonly UserRegistrationFooterLine1 = 'UserRegistrationFooterLine1';
  public static readonly UserRegistrationFooterLine2 = 'UserRegistrationFooterLine2';
  public static readonly UserRegistrationNotificationContactLine1 = 'UserRegistrationNotificationContactLine1';
  public static readonly UserRegistrationNotificationContactLine2 = 'UserRegistrationNotificationContactLine2';
  public static readonly UserRegistrationNotificationDetails = 'UserRegistrationNotificationDetails';
  public static readonly UserRegistrationNotificationFollowInstructions =
    'UserRegistrationNotificationFollowInstructions';
  public static readonly UserRegistrationNotificationNeedResend = 'UserRegistrationNotificationNeedResend';
  public static readonly UserRegistrationNotificationResentEmail = 'UserRegistrationNotificationResentEmail';
  public static readonly UserRegistrationNotificationSentEmail = 'UserRegistrationNotificationSentEmail';
  public static readonly UserRegistrationWithoutPasswordNotificationSentEmail =
    'UserRegistrationWithoutPasswordNotificationSentEmail';
  public static readonly UserResetPasswordDescription = 'UserResetPasswordDescription';
  public static readonly UserResetPasswordNew = 'UserResetPasswordNew';
  public static readonly UserResetPasswordOld = 'UserResetPasswordOld';
  public static readonly UserResetPasswordRepeatNew = 'UserResetPasswordRepeatNew';
  public static readonly UserResetPasswordSave = 'UserResetPasswordSave';
  public static readonly UserResetPasswordSuccessMessage = 'UserResetPasswordSuccessMessage';
  public static readonly UserResetPasswordTitle = 'UserResetPasswordTitle';
  public static readonly CustomerVerificationNewPasswordSave = 'CustomerVerificationNewPasswordSave';
  public static readonly UserSearchShowOnlyLockedAccounts = 'UserSearchShowOnlyLockedAccounts';
  public static readonly UserSearchShowOnlyRejectedAccounts = 'UserSearchShowOnlyRejectedAccounts';
  public static readonly UserSecurityQuestionsDescription = 'UserSecurityQuestionsDescription';
  public static readonly UserSessionClosedDescription = 'UserSessionClosedDescription';
  public static readonly UserSessionClosedTitle = 'UserSessionClosedTitle';
  public static readonly UserSuspendAccount = 'UserSuspendAccount';
  public static readonly Username = 'Username';
  public static readonly UsingOfSystem = 'UsingOfSystem';
  public static readonly VOAffordabilityLink = 'VOAffordabilityLink';
  public static readonly VOAffordabilityText = 'VOAffordabilityText';
  public static readonly VOBtnProduct = 'VOBtnProduct';
  public static readonly VOClickHere = 'VOClickHere';
  public static readonly VOLiteratureLink = 'VOLiteratureLink';
  public static readonly VOLiteratureText = 'VOLiteratureText';
  public static readonly VONotificationMsg = 'VONotificationMsg';
  public static readonly VONotificationMsgWindowTitle = 'VONotificationMsgWindowTitle';
  public static readonly VOProducts = 'VOProducts';
  public static readonly VOProductsLink = 'VOProductsLink';
  public static readonly VOProductsText = 'VOProductsText';
  public static readonly ValidUntil = 'ValidUntil';
  public static readonly ValidateExistingCustomer = 'ValidateExistingCustomer';
  public static readonly ValidateExistingCustomerTitle = 'ValidateExistingCustomerTitle';
  public static readonly ValidateNewPassword = 'ValidateNewPassword';
  public static readonly ValidatePhoneNumber = 'ValidatePhoneNumber';
  public static readonly ValidatePhoneNumberTitle = 'ValidatePhoneNumberTitle';
  public static readonly ValidationFailedOnSave = 'ValidatioFailedOnSave';
  public static readonly Valuation = 'Valuation';
  public static readonly ValuationCompanyNameId = 'ValuationCompanyName';
  public static readonly ValuationCompletedValueId = 'ValuationCompletedValue';
  public static readonly ValuationFeeAmountId = 'ValuationFeeAmount';
  public static readonly ValuationFeeId = 'ValuationFee';
  public static readonly ValuationReportPayerTypeId = 'ValuationReportPayerType';
  public static readonly ValuationReportTypeId = 'ValuationReportType';
  public static readonly Value = 'Value';
  public static readonly ValueDecreasedBy = 'ValueDecreasedBy';
  public static readonly ValueGreaterThan = 'ValueGreaterThan';
  public static readonly ValueIncrease = 'ValueIncrease';
  public static readonly ValueIncreasedBy = 'ValueIncreasedBy';
  public static readonly ValueIncreasedError = 'ValueIncreasedError';
  public static readonly VendorDetailsHeader = 'VendorDetailsHeader';
  public static readonly VendorName = 'VendorName';
  public static readonly VendorTelephoneNumber = 'VendorTelephoneNumber';
  public static readonly VerificationCodeEnterInputLabel = 'VerificationCodeEnterInputLabel';
  public static readonly VerificationCodeHasExceededMaximumAttemptsContactBank =
    'VerificationCodeHasExceededMaximumAttemptsContactBank';
  public static readonly VerificationCodeHasExceededMaximumAttemptsRestartFlow =
    'VerificationCodeHasExceededMaximumAttemptsRestartFlow';
  public static readonly VerificationCodeHasExceededMaximumOtpSendLimit =
    'VerificationCodeHasExceededMaximumOtpSendLimit';
  public static readonly VerificationCodeHasExceededMaximumOtpValidation =
    'VerificationCodeHasExceededMaximumOtpValidation';
  public static readonly VerificationCodeHasExpired = 'VerificationCodeHasExpired';
  public static readonly VerificationCodeInfoSend = 'VerificationCodeInfoSend';
  public static readonly VerificationCodeInfoSent = 'VerificationCodeInfoSent';
  public static readonly VerificationCodeInvalidOtpInfo = 'VerificationCodeInvalidOtpInfo';
  public static readonly VerificationCodeReSendButton = 'VerificationCodeReSendButton';
  public static readonly VerificationCodeSendButton = 'VerificationCodeSendButton';
  public static readonly VerificationCodeTitle = 'VerificationCodeTitle';
  public static readonly VerificationCodeDetails = 'VerificationCodeDetails';
  public static readonly VerifyApplicantsDetails = 'VerifyApplicantsDetails';
  public static readonly PasswordChangeResendVerificationCodeDetails = 'PasswordChangeResendVerificationCodeDetails';
  public static readonly PasswordChangeVerificationCodeDetails = 'PasswordChangeVerificationCodeDetails';
  public static readonly PasswordChangeVerificationCodeTitle = 'PasswordChangeVerificationCodeTitle';
  public static readonly ResendVerificationCodeDetails = 'ResendVerificationCodeDetails';
  public static readonly ViaMortgageClub = 'ViaMortgageClub';
  public static readonly ViewAIPCertificateTitle = 'ViewAIPCertificateTitle';
  public static readonly ViewAdviceNotes = 'ViewAdviceNotes';
  public static readonly ViewAffordabilityResults = 'ViewAffordabilityResults';
  public static readonly ViewAipBundle = 'ViewAipBundle';
  public static readonly ViewAllUploadedDocuments = 'ViewAllUploadedDocuments';
  public static readonly ViewAndAddAdviceNotes = 'ViewAndAddAdviceNotes';
  public static readonly ViewApplicationBundle = 'ViewApplicationBundle';
  public static readonly ViewAssociatedCases = 'ViewAssociatedCases';
  public static readonly ViewAssociatedCompanies = 'ViewAssociatedCompanies';
  public static readonly ViewAudit = 'ViewAudit';
  public static readonly ViewBranchDetails = 'ViewBranchDetails';
  public static readonly ViewCallHistory = 'ViewCallHistory';
  public static readonly ViewCreditScoreResults = 'ViewCreditScoreResults';
  public static readonly ViewFactFind = 'ViewFactFind';
  public static readonly ViewIllustrationBundle = 'ViewIllustrationBundle';
  public static readonly ViewIncompleteFactFind1 = 'ViewIncompleteFactFind1';
  public static readonly ViewKfi = 'ViewKfi';
  public static readonly ViewKycData = 'ViewKycData';
  public static readonly ViewMortgageAccountOverview = 'ViewMortgageAccountOverview';
  public static readonly ViewMortgageOfferBundle = 'ViewMortgageOfferBundle';
  public static readonly ViewOfferAuthenticationDescription = 'ViewOfferAuthenticationDescription';
  public static readonly ViewOfferAuthenticationHeader = 'ViewOfferAuthenticationHeader';
  public static readonly ViewOfferAuthenticationPasscode = 'ViewOfferAuthenticationPasscode';
  public static readonly ViewOfferSendSmsDescription = 'ViewOfferSendSmsDescription';
  public static readonly ViewOfferSendSmsHeader = 'ViewOfferSendSmsHeader';
  public static readonly ViewPaymentDetailsTitle = 'ViewPaymentDetailsTitle';
  public static readonly ViewPaymentsTitle = 'ViewPaymentsTitle';
  public static readonly ViewReadOnlyApplication = 'ViewReadOnlyApplication';
  public static readonly ViewRecommendation = 'ViewRecommendation';
  public static readonly ViewRejectionReason = 'ViewRejectionReason';
  public static readonly ViewResult = 'ViewResult';
  public static readonly ViewResponseButton = 'ViewResponseButton';
  public static readonly ViewSuitabilityReport = 'ViewSuitabilityReport';
  public static readonly VirtualOfficeBtnAIP = 'VOBtnAIP';
  public static readonly VirtualOfficeBtnAPP = 'VOBtnAPP';
  public static readonly VirtualOfficeBtnAdvice = 'VOBtnAdvice';
  public static readonly VirtualOfficeBtnCaseSummary = 'VOBtnCaseSummary';
  public static readonly VirtualOfficeBtnKFI = 'VOBtnKFI';
  public static readonly VirtualOfficeCaseOwnerTitle = 'VOCaseOwnerTitle';
  public static readonly VirtualOfficeColAccountNumber = 'VOColAccountNumber';
  public static readonly VirtualOfficeColAlerts = 'VOColAlerts';
  public static readonly VirtualOfficeColBusinessWriter = 'VOColBusinessWriter';
  public static readonly VirtualOfficeColCaseID = 'VOColCaseID';
  public static readonly VirtualOfficeColLeadName = 'VOColLeadName';
  public static readonly VirtualOfficeColStatus = 'VOColStatus';
  public static readonly VirtualOfficeConfirmBtnCopyCase = 'VOConfirmBtnCopyCase';
  public static readonly VirtualOfficeOptShowOnlyBusinessWriterCases = 'VOOptShowOnlyBusinessWriterCases';
  public static readonly VirtualOfficeOptShowOnlyCaseAdministratorCases = 'VOOptShowOnlyCaseAdministratorCases';
  public static readonly VomoContactDetailsForCustomer = 'VomoContactDetailsForCustomer';
  public static readonly VomoEmailAddress = 'VomoEmailAddress';
  public static readonly VomoIssueType = 'VomoIssueType';
  public static readonly VomoIssueByPostDescription = 'VomoIssueByPostDescription';
  public static readonly VomoMobileNumber = 'VomoMobileNumber';
  public static readonly VomoPreferencesDescription = 'VomoPreferencesDescription';
  public static readonly VomoPreferencesTitle = 'VomoPreferencesTitle';
  public static readonly VomoReceived = 'VomoReceived';
  public static readonly Warning = 'Warning';
  public static readonly WarningContent = 'WarningContent';
  public static readonly WarningForPrePopulatedItems = 'WarningForPrePopulatedItems';
  public static readonly WarningUntilUserExpire = 'WarningUntilUserExpire';
  public static readonly Welcome = 'Welcome';
  public static readonly WereApplicantsInterviewed = 'WereApplicantsFaceToFaceInterviewed';
  public static readonly WereYouKnownByAnyOtherSurnamesId = 'AnyOtherSurnames';
  public static readonly WhatAreTheDetailsOfTheChange = 'WhatAreTheDetailsOfTheChange';
  public static readonly WhatAreTheirDatesOfBirthId = 'DependentsDatesOfBirth';
  public static readonly WhatFloorIsTheFlatOn = 'WhatFloorIsTheFlatOn';
  public static readonly WhatImpactWillThisHaveOnYourInId = 'ImpactOnIncome';
  public static readonly WhatIsTheEstimatedValueOfProp = 'WhatIsTheEstimatedValueOfProp';
  public static readonly WhatIsTheNatureOfTheBusinessId = 'NatureOfBusiness';
  public static readonly WhatIsTheRemainingLeasePeriod = 'WhatIsTheRemainingLeasePeriod';
  public static readonly WhatIsTheTenure = 'WhatIsTheTenure';
  public static readonly WhatIsTheTrueMarketValueOfThePId = 'PropertyMarketValue';
  public static readonly WhatIsTheorPriceOfTheProId = 'PropertyPurchasePrice';
  public static readonly WhatIsYourCurrentAddressId = 'CurrentAddress';
  public static readonly WhatIsYourIntendedRetirementAgId = 'IntendedRetirementAge';
  public static readonly WhatIsYourPreviousAddressId = 'PreviousAddress';
  public static readonly WhatIsYourRelationshipToTheVen = 'WhatIsYourRelationshipToTheVen';
  public static readonly WhatIsYourTotalAnnualPensionInId = 'TotalExpectedAnnualPension';
  public static readonly WhatTheyOwe = 'WhatTheyOwe';
  public static readonly WhatTypeOfPropertyIsIt = 'WhatTypeOfPropertyIsIt';
  public static readonly WhatWasYourEarnedGrossIncomeFoId = 'TotalAnnualIncomePreviousYear';
  public static readonly WhenToSwitch = 'WhenToSwitch';
  public static readonly WhenToSwitchDescription = 'WhenToSwitchDescription';
  public static readonly WhenToSwitchInput = 'WhenToSwitchInput';
  public static readonly WhenWasThePropertyConstructed = 'WhenWasThePropertyConstructed';
  public static readonly WhereDidUserHearAboutProduct = 'WhereDidUserHearAboutProduct';
  public static readonly WhereIsThePropertyYouAreMortgaId = 'PropertyLocation';
  public static readonly WhereShouldFutureCorrespondencId = 'FutureCorrespondence';
  public static readonly WhichApplicantIsOffered = 'WhichApplicantIsOffered';
  public static readonly WhoIsPrimarilyResponsible = 'WhoIsPrimarilyResponsible';
  public static readonly WhoIsYourLenderId = 'WhoLender';
  public static readonly WhoLender = 'WhoLender';
  public static readonly WhoShouldWeContactToInstructTh = 'WhoShouldWeContactToInstructTh';
  public static readonly WhoWasTheLender = 'WhoWasTheLender';
  public static readonly WillMortgageBeRedeemed = 'WillMortgageBeRedeemed';
  public static readonly WillThePropertyUsedForBusiness = 'WillThePropertyUsedForBusiness';
  public static readonly WillThereBeAnyExistingTenants = 'WillThereBeAnyExistingTenants';
  public static readonly WillYouHoldAnyBuyToLetMortgageId = 'HoldAnyBTL';
  public static readonly WillYouHoldAnyOtherNonBuyToLetId = 'HoldAnyNonBTL';
  public static readonly WillYouReceiveAnyDiscounts = 'WillYouReceiveAnyDiscounts';
  public static readonly WithdrawnProductWarningContent = 'WithdrawnProductWarningContent';
  public static readonly WithdrawnProductWarningTitle = 'WithdrawnProductWarningTitle';
  public static readonly WorkPhoneNumberId = 'WorkPhoneNumber';
  public static readonly WorldPayNumber = 'WorldPayNumber';
  public static readonly WorldpayDisabledText = 'WorldpayDisabledText';
  public static readonly WouldYouLikeAQuoteFromOurLegal = 'WouldYouLikeAQuoteFromOurLegal';
  public static readonly WritingBusiness = 'WritingBusiness';
  public static readonly WrongAnswer = 'WrongAnswer';
  public static readonly WrongAnswerLimitReached = 'WrongAnswerLimitReached';
  public static readonly YearEnding1 = 'YearEnding1';
  public static readonly YearEnding2 = 'YearEnding2';
  public static readonly YearsId = 'Years';
  public static readonly Yes = 'Yes';
  public static readonly YouAreSwitchingTo = 'YouAreSwitchingTo';
  public static readonly YourContactDetails = 'YourContactDetails';
  public static readonly YourCurrentMortgageTitle = 'YourCurrentMortgageTitle';
  public static readonly YourHouseholdId = 'YourHousehold';
  public static readonly YourIncomeId = 'YourIncome';
  public static readonly YourMortgageId = 'YourMortgage';
  public static readonly YourMortgageWithBankOfIreland = 'YourMortgageWithBankOfIreland';
  public static readonly YourOutgoings = 'YourOutgoings';
  public static readonly YourProperties = 'YourProperties';
  public static readonly YourProperty = 'YourProperty';
  public static readonly YourResultSubtitle = 'YourResultSubtitle';
  public static readonly YrTerm = 'YrTerm';
  public static readonly Yrs = 'Yrs';
  public static readonly Zoom = 'Zoom';
}
